
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("KcDWk", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $dPJCf = parcelRequire("dPJCf");

const $0cb26f4daa528aad$var$RELEASE_UNUSED_DELAY_TIME = 10000; // 10 sec
const $0cb26f4daa528aad$var$ssredMacros = new Map();
const $0cb26f4daa528aad$var$usedMacros = new Set();
function $0cb26f4daa528aad$export$6e21e394d708bb62() {
    $0cb26f4daa528aad$var$ssredMacros.clear();
}
function $0cb26f4daa528aad$export$f700dfca474a9730() {
    setTimeout($0cb26f4daa528aad$var$releaseUnused, $0cb26f4daa528aad$var$RELEASE_UNUSED_DELAY_TIME);
}
function $0cb26f4daa528aad$var$releaseUnused() {
    for (const macroId of $0cb26f4daa528aad$var$ssredMacros.keys())if (!$0cb26f4daa528aad$var$usedMacros.has(macroId)) $0cb26f4daa528aad$var$ssredMacros.delete(macroId);
}
function $0cb26f4daa528aad$export$be7b16c53ead6686(macroId) {
    const $ = (0, $frIzR.c)(3);
    const transitionId = (0, $dPJCf.useTransitionId)();
    $0cb26f4daa528aad$var$usedMacros.add(macroId);
    let t0;
    if ($[0] !== macroId || $[1] !== transitionId) {
        t0 = !transitionId ? $0cb26f4daa528aad$var$ssredMacros.get(macroId) : undefined;
        $[0] = macroId;
        $[1] = transitionId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
function $0cb26f4daa528aad$export$e4c99b90ba7f5231(macroId) {
    if (!$0cb26f4daa528aad$var$ssredMacros.has(macroId)) {
        const ele = document.querySelector(`[data-fabric-macro="${macroId}"][data-skate-created]`);
        if (ele) $0cb26f4daa528aad$var$ssredMacros.set(macroId, ele);
    }
}
module.exports["releaseSSRedLegacyMacros"] = $0cb26f4daa528aad$export$6e21e394d708bb62;
module.exports["releaseUnusedSSRedLegacyMacrosWithDelay"] = $0cb26f4daa528aad$export$f700dfca474a9730;
module.exports["useSSRedLegacyMacroElement"] = $0cb26f4daa528aad$export$be7b16c53ead6686;
module.exports["collectSSRedLegacyMacro"] = $0cb26f4daa528aad$export$e4c99b90ba7f5231;

});

parcelRegister("eqB7W", function(module, exports) {
/**
 * @generated SignedSource<<8785cf6339753f2b7b161b1a80d02852>>
 * @relayHash 0338e1ad9a17b74a51ceb84d72bc7c61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e3efc04c3bd70f0dd085cb5ca373f071edfe850c1e5c8170567f9dc326950578
const $ea367f38360527c0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "adf"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "containedRender"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": "RENDERER",
            "kind": "LocalArgument",
            "name": "mode"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "adf",
                    "variableName": "adf"
                },
                {
                    "kind": "Variable",
                    "name": "containedRender",
                    "variableName": "containedRender"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "mode",
                    "variableName": "mode"
                }
            ],
            "concreteType": "MacroBody",
            "kind": "LinkedField",
            "name": "macroBodyRenderer",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "kind": "ScalarField",
                    "name": "representation"
                },
                {
                    "concreteType": "EmbeddedMediaToken",
                    "kind": "LinkedField",
                    "name": "mediaToken",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "token"
                        }
                    ]
                },
                {
                    "concreteType": "WebResourceDependencies",
                    "kind": "LinkedField",
                    "name": "webResourceDependencies",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contexts"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "keys"
                        },
                        {
                            "concreteType": "WebResourceTags",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "js"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "css"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LegacyMacroRendererQueryBodyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LegacyMacroRendererQueryBodyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0338e1ad9a17b74a51ceb84d72bc7c61",
            "id": "e3efc04c3bd70f0dd085cb5ca373f071edfe850c1e5c8170567f9dc326950578",
            "metadata": {},
            "name": "LegacyMacroRendererQueryBodyQuery",
            "operationKind": "query",
            "text": "query LegacyMacroRendererQueryBodyQuery($adf:String!,$containedRender:Boolean=false,$contentId:ID,$mode:ContentRendererMode=RENDERER)@allowHigherTimeout{macroBodyRenderer(adf:$adf,containedRender:$containedRender,contentId:$contentId,mode:$mode){value,representation,mediaToken{token},webResourceDependencies{contexts,keys,tags{js,css}}}}"
        }
    };
}();
$ea367f38360527c0$var$node.hash = "dd7355924ba42269bd10c6f111b4c390";
var $ea367f38360527c0$export$2e2bcd8739ae039 = $ea367f38360527c0$var$node;
module.exports["default"] = $ea367f38360527c0$export$2e2bcd8739ae039;

});

parcelRegister("b1ypt", function(module, exports) {
/**
 * @generated SignedSource<<58115bf3210cc40e16dd28de52b53840>>
 * @relayHash 7c8c189489482af15da56d7272f26902
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 86a2842e0d619c071cdb54f54bfddd7fbf88609a4d8bb58a0e80aca743392a64
const $dc795461fa782a5a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "adf"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "containedRender"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": "RENDERER",
            "kind": "LocalArgument",
            "name": "mode"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "adf",
                    "variableName": "adf"
                },
                {
                    "kind": "Variable",
                    "name": "containedRender",
                    "variableName": "containedRender"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "mode",
                    "variableName": "mode"
                }
            ],
            "concreteType": "HtmlDocument",
            "kind": "LinkedField",
            "name": "contentRenderer",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "concreteType": "WebResourceDependencies",
                    "kind": "LinkedField",
                    "name": "webResourceDependencies",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contexts"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "keys"
                        },
                        {
                            "concreteType": "WebResourceTags",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "js"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "css"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LegacyMacroRendererQueryContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LegacyMacroRendererQueryContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7c8c189489482af15da56d7272f26902",
            "id": "86a2842e0d619c071cdb54f54bfddd7fbf88609a4d8bb58a0e80aca743392a64",
            "metadata": {},
            "name": "LegacyMacroRendererQueryContentQuery",
            "operationKind": "query",
            "text": "query LegacyMacroRendererQueryContentQuery($adf:String!,$containedRender:Boolean=false,$contentId:ID!,$mode:ContentRendererMode=RENDERER){contentRenderer(adf:$adf,containedRender:$containedRender,contentId:$contentId,mode:$mode){html,webResourceDependencies{contexts,keys,tags{js,css}}}}"
        }
    };
}();
$dc795461fa782a5a$var$node.hash = "83bbd0a93f53839a47ac4b3d948ad643";
var $dc795461fa782a5a$export$2e2bcd8739ae039 = $dc795461fa782a5a$var$node;
module.exports["default"] = $dc795461fa782a5a$export$2e2bcd8739ae039;

});

parcelRegister("ld6xp", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


var $6mKj3 = parcelRequire("6mKj3");

function $1a525e6db77527ad$export$93a875f36a027067() {
    let blocklist = (0, $4VJDS.default).getStringList('confluence_frontend_macros_query_blocklist', [
        'include',
        'jirachart',
        'jiraroadmap',
        'ui-button',
        'contentbylabel',
        'excerpt-include',
        'tasks-report-macro',
        'blog-posts',
        'section',
        'table-filter',
        'children',
        'pagetree',
        'detailssummary',
        'decisionreport'
    ]);
    if ((0, $6mKj3.expVal)('confluence_frontend_ssr_include_macro_exp', 'isEnabled', false)) blocklist = blocklist.filter((macro)=>macro !== 'include');
    return String(blocklist).split(',');
}
function $1a525e6db77527ad$export$32e19dd05a214cc0(extensionKey, isNested2pBodiedExtension = false) {
    return !isNested2pBodiedExtension && !$1a525e6db77527ad$export$93a875f36a027067().includes(extensionKey || '');
}
module.exports["getMultiMacroQueryBlocklistFF"] = $1a525e6db77527ad$export$93a875f36a027067;
module.exports["canUseMultiMacroQuery"] = $1a525e6db77527ad$export$32e19dd05a214cc0;

});

parcelRegister("92uc5", function(module, exports) {

var $gHCIk = parcelRequire("gHCIk");

const $0aecfdd3c11bee35$export$e4b2a3005b630bc8 = ({ content: content, contentId: contentId })=>{
    const contentValue = content || [];
    const contentDocument = {
        type: 'doc',
        content: Array.isArray(contentValue) ? contentValue : [
            contentValue
        ],
        version: 1
    };
    const contentDocumentAdf = (0, $gHCIk.serializeExtensionADF)(contentDocument);
    return {
        content: contentDocumentAdf,
        from: 'atlas_doc_format',
        to: 'storage',
        contentId: contentId
    };
};
module.exports["getContentConverterVariables"] = $0aecfdd3c11bee35$export$e4b2a3005b630bc8;

});

parcelRegister("8mIlz", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


var $6mEZ3 = parcelRequire("6mEZ3");


var $gHCIk = parcelRequire("gHCIk");

const $c41a024b478ea6bf$var$getContentId = (adf, contentId)=>{
    const parentId = adf?.attrs?.parameters?.macroParams?._parentId?.value;
    return parentId || contentId;
};
const $c41a024b478ea6bf$export$99dbcdf31bb91f29 = ({ adf: adf, node: node, mode: mode = 'RENDERER', contentId: contentId })=>{
    const extensionADF = adf || (0, $6mEZ3.extensionToADF)(node);
    const isMacroContentAndBody = (0, $4VJDS.default).getBoolean('confluence_frontend_macro_adf_frontend_render', true);
    return {
        adf: (0, $gHCIk.serializeExtensionADF)(extensionADF),
        mode: mode.toUpperCase(),
        contentId: isMacroContentAndBody ? $c41a024b478ea6bf$var$getContentId(extensionADF, contentId) : contentId,
        isMacroContentAndBody: isMacroContentAndBody
    };
};
module.exports["getMacroQueryVariables"] = $c41a024b478ea6bf$export$99dbcdf31bb91f29;

});

parcelRegister("6Cce7", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $266b70085156c92e$export$ef5feff44649e0e4 = (0, $eSUdr.default)`query ContentConverterQuery($content:String!$contentId:ID!$from:String!$to:String!$spaceKeyContext:String=""){contentConverter(from:$from to:$to content:$content contentIdContext:$contentId spaceKeyContext:$spaceKeyContext){value}}`;
module.exports["ContentConverterQuery"] = $266b70085156c92e$export$ef5feff44649e0e4;

});

parcelRegister("2aGhQ", function(module, exports) {
/**
 * @generated SignedSource<<f5671f5d7d0407fbc821692a547020d1>>
 * @relayHash 584eeb631668d23b8ce4c3a29c749dba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4196b100b8db9b0ae7d8f1871949cbfc381146b4a3a957518c8bac7c4b59c77
const $dc9c06a2dbe8ab9b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blocklist"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": "RENDERER",
        "kind": "LocalArgument",
        "name": "mode"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "refetchToken"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ], v7 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "blocklist",
                    "variableName": "blocklist"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "refetchToken",
                    "variableName": "refetchToken"
                }
            ],
            "concreteType": "MacroConnection",
            "kind": "LinkedField",
            "name": "macros",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfoV2",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                },
                {
                    "concreteType": "Macro",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "macroId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "mode",
                                    "variableName": "mode"
                                }
                            ],
                            "concreteType": "RenderedMacro",
                            "kind": "LinkedField",
                            "name": "renderedMacro",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "macroRenderedRepresentation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "macroBodyStorage"
                                },
                                {
                                    "concreteType": "WebResourceDependenciesV2",
                                    "kind": "LinkedField",
                                    "name": "webResource",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "contexts"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "keys"
                                        },
                                        {
                                            "concreteType": "SuperBatchWebResourcesV2",
                                            "kind": "LinkedField",
                                            "name": "superbatch",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "metatags"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "WebResourceTagsV2",
                                            "kind": "LinkedField",
                                            "name": "tags",
                                            "plural": false,
                                            "selections": v6 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "WebResourceUrisV2",
                                            "kind": "LinkedField",
                                            "name": "uris",
                                            "plural": false,
                                            "selections": v6 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "EmbeddedMediaTokenV2",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "multiMacroQueryQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "multiMacroQueryQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "584eeb631668d23b8ce4c3a29c749dba",
            "id": "c4196b100b8db9b0ae7d8f1871949cbfc381146b4a3a957518c8bac7c4b59c77",
            "metadata": {},
            "name": "multiMacroQueryQuery",
            "operationKind": "query",
            "text": "query multiMacroQueryQuery($contentId:ID!,$mode:MacroRendererMode=RENDERER,$blocklist:[String!],$first:Int,$after:String,$refetchToken:String)@allowHigherTimeout{macros(contentId:$contentId,blocklist:$blocklist,first:$first,after:$after,refetchToken:$refetchToken){pageInfo{hasNextPage,endCursor},nodes{macroId,contentId,renderedMacro(mode:$mode){value,macroRenderedRepresentation,macroBodyStorage,webResource{contexts,keys,superbatch{metatags},tags{css,data,js},uris{css,data,js}},mediaToken{token}}}}}"
        }
    };
}();
$dc9c06a2dbe8ab9b$var$node.hash = "5967875eb6ab4194db64d8e7a4b9d76a";
var $dc9c06a2dbe8ab9b$export$2e2bcd8739ae039 = $dc9c06a2dbe8ab9b$var$node;
module.exports["default"] = $dc9c06a2dbe8ab9b$export$2e2bcd8739ae039;

});

parcelRegister("gK2Sc", function(module, exports) {
/**
 * @generated SignedSource<<3cc6a2dd9c6ecf0ec23186c4b6555996>>
 * @relayHash 9ee29c27577e5a660c9549df9e265024
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5366a5521b978a9252e0dd41fe636da5fea364b21a6441ec715c491444e20acf
const $f52a228c3dcb9a85$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blocklist"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": "RENDERER",
        "kind": "LocalArgument",
        "name": "mode"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "refetchToken"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ], v7 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "blocklist",
                    "variableName": "blocklist"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "refetchToken",
                    "variableName": "refetchToken"
                }
            ],
            "concreteType": "MacroConnection",
            "kind": "LinkedField",
            "name": "macros",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfoV2",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                },
                {
                    "concreteType": "Macro",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "macroId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "mode",
                                    "variableName": "mode"
                                }
                            ],
                            "concreteType": "RenderedMacro",
                            "kind": "LinkedField",
                            "name": "renderedMacro",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "macroRenderedRepresentation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "macroBodyStorage"
                                },
                                {
                                    "concreteType": "WebResourceDependenciesV2",
                                    "kind": "LinkedField",
                                    "name": "webResource",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "contexts"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "keys"
                                        },
                                        {
                                            "concreteType": "SuperBatchWebResourcesV2",
                                            "kind": "LinkedField",
                                            "name": "superbatch",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "metatags"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "WebResourceTagsV2",
                                            "kind": "LinkedField",
                                            "name": "tags",
                                            "plural": false,
                                            "selections": v6 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "WebResourceUrisV2",
                                            "kind": "LinkedField",
                                            "name": "uris",
                                            "plural": false,
                                            "selections": v6 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "EmbeddedMediaTokenV2",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "multiMacroQueryWithAppKeyQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "multiMacroQueryWithAppKeyQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "9ee29c27577e5a660c9549df9e265024",
            "id": "5366a5521b978a9252e0dd41fe636da5fea364b21a6441ec715c491444e20acf",
            "metadata": {},
            "name": "multiMacroQueryWithAppKeyQuery",
            "operationKind": "query",
            "text": "query multiMacroQueryWithAppKeyQuery($contentId:ID!,$mode:MacroRendererMode=RENDERER,$blocklist:[String!],$first:Int,$after:String,$refetchToken:String)@allowHigherTimeout{macros(contentId:$contentId,blocklist:$blocklist,first:$first,after:$after,refetchToken:$refetchToken){pageInfo{hasNextPage,endCursor},nodes{macroId,contentId,renderedMacro(mode:$mode){appKey,value,macroRenderedRepresentation,macroBodyStorage,webResource{contexts,keys,superbatch{metatags},tags{css,data,js},uris{css,data,js}},mediaToken{token}}}}}"
        }
    };
}();
$f52a228c3dcb9a85$var$node.hash = "35ff01947fb8029fb235327bf18368a3";
var $f52a228c3dcb9a85$export$2e2bcd8739ae039 = $f52a228c3dcb9a85$var$node;
module.exports["default"] = $f52a228c3dcb9a85$export$2e2bcd8739ae039;

});

parcelRegister("F4YLX", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $87886bfe56e46f2e$export$2e83ac12275e5b95 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jDbpB",
    name: "TourableRedactionExtensionLoader",
    loader: async ()=>(await (parcelRequire("4ejSJ"))).TourableRedactionExtension
});
module.exports["TourableRedactionExtensionLoader"] = $87886bfe56e46f2e$export$2e83ac12275e5b95;

});

parcelRegister("4ejSJ", function(module, exports) {

let $3147e45c794cc193$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3147e45c794cc193$var$load("jXx9i"),
    $3147e45c794cc193$var$load("5AfWB")
]).then(()=>parcelRequire('jubPE'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("fuLIO", function(module, exports) {

var $422HI = parcelRequire("422HI");


var $a4TK8 = parcelRequire("a4TK8");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $bavCP = parcelRequire("bavCP");


var $gtD4K = parcelRequire("gtD4K");


var $iXCQx = parcelRequire("iXCQx");


var $4VJDS = parcelRequire("4VJDS");


var $eczvQ = parcelRequire("eczvQ");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $6mEZ3 = parcelRequire("6mEZ3");


var $8pcS0 = parcelRequire("8pcS0");


var $kRAnY = parcelRequire("kRAnY");


var $ld6xp = parcelRequire("ld6xp");


var $iKSlH = parcelRequire("iKSlH");


var $gHCIk = parcelRequire("gHCIk");


var $92uc5 = parcelRequire("92uc5");


var $6Cce7 = parcelRequire("6Cce7");


var $eqB7W = parcelRequire("eqB7W");


var $b1ypt = parcelRequire("b1ypt");


var $hp2SH = parcelRequire("hp2SH");


var $7W8i8 = parcelRequire("7W8i8");


var $5kjCz = parcelRequire("5kjCz");

// Code taken from https://github.com/podefr/react-debounce-render/tree/master aka react-debounce-render package
// In order to prevent a new package from being added to the AFM project, the code was copied and pasted here since it is lightweight.




var $jSnXV = parcelRequire("jSnXV");


var $56GFp = parcelRequire("56GFp");

const $3dbf040db5bfac2c$export$437fb41b7a687949 = (ComponentToDebounce, wait, debounceArgs)=>{
    class DebouncedContainer extends (0, $42omo.Component) {
        shouldComponentUpdate() {
            this.updateDebounced();
            return false;
        }
        componentWillUnmount() {
            this.updateDebounced.cancel();
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentToDebounce, this.props);
        }
        constructor(...args){
            super(...args);
            // eslint-disable-next-line react/sort-comp
            this.updateDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(this.forceUpdate, wait, debounceArgs);
        }
    }
    DebouncedContainer.displayName = `debounceRender(${ComponentToDebounce.displayName || ComponentToDebounce.name || 'Component'})`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))(DebouncedContainer, ComponentToDebounce);
};



var $bQm3c = parcelRequire("bQm3c");


var $cbc8g = parcelRequire("cbc8g");


var $cgtv4 = parcelRequire("cgtv4");

const $71fb7e5ab8464496$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    highlightedPageIncludeRenderedError: {
        id: "fabric-extension-legacy-macro-renderer.legacy-macro-renderer-query.highlightedPageIncludeError",
        defaultMessage: "Unable to render { include }"
    },
    nonhighlightedPageIncludeRenderedError: {
        id: "fabric-extension-legacy-macro-renderer.legacy-macro-renderer-query.nonhighlightedPageIncludeRenderedError",
        defaultMessage: " Already included page \u201C{pageTitle}\u201D, stopping."
    }
});


/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 



var $inPa6 = parcelRequire("inPa6");


var $fwDOR = parcelRequire("fwDOR");


var $iRRvH = parcelRequire("iRRvH");

parcelRequire("dx8CK");
var $lEgye = parcelRequire("lEgye");





var $9wGTI = parcelRequire("9wGTI");


var $cpjd2 = parcelRequire("cpjd2");


var $brpfO = parcelRequire("brpfO");


var $hEeUR = parcelRequire("hEeUR");


var $989nU = parcelRequire("989nU");


var $KcDWk = parcelRequire("KcDWk");


var $bYtfC = parcelRequire("bYtfC");


var $iaRmR = parcelRequire("iaRmR");


var $6AplS = parcelRequire("6AplS");


var $hMRhJ = parcelRequire("hMRhJ");


var $5LTS4 = parcelRequire("5LTS4");


var $hHZWk = parcelRequire("hHZWk");








var $bX5uj = parcelRequire("bX5uj");


var $8eAX8 = parcelRequire("8eAX8");


var $fgbpl = parcelRequire("fgbpl");





var $3Btfb = parcelRequire("3Btfb");


var $giS6h = parcelRequire("giS6h");


var $8cOoD = parcelRequire("8cOoD");

/* eslint-disable no-console */ 


class $172ec9aa4291f34d$export$65a835712c7fb845 {
    static init(hostAPI, logger) {
        if (this.macroActions === null) {
            const getMacroId = (arg)=>{
                const macroId = arg?._context?.extension?.options?.productContext?.['macro.id'];
                if (!macroId) throw new Error('No macro ID found in the call.');
                return macroId;
            };
            const getEditorAction = (methodName, macroId)=>{
                const cachedMacro = this.macrosCache.get(macroId);
                if (typeof cachedMacro?.actions?.[methodName] !== 'function') throw new Error('Failed to execute this method. Please ensure that you are calling this method from within a multi-body extension inside your Connect application.');
                return cachedMacro.actions[methodName];
            };
            const assertNotReadonly = (macroId)=>{
                const cachedMacro = this.macrosCache.get(macroId);
                if (cachedMacro && cachedMacro.readonly) throw new Error('This method is not allowed in view mode');
                return true;
            };
            /**
       * Adding extra param to function ({returnPromise: true}) to let Connect know that
       * it returns Promise
       */ const prepareModuleFunction = (moduleFn)=>{
                return Object.assign(moduleFn, {
                    returnsPromise: true
                });
            };
            this.macroActions = {
                addBody: prepareModuleFunction((...args)=>{
                    try {
                        const context = args[args.length - 1];
                        const macroId = getMacroId(context);
                        assertNotReadonly(macroId);
                        const addChild = getEditorAction('addChild', macroId);
                        return Promise.resolve(addChild());
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                removeBody: prepareModuleFunction((...args)=>{
                    try {
                        if (args.length !== 2 || typeof args[0] !== 'number') throw new Error('The removeBody method expects an index number as its argument.');
                        const [index, context] = args;
                        const macroId = getMacroId(context);
                        assertNotReadonly(macroId);
                        const removeChild = getEditorAction('removeChild', macroId);
                        return Promise.resolve(removeChild(index));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                showBody: prepareModuleFunction((...args)=>{
                    try {
                        if (args.length !== 2 || typeof args[0]?.body !== 'number' || typeof args[0]?.frame !== 'number') throw new Error('The showBody method expects an object with body and frame properties as its argument.');
                        const [indexes, context] = args;
                        const macroId = getMacroId(context);
                        const changeActive = getEditorAction('changeActive', macroId);
                        return Promise.resolve(changeActive(indexes.body));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                getBodyCount: prepareModuleFunction((...args)=>{
                    try {
                        const context = args[args.length - 1];
                        const macroId = getMacroId(context);
                        const getChildrenCount = getEditorAction('getChildrenCount', macroId);
                        return Promise.resolve(getChildrenCount());
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                getParameters: prepareModuleFunction((...args)=>{
                    try {
                        const context = args[args.length - 1];
                        const macroId = getMacroId(context);
                        const cachedMacro = this.macrosCache.get(macroId);
                        if (!cachedMacro) throw new Error('Failed to execute this method. Please ensure that you are calling this method from within a multi-body extension inside your Connect application.');
                        return Promise.resolve(JSON.parse(cachedMacro.parameters));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                updateParameters: prepareModuleFunction((...args)=>{
                    try {
                        if (args.length !== 2 || !args[0] || typeof args[0] !== 'object') throw new Error('The updateParameters method expects an object with macro parameters as its argument.');
                        const [parameters, context] = args;
                        const macroId = getMacroId(context);
                        assertNotReadonly(macroId);
                        const updateParameters = getEditorAction('updateParameters', macroId);
                        return Promise.resolve(updateParameters(parameters));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                })
            };
        }
        if (!hostAPI.isModuleDefined(this.macroName)) hostAPI.defineModule(this.macroName, this.macroActions);
    }
    static register(macroId, macroParams, editorActions, readonly) {
        if (!this.macrosCache.has(macroId)) this.macrosCache.set(macroId, {
            actions: editorActions,
            parameters: macroParams,
            readonly: readonly
        });
    }
    static deregister(macroId) {
        if (this.macrosCache.has(macroId)) this.macrosCache.delete(macroId);
    }
    static cleanCache() {
        this.macrosCache.clear();
    }
}
$172ec9aa4291f34d$export$65a835712c7fb845.macroName = 'macro';
$172ec9aa4291f34d$export$65a835712c7fb845.macroActions = null;
$172ec9aa4291f34d$export$65a835712c7fb845.macrosCache = new Map();
const $172ec9aa4291f34d$export$f3a2903499008e78 = async ({ logger: logger })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            if (!connectHost) {
                logger.error`ConnectHost is not available to init macro module`;
                resolve();
                return;
            }
            $172ec9aa4291f34d$export$65a835712c7fb845.init(connectHost, logger);
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for macro module!`;
            resolve();
        });
    });
};






var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


const $24172b2397b2d142$export$13124d26de07dad1 = ({ macroId: macroId, macroParams: macroParams, editorActions: editorActions, readonly: readonly = false })=>{
    (0, $42omo.useEffect)(()=>{
        if (!editorActions) {
            (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`No editor actions has been provided to MultiBodiedExtensionHandler for macro ${macroId}.`), {
                attribution: (0, $3IBnw.Attribution).ECOSYSTEM
            });
            return;
        }
        (0, $172ec9aa4291f34d$export$65a835712c7fb845).register(macroId, macroParams, editorActions, readonly);
        return ()=>{
            (0, $172ec9aa4291f34d$export$65a835712c7fb845).deregister(macroId);
        };
    }, [
        macroId,
        macroParams,
        editorActions,
        readonly
    ]);
    return null;
};






var $6g1oe = parcelRequire("6g1oe");





var $gEtAQ = parcelRequire("gEtAQ");

const $b1fc10dfab719594$var$extractExtensionKey = (extensionId)=>{
    const split = extensionId.split('__');
    if (split.length === 3) return split[1];
    return 'UNKOWN_EXTENSION_KEY';
};
const $b1fc10dfab719594$var$sendReferenceData = (references, extensionId, createAnalyticsEvent)=>{
    const eventName = 'data_provider';
    const addonFilter = {
        id: extensionId
    };
    const eventData = {
        eventData: references
    };
    const analyticsEvent = createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: (0, $gEtAQ.isViewPage)() ? 'viewPageScreen' : 'editPageScreen',
            action: 'broadcasted',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: $b1fc10dfab719594$var$extractExtensionKey(extensionId)
            }
        }
    });
    analyticsEvent.fire();
    // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).connectHost.broadcastEvent(eventName, addonFilter, eventData);
};
const $b1fc10dfab719594$export$b2f0fd57401a56fe = ({ references: references, macroContainer: macroContainer })=>{
    const [extensionId, setExtensionId] = (0, $42omo.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (extensionId && Array.isArray(references) && references.length > 0) $b1fc10dfab719594$var$sendReferenceData(references, extensionId, createAnalyticsEvent);
    }, [
        references,
        extensionId,
        createAnalyticsEvent
    ]);
    const listeningForInitialization = (0, $42omo.useCallback)((event)=>{
        if (event.data?.type !== 'event_query' || !event.data?.eid || !event.data?.args?.includes?.('data_provider')) return;
        const iframeEl = document.getElementById(event.data.eid);
        if (iframeEl && macroContainer?.contains?.(iframeEl)) setExtensionId(event.data.eid);
    }, [
        macroContainer,
        setExtensionId
    ]);
    // Starts listening for macro initialization
    (0, $42omo.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).addEventListener('message', listeningForInitialization);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).removeEventListener('message', listeningForInitialization);
        };
    }, [
        listeningForInitialization
    ]);
    return null;
};









var $gdv5Z = parcelRequire("gdv5Z");


var $ebrpi = parcelRequire("ebrpi");





var $hUS75 = parcelRequire("hUS75");

const $bd422ab26f8348d3$export$99a6d9338f38339e = ({ error: error, mode: mode, extensionKey: extensionKey, node: node, contentId: contentId })=>{
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hUS75.MacroExperienceStop), {
        extensionKey: extensionKey,
        error: error || Error(`Unable to render ${extensionKey}`),
        mode: mode,
        attributes: attributes,
        contentId: contentId,
        name: (0, $5kjCz.getExperienceName)(mode, node),
        source: "LegacyMacroRendererError"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: 5,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 200,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: "var(--ds-space-050, 4px)"
        },
        "data-testid": "legacy-macro-renderer-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: "",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "fabric-extension-legacy-macro-renderer.legacymacrorenderer.error",
        defaultMessage: "Failed to get macro details"
    }))));
};



var $aQw7y = parcelRequire("aQw7y");







const $622a0e8eee3d2f68$var$canOpenInNewTab = (href)=>{
    if (!href) // e.g., "Refresh" link in jira issue macro
    return false;
    const url = new URL(href);
    if (url.origin !== window.location.origin) return true;
    else if (url.pathname.includes('/wiki/rest/api')) return false;
    else if (url.pathname.includes('changes.action')) // e.g., "Show More" link in the recently updated macro
    return false;
    else if (url.pathname.includes('confirmattachmentremoval.action')) // e.g., "Delete" link in the attachments macro
    return false;
    else if (url.pathname.includes('.action')) // Most .action links should open in a new tab
    return true;
    else return true;
};
const $622a0e8eee3d2f68$export$5f4b0c82ca04cc0c = (extensionKey, container, isEditor)=>{
    const extensionsToOpenLinksInNewTab = (0, $42omo.useMemo)(()=>{
        const extensionSet = new Set();
        if (!isEditor) return extensionSet;
        const allowlist = (0, $4VJDS.default).getStringList('confluence_frontend_macro_links_new_tab_allowlist', []);
        allowlist.map((ext)=>ext.trim().toLowerCase()).forEach((ext)=>ext && extensionSet.add(ext));
        return extensionSet;
    }, [
        isEditor
    ]);
    (0, $42omo.useEffect)(()=>{
        // Short circuit if we're not in the editor or the container is falsey
        if (!isEditor || !container) return;
        // Only intercept links in the FF allowlist
        if (!extensionsToOpenLinksInNewTab?.has(extensionKey.toLowerCase())) return;
        function interceptLinkClick(ev) {
            const anchor = ev?.target;
            // Only intercept clicks on anchor tags
            if (anchor?.tagName !== 'A') return;
            if (!$622a0e8eee3d2f68$var$canOpenInNewTab(anchor.href)) return;
            ev.preventDefault();
            window.open(anchor.href, '_blank', 'noopener, noreferrer');
        }
        container.addEventListener('click', interceptLinkClick);
        return ()=>{
            // Remove the event listener when the component unmounts
            container.removeEventListener('click', interceptLinkClick);
        };
    }, [
        container,
        extensionsToOpenLinksInNewTab,
        extensionKey,
        isEditor
    ]);
};


// The rendered HTML currently outputs a div that contains a macro id attribute
// `data-macro-id="XYZ"`. We can parse that and get the ID
const $34a09ee48ab537fd$var$idFromStorageFormat = /data-macro-id="([0-9a-fA-F\-]+?)"/;
// this will be fallback pattern in case div does not contain the macro id attribute.
// Parse in from data variable in the script tag.Pattern looks like `\\\"macro.id\\\":\\\"XYZ\\\"`
const $34a09ee48ab537fd$var$idFromADF = /macro\.id\\":\\"([0-9a-fA-F\-]+?)\\"/;
const $34a09ee48ab537fd$var$logger = (0, $7W8i8.getLogger)('LegacyMacroRenderer');
const $34a09ee48ab537fd$var$Overlay = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "legacy-macro-overlay",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            bottom: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            left: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            right: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            cursor: 'default',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            zIndex: 2
        }
    });
/**
 * CEMS-919 and HOT-84603
 * ---------
 * Current implementation of the Team Calendars Plugin does not account for
 * a SPA transition. It only loads the calendars once and forgets about
 * re-initializing them once the page is unmounted. For this, we need to
 * invoke the assets when necessary and initialize the calendars. Also reference:
 * confluence-frontend-server/src/components/ContentBody/ContentBodyDefaultComponent.js
 * @private
 */ const $34a09ee48ab537fd$var$initializeCalendarIfNeeded = async (extensionKey, isBodied, macroRenderedOutput)=>{
    const isCalendarNeeded = extensionKey === 'calendar' || isBodied && macroRenderedOutput?.includes('data-macro-name="calendar"');
    if (isCalendarNeeded) (0, $cpjd2.requireLegacyWRM)((0, $8eAX8.teamCalendarWRM)(), ()=>{
        try {
            window.require('tc/init-resources').requireResources();
        } catch (err) {
            $34a09ee48ab537fd$var$logger.error(err);
        }
    }, ()=>{
        $34a09ee48ab537fd$var$logger.error`Error loading team calendar WRM!`;
    });
};
const $34a09ee48ab537fd$var$getMacroId = (adf, macroRenderedOutput)=>{
    const idFromNode = adf?.attrs?.parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    let matches = $34a09ee48ab537fd$var$idFromStorageFormat.exec(macroRenderedOutput || '');
    if (matches?.[1]) return matches[1];
    matches = $34a09ee48ab537fd$var$idFromADF.exec(macroRenderedOutput || '');
    if (matches?.[1]) return matches[1];
    $34a09ee48ab537fd$var$logger.error`Cannot find macro id from ${macroRenderedOutput}`;
    return '';
};
const $34a09ee48ab537fd$var$MACROS_TO_URL_SHIM = [
    'include',
    'contentbylabel',
    'children',
    'content-report-table',
    'index',
    'pagetree',
    'tasks-report-macro',
    'recently-updated-dashboard',
    'recently-updated',
    'toc'
];
const $34a09ee48ab537fd$var$UFO3PSegmentWrapper = ({ children: children, extensionKey: extensionKey })=>{
    const isFirstPartyExtension = (0, $42omo.useMemo)(()=>{
        const trimmedExtensions = new Set((0, $4VJDS.default).getString('confluence_1p_extensions', '').split(',').map((item)=>item.trim()));
        return trimmedExtensions.has(extensionKey);
    }, [
        extensionKey
    ]);
    if (isFirstPartyExtension) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
        name: `extension-${extensionKey}`
    }, children);
};
const $34a09ee48ab537fd$export$a5c44bbb70ae7ae6 = (0, $3Btfb.withNavigationPolicy)(({ adf: adf, macroRepresentation: macroRepresentation, macroRenderedOutput: macroRenderedOutput, mode: mode, node: node, contentId: contentId, attributes: attributes, experienceName: experienceName, featureFlags: featureFlags, webresource: webresource, body: body, parameters: parameters, navigationPolicy: navigationPolicy, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, context: context, spaceKey: spaceKey, providers: providers, mediaToken: mediaToken, noOverlay: noOverlay, isWithinEditor: isWithinEditor, isPreviewMode: isPreviewMode })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isInline = adf.type === (0, $8pcS0.INLINE_EXTENSION_TYPE);
    const isMultiBodied = adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE);
    const extensionKey = adf?.attrs?.extensionKey || '';
    const scriptContainer = (0, $42omo.useRef)(null);
    if (!macroRenderedOutput) macroRenderedOutput = '';
    if (extensionKey && macroRenderedOutput) {
        // If a Tiny page with Style Macro gets converted to Fabric, need to Scope the CSS
        // When in edit mode, the <style> tag don't have data-macro-name="style" attribute, so need to pass a different regex
        if (extensionKey === 'style') macroRenderedOutput = (0, $6AplS.scopeCSS)(macroRenderedOutput, (0, $6AplS.mainContentSelector), /(<style[^>]*>)((.|\n|\r)*?)(<\/style>)/gm).contentWithScopedCSS;
        else // Other extensionKeys could have nested Style Macro
        macroRenderedOutput = (0, $6AplS.scopeCSS)(macroRenderedOutput, (0, $6AplS.mainContentSelector)).contentWithScopedCSS;
    }
    const { viewportHeight: viewportHeight } = (0, $bYtfC.useConnectExtensionViewportSize)(node);
    const shouldHideOverlay = (0, $aQw7y.useShouldHideOverlay)(extensionKey, (0, $fgbpl.isBodiedExtension)(adf.type));
    /**
   * Callback to be triggered when web resources are resolved.
   * This is to make sure certain macros e.g. Gadget Macro only to render output after web resources loaded.
   * For more context of the issue: https://hello.atlassian.net/wiki/spaces/~462393321/pages/1007234825/Debugging+Legacy+Jira+gadgets+within+Connie
   * https://jira.atlassian.com/browse/CONFCLOUD-70573
   */ const [delayedOutput, setDelayedOutput] = (0, $42omo.useState)(extensionKey === 'gadget' ? '' : macroRenderedOutput);
    const [container, setContainer] = (0, $42omo.useState)(null);
    const [isMacroResourcesLoaded, setIsMacroResourcesLoaded] = (0, $42omo.useState)(false);
    // Variables for temporarily measuring rendered macro heights
    const isRendererExtension = mode === (0, $5kjCz.RENDERER) && adf.type === (0, $8pcS0.REGULAR_EXTENSION_TYPE);
    const isMacroLoaded = container && isMacroResourcesLoaded && delayedOutput;
    (0, $42omo.useEffect)(()=>{
        if (container) {
            const loadMacroResources = async ()=>{
                const isDPModuleDefined = (0, $8cOoD.checkIsDPModuleDefined)();
                if (!isDPModuleDefined) {
                    const isViewPage = mode === (0, $5kjCz.RENDERER);
                    await (0, $8cOoD.loadDataProviderModule)({
                        logger: $34a09ee48ab537fd$var$logger,
                        isViewPage: isViewPage,
                        createAnalyticsEvent: createAnalyticsEvent
                    });
                }
                if (isMultiBodied) await (0, $172ec9aa4291f34d$export$f3a2903499008e78)({
                    logger: $34a09ee48ab537fd$var$logger
                });
                await (0, $8eAX8.loadMacroWebResources)(webresource, macroRenderedOutputFromSSR, macroOutput, ()=>{
                    if (delayedOutput !== macroRenderedOutput) setDelayedOutput(macroRenderedOutput);
                }, scriptContainer?.current);
                setIsMacroResourcesLoaded(true);
            };
            loadMacroResources();
            (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $9wGTI.fg)('content_early_connect_iframe_initialization'));
            $34a09ee48ab537fd$var$initializeCalendarIfNeeded(extensionKey, (0, $fgbpl.isBodiedExtension)(adf.type), macroRenderedOutput);
        }
    }, [
        webresource,
        extensionKey,
        macroRenderedOutput,
        delayedOutput,
        container,
        scriptContainer,
        macroRenderedOutputFromSSR,
        macroOutput,
        mode,
        createAnalyticsEvent,
        isMultiBodied,
        adf.type
    ]);
    (0, $42omo.useEffect)(()=>{
        /**
     * Our goal here is to measure the height of the connect macro after its iframe content has finished rendering.
     * The iframe load event would be insufficient and we can't be specific on when the content in the iframe is done
     * rendering since it'd rely on the vendor using ACJS to communicate this. At best we approximate by waiting for
     * resources to have been loaded and waiting a reasonable amount of time to check. We will also restrict this
     * to view mode and avoid multi-bodied or inline macros.
     */ if (isMacroLoaded && isRendererExtension && (0, $9wGTI.fg)('confluence_content_macro_measurements')) {
            const timer = setTimeout(()=>{
                // Target the connect iframe to prevent measuring macros in other extension points
                const connectIframe = container.querySelector('iframe');
                if (connectIframe) {
                    const { height: height } = connectIframe.getBoundingClientRect();
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            source: 'legacyMacroRenderer',
                            action: 'render',
                            actionSubject: 'connectMacro',
                            attributes: {
                                extensionKey: extensionKey,
                                height: height
                            }
                        }
                    }).fire();
                }
            }, 10000);
            return ()=>clearTimeout(timer);
        }
    }, [
        container,
        extensionKey,
        createAnalyticsEvent,
        isMacroLoaded,
        isRendererExtension
    ]);
    (0, $622a0e8eee3d2f68$export$5f4b0c82ca04cc0c)(extensionKey ?? '', container, mode === (0, $5kjCz.EDITOR) || isWithinEditor);
    const macroId = $34a09ee48ab537fd$var$getMacroId(adf, macroRenderedOutput);
    const ssredElement = (0, $KcDWk.useSSRedLegacyMacroElement)(macroId);
    const nodeProps = {
        ref: setContainer
    };
    const macroDataProps = {
        'data-fabric-macro': macroId,
        'data-macro-body': body || '',
        'data-macro-parameters': parameters || '',
        'data-node-type': extensionKey === 'include' ? 'include' : undefined
    };
    // Use parent id if the macro source is different than the current page
    const getContentId = (adf, contentId)=>{
        const parentId = adf?.attrs?.parameters?.macroParams?._parentId?.value;
        return parentId || contentId;
    };
    const { getExtensionHandlers: getExtensionHandlers } = providers;
    const extensionHandlers = getExtensionHandlers ? getExtensionHandlers({
        adf: macroRepresentation == 'atlas_doc_format' ? macroRenderedOutputFromSSR || macroOutput || macroRenderedOutput : adf,
        contentId: getContentId(adf, contentId),
        spaceKey: spaceKey,
        macroRenderedOutput: macroRenderedOutputFromSSR || macroOutput || macroRenderedOutput,
        shouldIncludeMacroWithReferencesHandlers: true,
        referentialityDataSourceProvider: new (0, $lEgye.DataSourceProvider)(),
        mediaToken: mediaToken
    }) : {};
    const elementProps = {
        adf: adf,
        isInline: isInline,
        contentId: getContentId(adf, contentId),
        mode: mode,
        extensionKey: extensionKey,
        nodeProps: nodeProps,
        macroRepresentation: macroRepresentation,
        macroDataProps: macroDataProps,
        macroRenderedOutput: delayedOutput,
        extensionHandlers: extensionHandlers,
        mediaToken: mediaToken,
        ssredElement: ssredElement,
        delayIframe: false,
        height: viewportHeight
    };
    if (mode === (0, $5kjCz.RENDERER) || mode === (0, $5kjCz.PDF)) {
        try {
            const macroId = attributes?.macroId ? attributes.macroId : '';
            const type = attributes?.type ? attributes.type : 'none';
            // on view page it will send macro load event
            // it will help to alert in case of multiple rendering of macro
            // event name: macro renderer (client)
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'renderer',
                    actionSubject: 'macro',
                    source: 'legacyMacroRenderer',
                    attributes: {
                        mode: mode,
                        extensionKey: extensionKey,
                        macroId: macroId,
                        contentId: contentId,
                        type: type
                    }
                }
            }).fire();
        } catch (err) {
            $34a09ee48ab537fd$var$logger.error`An error occurred while firing the analytics event for legacyMacroRendererComponent: ${err}`;
        }
        const finalExtensionKey = attributes?.extensionKey || extensionKey;
        /**
     * https://product-fabric.atlassian.net/browse/CCP-1798
     * If macroRenderedOutputFromSSR or macroOuput are passed as a prop, they will be used for SPA rehydration (rather
     * than the MacroContentQuery). macroRenderedOutputFromSSR / macroOutput already have JS/CSS coming from ContentUnifiedQuery,
     * so here we use the base components of LegacyMacroRendererComponent, but instead
     * render FabricLegacyMacrosServerRenderer, which sets JS/CSS internally.
     * https://product-fabric.atlassian.net/browse/DLRN-3182
     * If macroOutput exists, it contains the full html (as a string) required to render the macro.
     */ if (macroRenderedOutputFromSSR || macroOutput) {
            const macroDefaultProps = {
                node: node,
                context: context,
                references: references,
                contentId: contentId,
                spaceKey: spaceKey || '',
                mode: (0, $5kjCz.RENDERER),
                extensionKey: extensionKey,
                attributes: attributes
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34a09ee48ab537fd$var$UFO3PSegmentWrapper, {
                extensionKey: finalExtensionKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
                name: "LegacyMacroRendererComponentResourcesSSR",
                hold: !isMacroResourcesLoaded
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1fc10dfab719594$export$b2f0fd57401a56fe), {
                references: references,
                macroContainer: container
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5LTS4.ExtensionLoadingComplete), {
                extensionKey: finalExtensionKey,
                contentId: contentId,
                node: node
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $989nU.FabricLegacyMacrosServerRenderer), {
                renderedByProvider: true,
                macroRenderedOutput: macroRenderedOutputFromSSR,
                macroDefaultProps: macroDefaultProps,
                containerRef: setContainer,
                macroOutput: macroOutput
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hHZWk.LegacyUserElementsHover), {
                node: container
            }), // WS-3295 - DO NOT REMOVE THIS LOADER
            // We need to load the legacy editor here to allow users to create/edit/view comments with the attachments macro
            extensionKey === 'attachments' && !isPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMRhJ.RendererExtensionContext).Consumer, null, ({ EditorLoaderLoader: EditorLoaderLoader })=>{
                // isWithinEditor will be true if the attachments macro is within a macro
                // that itself is being rendered in the editor, e.g., excerpt-include.
                return !isWithinEditor && !isPreviewMode && EditorLoaderLoader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EditorLoaderLoader, null);
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
                name: experienceName,
                contentId: contentId,
                extensionKey: extensionKey,
                mode: mode,
                attributes: attributes
            })));
        }
        // TODO: Detect TeamCalendar macro and enusre hold timing is correct for it
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34a09ee48ab537fd$var$UFO3PSegmentWrapper, {
            extensionKey: finalExtensionKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "LegacyMacroRendererComponentResourcesNonSSR",
            hold: !isMacroResourcesLoaded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1fc10dfab719594$export$b2f0fd57401a56fe), {
            references: references,
            macroContainer: container
        }), isMultiBodied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $24172b2397b2d142$export$13124d26de07dad1), {
            macroId: macroId,
            macroParams: parameters,
            editorActions: multiBodiedExtensionActions,
            readonly: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: `${webresource?.tags?.css || ''}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                display: 'none'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5LTS4.ExtensionLoadingComplete), {
            extensionKey: finalExtensionKey,
            contentId: contentId,
            node: node
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iaRmR.LegacyMacroStyledElement), {
            renderedByProvider: true,
            ...elementProps,
            macroRenderedOutput: $34a09ee48ab537fd$var$MACROS_TO_URL_SHIM.includes(extensionKey) ? navigationPolicy.shimHtmlUrls(delayedOutput) : delayedOutput
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hHZWk.LegacyUserElementsHover), {
            node: container
        }), // WS-3295 - DO NOT REMOVE THIS LOADER
        // We need to load the legacy editor here to allow users to create/edit/view comments with the attachments macro
        extensionKey === 'attachments' && !isPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMRhJ.RendererExtensionContext).Consumer, null, ({ EditorLoaderLoader: EditorLoaderLoader })=>{
            // isWithinEditor will be true if the attachments macro is within a macro
            // that itself is being rendered in the editor, e.g., excerpt-include.
            return !isWithinEditor && EditorLoaderLoader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EditorLoaderLoader, null);
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: "js-container",
            ref: scriptContainer,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                display: 'none'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes
        })));
    }
    let parsedDelayedOutput;
    let parseError;
    let component;
    try {
        if (macroRepresentation === 'atlas_doc_format') {
            parsedDelayedOutput = JSON.parse(delayedOutput);
            component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
                document: parsedDelayedOutput,
                contentId: getContentId(adf, contentId),
                featureFlags: featureFlags ?? {},
                extensionHandlers: extensionHandlers,
                mediaToken: mediaToken,
                appearance: "full-width"
            });
        }
    } catch (e) {
        parseError = e;
        $34a09ee48ab537fd$var$logger.error`An error occurred while parsing adf output: ${delayedOutput}`;
        component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd422ab26f8348d3$export$99a6d9338f38339e), {
            error: parseError,
            node: node,
            mode: mode,
            extensionKey: extensionKey,
            contentId: contentId
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34a09ee48ab537fd$var$UFO3PSegmentWrapper, {
        extensionKey: extensionKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "LegacyMacroRendererComponentResourcesFabric",
        hold: !isMacroResourcesLoaded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: `${webresource?.tags?.css || ''}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    }), isMultiBodied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $24172b2397b2d142$export$13124d26de07dad1), {
        macroId: macroId,
        macroParams: parameters,
        editorActions: multiBodiedExtensionActions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iaRmR.LegacyMacroStyledElement), {
        renderedByProvider: true,
        ...elementProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: viewportHeight && (0, $9wGTI.fg)('confluence_connect_macro_preset_height') ? {
            minHeight: `${viewportHeight}px`
        } : null
    }, noOverlay || shouldHideOverlay || isMultiBodied ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34a09ee48ab537fd$var$Overlay, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1fc10dfab719594$export$b2f0fd57401a56fe), {
        references: references,
        macroContainer: container
    }), macroRepresentation === 'atlas_doc_format' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "macro-adf-renderer",
        ref: setContainer
    }, component) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: setContainer,
        dangerouslySetInnerHTML: {
            __html: `${delayedOutput}`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        key: "js-container",
        ref: scriptContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    })));
});
const $34a09ee48ab537fd$export$b43db7dd8b06a124 = (props)=>{
    const rendererExtensionProviders = (0, $42omo.useContext)((0, $hMRhJ.RendererExtensionContext));
    const classicEditorExtensionProviders = (0, $42omo.useContext)((0, $giS6h.ClassicEditorContext));
    const isWithinEditor = classicEditorExtensionProviders?.isWithinEditor ?? false;
    const providers = {
        ...classicEditorExtensionProviders,
        ...rendererExtensionProviders
    };
    const propsWithProviders = {
        ...props,
        providers: providers,
        isWithinEditor: isWithinEditor
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34a09ee48ab537fd$export$a5c44bbb70ae7ae6, propsWithProviders);
};



var $euF5O = parcelRequire("euF5O");





const $3ff9e0546f2c245a$export$1b5865c105cfe12d = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    listOfRenderedPageIncludeNodes: []
});


/**
 * Checks whether an extension node is a plain text macro or not.
 *
 * The node at this point may not indicate what it's content type is, so a
 * reliable way is to check for the `__bodyContent` property, which exists
 * on plain text macros.
 *
 * @param node Extension node to check
 */ const $b65e5cf2eec587a5$var$isPlainTextMacro = (node)=>node.type === (0, $8pcS0.REGULAR_EXTENSION_TYPE) && Boolean(node?.parameters?.macroParams?.__bodyContent);
/**
 * All bodied extensions are rich text.
 *
 * @param node Extension node to check
 */ const $b65e5cf2eec587a5$var$isRichTextMacro = (node)=>node.type === (0, $8pcS0.BODIED_EXTENSION_TYPE);
const $b65e5cf2eec587a5$var$convertADFContentToStorageQuery = async (contentId, content)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const result = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $6Cce7.ContentConverterQuery),
        variables: (0, $92uc5.getContentConverterVariables)({
            content: content,
            contentId: contentId
        })
    });
    return result.data?.contentConverter?.value;
};
function $b65e5cf2eec587a5$var$isMacroUsingInEditorRendererView({ isInEditorRendererView: isInEditorRendererView, node: node, extensionKey: extensionKey }) {
    return isInEditorRendererView && (0, $kRAnY.is2PBodiedExtension)({
        extensionKey: extensionKey,
        extensionType: node.type
    });
}
function $b65e5cf2eec587a5$var$isIncludePageNested2pBodiedExtension({ contentId: contentId, node: node, extensionKey: extensionKey }) {
    const hasParent = !!node?.parameters?.macroParams?._parentId?.value;
    const hasSameParent = node?.parameters?.macroParams?._parentId?.value === contentId;
    return (0, $kRAnY.is2PBodiedExtension)({
        extensionKey: extensionKey,
        extensionType: node.type
    }) && hasParent && !!contentId && !hasSameParent;
}
function $b65e5cf2eec587a5$var$shouldConvertBodyToStorageFormat(props) {
    const { extensionKey: extensionKey } = props;
    return Boolean(!(0, $ld6xp.canUseMultiMacroQuery)(extensionKey, $b65e5cf2eec587a5$var$isIncludePageNested2pBodiedExtension(props)) || $b65e5cf2eec587a5$var$isMacroUsingInEditorRendererView(props));
}
class $b65e5cf2eec587a5$export$a7d233751dc2a8c9 extends (0, $42omo.Component) {
    getChildContext() {
        const { context: context } = this.props;
        const noop = ()=>{};
        return {
            insertCss: context.insertCss || noop
        };
    }
    componentDidMount() {
        this.setMacroData();
        this.setUFOEventMacroDisplayStatus();
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.contentId !== nextProps.contentId || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.props?.node?.parameters, nextProps?.node?.parameters) || (nextProps.references || this.props.references) && this.props.references !== nextProps.references || this.state.hasBodyBeenFetched !== nextState.hasBodyBeenFetched || this.state.body !== nextState.body;
    }
    componentDidUpdate() {
        this.setMacroData();
    }
    componentWillUnmount() {
        const { node: node, mode: mode, contentId: contentId } = this.props;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
        (0, $5kjCz.stopJIRAMacro)(mode, contentId, name, attributes);
    }
    /**
   * Parses the rich text macro's body and sets the state with it.
   */ async setRichTextMacroBody() {
        const { contentId: contentId, node: node } = this.props;
        // Get the ADF content of the node
        const content = node?.content || [];
        try {
            // Unfortunately, vendor add ons expect storage format. We need to convert
            // the ADF to the appropriate format.
            let body;
            // only use conversion query in two scenarios
            //   1. if not using macros query where body storage format is already provided.
            //   2. If macro is using in editor renderer view, we need to update the body for this singular macro
            //      using the multi macro query would refetch for all macros on the page, re-rendering them all.
            if ($b65e5cf2eec587a5$var$shouldConvertBodyToStorageFormat(this.props)) body = await $b65e5cf2eec587a5$var$convertADFContentToStorageQuery(contentId, content);
            this.setState({
                body: body,
                hasBodyBeenFetched: true
            });
        } catch (error) {
            this.logger.error`${error}`; //tslint:disable-line
        }
    }
    /**
   * Parses the plain text macro's body and sets the state with it.
   *
   * Even though it's plain text, we don't actually need to set state. This
   * could be done in the renderer, but because we're converting rich text
   * macro's body to storage format, the mechanism for passing in the body is
   * `this.setState`. This will change in the future if we start passing
   * adf in our `getMacroBody` calls (and then this can be cleaned up).
   */ setPlainTextMacroBody() {
        const { node: node } = this.props;
        const body = node?.parameters?.macroParams?.__bodyContent?.value || '';
        this.setState({
            body: body,
            hasBodyBeenFetched: true
        });
    }
    setMacroData() {
        const { node: node } = this.props;
        // 1. Node is null, which means we won't render anything.
        // 2. If macro is using in editor renderer view, we need to refetch the body on update
        //    because the parameters might have changed due to user interaction in the macros edit mode.
        if (!node || $b65e5cf2eec587a5$var$isRichTextMacro(node) && this.state.hasBodyBeenFetched && !$b65e5cf2eec587a5$var$isMacroUsingInEditorRendererView(this.props)) return;
        if ($b65e5cf2eec587a5$var$isPlainTextMacro(node)) this.setPlainTextMacroBody();
        else if ($b65e5cf2eec587a5$var$isRichTextMacro(node)) this.setRichTextMacroBody();
        else // It's neither, so just render the component
        this.setState({
            hasBodyBeenFetched: true
        });
    }
    setUFOEventMacroDisplayStatus() {
        const extensionKey = this.props.extensionKey;
        if (!extensionKey) return;
        const parts = extensionKey.split('-');
        const pascalCaseString = parts.map((part)=>{
            if (part.length === 0) return '';
            return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        }).join('');
        (0, $cbc8g.addUFOCustomData)({
            [`is${pascalCaseString}MacroDisplayed`]: true
        });
    }
    // Use parent id if the macro source is different than the current page.
    // Critical for having the include-page macro load properly
    getContentId(adf, contentId) {
        const parentId = adf?.attrs?.parameters?.macroParams?._parentId?.value;
        return parentId || contentId;
    }
    render() {
        const mode = window.location.pathname.startsWith('/wiki/pdf/') ? 'pdf' : this.props.mode;
        const { hasBodyBeenFetched: hasBodyBeenFetched } = this.state;
        const node = this.props.node;
        if (!node) return null;
        if (!hasBodyBeenFetched) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
            node: node
        });
        const adf = (0, $6mEZ3.extensionToADF)(node);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $euF5O.LegacyMacroRendererContext).Consumer, null, ({ shouldRefetchMacroQuery: shouldRefetchMacroQuery })=>// In edit mode the editor renders this component outside of the main app, therefore
            // the Apollo client has to be provided here too
            // only use the multi macro query if this macro is not inside another, such as a page include
            // since that means it will not have been fetched by the multi macro query
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j1Ss3.ApolloProvider), {
                client: (0, $hp2SH.getApolloClient)()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
                value: (0, $fGzMp.getExperienceTracker)()
            }, this.determineQuery({
                ...this.props,
                mode: mode,
                adf: adf,
                shouldRefetchMacroQuery: shouldRefetchMacroQuery
            }))));
    }
    constructor(_props){
        super(_props);
        this.logger = (0, $7W8i8.getLogger)('LegacyMacroRendererQuery');
        /**
     * Return a query for both contentRenderer and macroBodyRenderer.
     */ this.getQueryForMacroContentAndBodyForPossibleFrontendRendering = ({ adf: adf, contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, featureFlags: featureFlags, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, context: context, shouldRefetchMacroQuery: shouldRefetchMacroQuery, noOverlay: noOverlay, isPreviewMode: isPreviewMode })=>{
            const renderPageIncludeError = (pageTitle)=>{
                return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    className: "error"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $71fb7e5ab8464496$export$a7357cdd1f0b0168).highlightedPageIncludeRenderedError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...(0, $71fb7e5ab8464496$export$a7357cdd1f0b0168).nonhighlightedPageIncludeRenderedError,
                    values: {
                        pageTitle: pageTitle
                    }
                })));
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $eqB7W.default),
                variables: {
                    adf: (0, $gHCIk.serializeExtensionADF)(adf),
                    // The template editor passes a "0" as contentId by default,
                    // in this scenario we do NOT want to pass a contentId at all into the query.
                    // Not passing the correct contentId can make some macros fail to load
                    ...contentId !== '0' ? {
                        contentId: this.getContentId(adf, contentId)
                    } : {},
                    mode: mode && mode.toUpperCase()
                },
                // Used when multiple instances of PageContentRenderer cause conflicting IDs in macroRenderedOutput. This forces
                // a refetch when rendering subsequent PageContentRenderer instances so that a new ID is present in
                // macroRenderedOutput. 'cache-first' is Apollo's default fetchPolicy.
                fetchPolicy: shouldRefetchMacroQuery ? 'no-cache' : 'cache-first',
                // Some macros take a long time to render, they should not hold up the rendering of other things
                context: {
                    throttle: true,
                    allowOnExternalPage: true
                },
                skip: Boolean(macroRenderedOutputFromSSR) || Boolean(macroOutput)
            }, ({ data: data, loading: loading, error: error })=>{
                // render LegacyMacroRendererComponent without query data if macro has been
                // SSR'd and macro output already exists or when macroOutput
                // exists which contains the entire html string needed to render the macro
                if (macroRenderedOutputFromSSR || macroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34a09ee48ab537fd$export$b43db7dd8b06a124), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRenderedOutput: data?.macroBodyRenderer?.value,
                    macroRepresentation: data?.macroBodyRenderer?.representation || 'view',
                    mediaToken: data?.macroBodyRenderer?.mediaToken?.token,
                    node: node,
                    webresource: data?.macroBodyRenderer?.webResourceDependencies,
                    mode: mode,
                    body: this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    macroRenderedOutputFromSSR: macroRenderedOutputFromSSR,
                    macroOutput: macroOutput,
                    spaceKey: spaceKey,
                    context: context,
                    noOverlay: noOverlay,
                    isPreviewMode: isPreviewMode
                });
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
                    showSpinner: !!data,
                    node: node
                });
                if (error || !data || !data.macroBodyRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd422ab26f8348d3$export$99a6d9338f38339e), {
                    error: error,
                    node: node,
                    mode: mode,
                    extensionKey: extensionKey,
                    contentId: contentId
                });
                // Make it possible to execute AC JS functions locally.
                // The hostOrigin should match browser host
                let macroRenderedOutput = data.macroBodyRenderer?.value;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ff9e0546f2c245a$export$1b5865c105cfe12d).Consumer, null, ({ listOfRenderedPageIncludeNodes: listOfRenderedPageIncludeNodes })=>{
                    const { isCircularRef: isCircularRef, prevPageTitle: prevPageTitle } = $b65e5cf2eec587a5$export$ddad0aee336d9e1(listOfRenderedPageIncludeNodes);
                    if (isCircularRef) return renderPageIncludeError(prevPageTitle);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b65e5cf2eec587a5$var$PageIncludeContextProvider, {
                        contentId: contentId,
                        node: this.props.node,
                        listOfRenderedPageIncludeNodes: listOfRenderedPageIncludeNodes
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34a09ee48ab537fd$export$b43db7dd8b06a124), {
                        contentId: contentId,
                        experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                        adf: adf,
                        attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                        references: references,
                        multiBodiedExtensionActions: multiBodiedExtensionActions,
                        macroRenderedOutput: macroRenderedOutput,
                        macroRepresentation: data.macroBodyRenderer?.representation || 'view',
                        mediaToken: data?.macroBodyRenderer?.mediaToken?.token,
                        node: node,
                        webresource: data.macroBodyRenderer?.webResourceDependencies,
                        mode: mode,
                        body: this.state.body,
                        parameters: (0, $6mEZ3.getParametersString)(node),
                        featureFlags: featureFlags,
                        spaceKey: spaceKey,
                        context: context,
                        noOverlay: noOverlay,
                        isPreviewMode: isPreviewMode
                    }));
                });
            });
        };
        this.getQueryForMacroContentFromBackend = ({ adf: adf, contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, featureFlags: featureFlags, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, context: context, shouldRefetchMacroQuery: shouldRefetchMacroQuery, noOverlay: noOverlay, isPreviewMode: isPreviewMode })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $b1ypt.default),
                variables: {
                    adf: (0, $gHCIk.serializeExtensionADF)(adf),
                    contentId: contentId,
                    mode: mode && mode.toUpperCase()
                },
                // Used when multiple instances of PageContentRenderer cause conflicting IDs in macroRenderedOutput. This forces
                // a refetch when rendering subsequent PageContentRenderer instances so that a new ID is present in
                // macroRenderedOutput. 'cache-first' is Apollo's default fetchPolicy.
                fetchPolicy: shouldRefetchMacroQuery ? 'no-cache' : 'cache-first',
                // Some macros take a long time to render, they should not hold up the rendering of other things
                context: {
                    throttle: true,
                    allowOnExternalPage: true
                },
                skip: Boolean(macroRenderedOutputFromSSR) || Boolean(macroOutput)
            }, ({ data: data, loading: loading, error: error })=>{
                // render LegacyMacroRendererComponent without query data if macro has been
                // SSR'd and macro output already exists or when macroOutput
                // exists which contains the entire html string needed to render the macro
                if (macroRenderedOutputFromSSR || macroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34a09ee48ab537fd$export$b43db7dd8b06a124), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: data?.contentRenderer?.html,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: "view",
                    webresource: data?.contentRenderer?.webResourceDependencies,
                    mode: mode,
                    body: this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    macroRenderedOutputFromSSR: macroRenderedOutputFromSSR,
                    macroOutput: macroOutput,
                    spaceKey: spaceKey,
                    context: context,
                    noOverlay: noOverlay,
                    isPreviewMode: isPreviewMode
                });
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
                    showSpinner: !!data,
                    node: node
                });
                if (error || !data || !data.contentRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd422ab26f8348d3$export$99a6d9338f38339e), {
                    error: error,
                    node: node,
                    mode: mode,
                    extensionKey: extensionKey,
                    contentId: contentId
                });
                // Make it possible to execute AC JS functions locally.
                // The hostOrigin should match browser host
                let contentRenderedHtml = data.contentRenderer.html;
                // assume we have data here
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34a09ee48ab537fd$export$b43db7dd8b06a124), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: contentRenderedHtml,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: "view",
                    webresource: data.contentRenderer.webResourceDependencies,
                    mode: mode,
                    body: this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    context: context,
                    noOverlay: noOverlay,
                    isPreviewMode: isPreviewMode
                });
            });
        };
        this.getQueryForMacros = (args)=>{
            const { adf: adf, contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, featureFlags: featureFlags, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, context: context, noOverlay: noOverlay } = args;
            const macroId = node.parameters?.macroMetadata?.macroId?.value;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKSlH.MultiMacroQuerySubscriber), {
                contentId: contentId,
                macroId: macroId
            }, ({ renderedMacro: renderedMacro, loading: loading, error: error, complete: complete })=>{
                // if the multi macro query is complete and there were no errors
                // that means we are inserting a new macro in the editor or have
                // just published the page in which case the new macro data
                // will not be available on the backend to render yet so use
                // the old queries to render instead
                if (complete && !renderedMacro && !error) return this.determineQuery(args, true);
                // render LegacyMacroRendererComponent without query data if macro has been
                // SSR'd and macro output already exists or when macroOutput
                // exists which contains the entire html string needed to render the macro
                if (macroRenderedOutputFromSSR || macroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34a09ee48ab537fd$export$b43db7dd8b06a124), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: renderedMacro?.value,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: renderedMacro?.macroRenderedRepresentation || 'view',
                    webresource: renderedMacro?.webResource,
                    mode: mode,
                    body: renderedMacro?.macroBodyStorage || this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    macroRenderedOutputFromSSR: macroRenderedOutputFromSSR,
                    macroOutput: macroOutput,
                    spaceKey: spaceKey,
                    context: context,
                    noOverlay: noOverlay,
                    mediaToken: renderedMacro?.mediaToken?.token
                });
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
                    node: node
                });
                if (error || !renderedMacro) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd422ab26f8348d3$export$99a6d9338f38339e), {
                    error: new (0, $422HI.ApolloErrorInterop)({
                        errorMessage: `error rendering legacy macro: {$extensionKey}`
                    }),
                    node: node,
                    mode: mode,
                    extensionKey: extensionKey,
                    contentId: contentId
                });
                // assume we have data here
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34a09ee48ab537fd$export$b43db7dd8b06a124), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: renderedMacro?.value,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: renderedMacro?.macroRenderedRepresentation || 'view',
                    webresource: renderedMacro?.webResource,
                    mode: mode,
                    body: renderedMacro?.macroBodyStorage || this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    context: context,
                    noOverlay: noOverlay,
                    mediaToken: renderedMacro?.mediaToken?.token
                });
            });
        };
        this.getReferencedContentId = (node)=>{
            return node?.parameters?.macroParams?._referencedContentId?.value || undefined;
        };
        this.determineQuery = (props, doNotUseMultiMacro = false)=>{
            const { extensionKey: extensionKey, node: node } = props;
            if (!doNotUseMultiMacro && (!node?.parameters?.macroParams?._parentId || node.parameters.macroParams._parentId.value === this.props.contentId) && (0, $ld6xp.canUseMultiMacroQuery)(extensionKey, $b65e5cf2eec587a5$var$isIncludePageNested2pBodiedExtension(props))) return this.getQueryForMacros(props);
            const editorMacroADFRendering = (0, $4VJDS.default).getBoolean('confluence_frontend_macro_adf_frontend_render', true);
            return editorMacroADFRendering ? this.getQueryForMacroContentAndBodyForPossibleFrontendRendering(props) : this.getQueryForMacroContentFromBackend(props);
        };
        const state = {
            body: '',
            hasBodyBeenFetched: false
        };
        // Check condition upfront to avoid unnecessary state updates
        // Otherwise it will make component to always render the shadow which breaks SSR result
        // Basically repeat of setMacroData logic for the initial render
        const { node: _node } = _props;
        if ($b65e5cf2eec587a5$var$isPlainTextMacro(_node)) {
            state.body = _node?.parameters?.macroParams?.__bodyContent?.value || '';
            state.hasBodyBeenFetched = true;
        } else if ($b65e5cf2eec587a5$var$isRichTextMacro(_node)) {
            if (!$b65e5cf2eec587a5$var$shouldConvertBodyToStorageFormat(_props)) state.hasBodyBeenFetched = true;
        } else state.hasBodyBeenFetched = true;
        this.state = state;
    }
}
$b65e5cf2eec587a5$export$a7d233751dc2a8c9.childContextTypes = {
    /**
   * Handler for css injection in components.
   */ insertCss: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
const $b65e5cf2eec587a5$export$ddad0aee336d9e1 = (listOfRenderedPageIncludeNodes)=>{
    if (listOfRenderedPageIncludeNodes?.length) {
        // Keep reference so that we can render the previous page title in error message
        let prevRenderedNode;
        const pageIncludeNodeIds = new Set();
        let pageIncludeNodeAlreadyRendered = false;
        for (const pageIncludeNode of listOfRenderedPageIncludeNodes){
            if (pageIncludeNode?.extensionKey !== 'include') continue;
            prevRenderedNode = pageIncludeNode;
            const id = pageIncludeNode?.parameters?.macroMetadata?.macroId?.value;
            if (id) {
                if (pageIncludeNodeIds.has(id)) {
                    pageIncludeNodeAlreadyRendered = true;
                    break;
                } else pageIncludeNodeIds.add(id);
            }
        }
        // indicate that this page has already been included, to avoid infinite loop
        if (pageIncludeNodeAlreadyRendered) {
            const prevReferencedNodePageTitle = prevRenderedNode?.parameters?.macroParams?.['']?.value;
            return {
                isCircularRef: true,
                prevPageTitle: prevReferencedNodePageTitle
            };
        }
    }
    return {
        isCircularRef: false,
        prevPageTitle: null
    };
};
const $b65e5cf2eec587a5$var$PageIncludeContextProvider = ({ contentId: contentId, node: node, listOfRenderedPageIncludeNodes: listOfRenderedPageIncludeNodes, children: children })=>{
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        const renderedPageIncludeNodes = [
            ...listOfRenderedPageIncludeNodes,
            {
                ...node,
                parentContentId: contentId
            }
        ];
        return {
            listOfRenderedPageIncludeNodes: renderedPageIncludeNodes
        };
    }, [
        listOfRenderedPageIncludeNodes,
        node,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ff9e0546f2c245a$export$1b5865c105cfe12d).Provider, {
        value: contextValue
    }, children);
};
const $b65e5cf2eec587a5$export$1609bcb5ce6c9dd9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { featureFlags: featureFlags } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b65e5cf2eec587a5$export$a7d233751dc2a8c9, {
        featureFlags: featureFlags,
        ...props
    });
}, (prevProps, nextProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevProps, nextProps));
const $b65e5cf2eec587a5$export$c0b18e27c7eefe80 = (0, $3dbf040db5bfac2c$export$437fb41b7a687949)($b65e5cf2eec587a5$export$1609bcb5ce6c9dd9, 10000);
module.exports["LegacyMacroRendererQuery"] = $b65e5cf2eec587a5$export$1609bcb5ce6c9dd9;
module.exports["DebouncedLegacyMacroRendererQuery"] = $b65e5cf2eec587a5$export$c0b18e27c7eefe80;

});

parcelRegister("kRAnY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j0gZR = parcelRequire("j0gZR");

const $ecf08ec6a3fe0bb1$export$3edb28f707c97620 = ({ extensionKey: extensionKey, extensionType: extensionType })=>(0, $j0gZR.is1PMacro)(extensionKey || '') && extensionType === 'bodiedExtension';
const $ecf08ec6a3fe0bb1$export$99128e639bf2cee5 = ({ extensionKey: extensionKey, extensionType: extensionType })=>!(0, $j0gZR.is1PMacro)(extensionKey || '') && extensionType === 'bodiedExtension';
const $ecf08ec6a3fe0bb1$export$8166325a9a095a58 = ({ getExtensionHandlers: getExtensionHandlers, isLivePage: isLivePage, contentId: contentId, spaceKey: spaceKey })=>{
    return (0, $42omo.useMemo)(()=>{
        if (isLivePage) return {
            rendererExtensionHandlers: getExtensionHandlers?.({
                contentId: contentId,
                spaceKey: spaceKey,
                isInEditorRendererView: true
            }),
            isAllowedToUseRendererView: (node)=>{
                return $ecf08ec6a3fe0bb1$export$99128e639bf2cee5({
                    extensionKey: node.attrs?.extensionKey,
                    extensionType: node.type
                });
            },
            showUpdated1PBodiedExtensionUI: (node)=>$ecf08ec6a3fe0bb1$export$3edb28f707c97620({
                    extensionKey: node.attrs?.extensionKey,
                    extensionType: node.type
                })
        };
        return undefined;
    }, [
        getExtensionHandlers,
        isLivePage,
        contentId,
        spaceKey
    ]);
};
module.exports["is2PBodiedExtension"] = $ecf08ec6a3fe0bb1$export$99128e639bf2cee5;
module.exports["useExtensionRendererViewOptions"] = $ecf08ec6a3fe0bb1$export$8166325a9a095a58;

});

parcelRegister("j0gZR", function(module, exports) {
const $fa4d787503d7b919$export$1bf1a639d38d3f44 = (macro)=>$fa4d787503d7b919$export$4b1d56e1a5f9d339.has(macro);
const $fa4d787503d7b919$export$4b1d56e1a5f9d339 = new Set([
    'toc',
    'children',
    'livesearch',
    'recently-updated',
    'details',
    'jlol',
    'jira',
    'pagetree',
    'anchor',
    'contentbylabel',
    'create-from-template',
    'roadmap',
    'blog-posts',
    'excerpt',
    'attachments',
    'profile',
    'include',
    'content-report-table',
    'detailssummary',
    'tasks-report-macro',
    'excerpt-include',
    'iframe',
    'listlabels',
    'profile-picture',
    'change-history',
    'pagetreesearch',
    'widget',
    'decisionreport',
    'viewpdf',
    'contributors',
    'gadget',
    'popular-labels',
    'jirachart',
    'toc-zone',
    'portfolioforjiraplan',
    'viewppt',
    'viewxls',
    'recently-updated-dashboard',
    'spaces',
    'index',
    'contributors-summary',
    'userlister',
    'gallery',
    'viewdoc',
    'chart',
    'related-labels',
    'jiraroadmap'
]);
module.exports["is1PMacro"] = $fa4d787503d7b919$export$1bf1a639d38d3f44;

});

parcelRegister("iKSlH", function(module, exports) {

var $gK2Sc = parcelRequire("gK2Sc");


var $2aGhQ = parcelRequire("2aGhQ");


var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $5ZqQS = parcelRequire("5ZqQS");


var $6mKj3 = parcelRequire("6mKj3");


var $c0rhi = parcelRequire("c0rhi");


var $l1uFv = parcelRequire("l1uFv");


var $ld6xp = parcelRequire("ld6xp");

const $45c36e8dcd65ba05$export$cab5f498ed530ce4 = (0, $2aGhQ.default);
const $45c36e8dcd65ba05$export$47b47cc5b34ab476 = (0, $gK2Sc.default);
const $45c36e8dcd65ba05$var$DEFAULT_PRELOAD_PAGE_SIZE = 8;
const $45c36e8dcd65ba05$var$DEFAULT_PAGE_SIZE = 10;
const $45c36e8dcd65ba05$var$actions = {
    queryMacros: ({ contentId: contentId, contentRendererMode: contentRendererMode, featureFlags: featureFlags, cursor: cursor, revision: revision, useServerRenderedData: useServerRenderedData = false, readFragmentInterop: readFragmentInterop })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            // avoid querying if already in progress
            if (getState().contentId === contentId && getState().revision === revision && getState().cursor === cursor) return;
            setState({
                contentId: contentId,
                revision: revision,
                cursor: cursor,
                complete: false
            });
            let mode = contentRendererMode.toUpperCase();
            mode = window.location.pathname.startsWith('/wiki/pdf/') ? 'PDF' : mode;
            const selectedQuery = (0, $6mKj3.expValEquals)('confluence_fetch_appkey_field', 'isEnabled', true) ? $45c36e8dcd65ba05$export$47b47cc5b34ab476 : $45c36e8dcd65ba05$export$cab5f498ed530ce4;
            const queryVariables = {
                contentId: contentId,
                mode: mode,
                blocklist: (0, $ld6xp.getMultiMacroQueryBlocklistFF)(),
                first: !cursor ? $45c36e8dcd65ba05$var$DEFAULT_PRELOAD_PAGE_SIZE : $45c36e8dcd65ba05$var$DEFAULT_PAGE_SIZE,
                after: cursor
            };
            // don't include revision if in SSR otherwise it will cause a cache miss between
            // SSR preload where revision is unknown and SSR render when this action is called
            if (!useServerRenderedData) queryVariables.refetchToken = revision;
            let data;
            {
                const shouldUseServerRenderedData = useServerRenderedData && !getState().cursor;
                if (shouldUseServerRenderedData) try {
                    if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) {
                        data = readFragmentInterop({
                            id: `$ROOT_QUERY.macros(${JSON.stringify({
                                ...cursor ? {
                                    after: cursor
                                } : {},
                                blocklist: queryVariables.blocklist,
                                contentId: contentId,
                                first: queryVariables.first
                            })})`
                        });
                        // have fragment take on same shape as query result
                        if (data) data = {
                            macros: data
                        };
                    } else data = (0, $l1uFv.readQueryInterop)({
                        query: selectedQuery,
                        variables: queryVariables
                    });
                } catch (e) {
                    //do not report error when query returns empty result in SSR
                    if (e?.message && !e?.message.includes('Invariant Violation: 8')) (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                        attribution: 'backbone'
                    });
                }
                if (!data || !data?.macros || !shouldUseServerRenderedData) {
                    const result = await (0, $c0rhi.queryInterop)({
                        query: selectedQuery,
                        variables: queryVariables,
                        context: {
                            allowOnExternalPage: true
                        }
                    });
                    if (result.errors) {
                        (0, $5ZqQS.getMonitoringClient)().submitError(result.errors, {
                            attribution: 'backbone'
                        });
                        setState({
                            error: true
                        });
                    }
                    data = result.data;
                }
            }
            const { nodes: nodes = [], pageInfo: pageInfo = {} } = data?.macros;
            const macros = nodes?.reduce((nodeMap, node)=>{
                if (node) {
                    const key = $45c36e8dcd65ba05$var$getMacrosCacheKey(node.contentId || '', node.macroId || '');
                    nodeMap[key] = node?.renderedMacro;
                }
                return nodeMap;
            }, {});
            setState({
                macroData: {
                    ...getState().macroData,
                    ...macros
                }
            });
            if (pageInfo.hasNextPage) dispatch($45c36e8dcd65ba05$var$actions.queryMacros({
                contentId: contentId,
                contentRendererMode: contentRendererMode,
                featureFlags: featureFlags,
                cursor: pageInfo.endCursor,
                revision: revision,
                readFragmentInterop: readFragmentInterop
            }));
            else setState({
                complete: true
            });
        },
    //only for testing
    resetState: ()=>({ setState: setState })=>{
            setState({
                complete: false,
                data: {},
                macroData: {},
                error: false,
                contentId: undefined,
                revision: undefined,
                cursor: undefined
            });
        }
};
const $45c36e8dcd65ba05$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        complete: false,
        data: {},
        macroData: {},
        readFragmentInterop: ()=>null
    },
    actions: $45c36e8dcd65ba05$var$actions,
    name: 'MultiMacroQueryStore'
});
const $45c36e8dcd65ba05$export$ad5695738c93511d = (0, $FOT9i.createContainer)($45c36e8dcd65ba05$var$store, {
    onInit: ()=>({ dispatch: dispatch }, { contentId: contentId, contentRendererMode: contentRendererMode, featureFlags: featureFlags, cursor: cursor, revision: revision, useServerRenderedData: useServerRenderedData, readFragmentInterop: readFragmentInterop })=>{
            dispatch($45c36e8dcd65ba05$var$actions.queryMacros({
                contentId: contentId,
                contentRendererMode: contentRendererMode,
                featureFlags: featureFlags,
                cursor: cursor,
                revision: revision,
                useServerRenderedData: useServerRenderedData,
                readFragmentInterop: readFragmentInterop
            }));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { contentId: contentId, contentRendererMode: contentRendererMode, featureFlags: featureFlags, cursor: cursor, revision: revision, useServerRenderedData: useServerRenderedData, readFragmentInterop: readFragmentInterop })=>{
            dispatch($45c36e8dcd65ba05$var$actions.queryMacros({
                contentId: contentId,
                contentRendererMode: contentRendererMode,
                featureFlags: featureFlags,
                cursor: cursor,
                revision: revision,
                useServerRenderedData: useServerRenderedData,
                readFragmentInterop: readFragmentInterop
            }));
        }
});
function $45c36e8dcd65ba05$var$getMacrosCacheKey(contentId, macroId) {
    return `${contentId}::${macroId ?? 0}`;
}
function $45c36e8dcd65ba05$var$multiMacroQuerySelector(state, params) {
    const key = $45c36e8dcd65ba05$var$getMacrosCacheKey(params.contentId, params.macroId);
    const macroData = state.macroData?.[key];
    return {
        loading: !Boolean(macroData) && !state.complete,
        error: !Boolean(macroData) && state.error,
        renderedMacro: macroData || null,
        complete: state.complete
    };
}
const $45c36e8dcd65ba05$export$f830af87140a4bfc = (0, $9zUhf.createStateHook)($45c36e8dcd65ba05$var$store, {
    selector: $45c36e8dcd65ba05$var$multiMacroQuerySelector
});
const $45c36e8dcd65ba05$export$9c7903e1ca090053 = (0, $j1v0l.createSubscriber)($45c36e8dcd65ba05$var$store, {
    selector: $45c36e8dcd65ba05$var$multiMacroQuerySelector
});
const $45c36e8dcd65ba05$export$6e231e75b8fd307c = (0, $9zUhf.createHook)($45c36e8dcd65ba05$var$store);
module.exports["MultiMacroQueryContainer"] = $45c36e8dcd65ba05$export$ad5695738c93511d;
module.exports["useMultiMacroQuery"] = $45c36e8dcd65ba05$export$f830af87140a4bfc;
module.exports["MultiMacroQuerySubscriber"] = $45c36e8dcd65ba05$export$9c7903e1ca090053;

});

parcelRegister("dx8CK", function(module, exports) {
$parcel$export(module.exports, "referentialityPlugin", () => (parcelRequire("1bl0g")).referentialityPlugin);
$parcel$export(module.exports, "createReferentiality", () => (parcelRequire("1bl0g")).createReferentiality);
$parcel$export(module.exports, "dataSourceResolver", () => (parcelRequire("4xvYZ")).dataSourceResolver);
$parcel$export(module.exports, "DataSourceProvider", () => (parcelRequire("lEgye")).DataSourceProvider);
$parcel$export(module.exports, "useReference", () => (parcelRequire("eVKuj")).useReference);
$parcel$export(module.exports, "ADFReferenceTypes", () => (parcelRequire("gcCrc")).ADFReferenceTypes);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $1bl0g = parcelRequire("1bl0g");


var $4xvYZ = parcelRequire("4xvYZ");


var $lEgye = parcelRequire("lEgye");


var $eVKuj = parcelRequire("eVKuj");


var $gcCrc = parcelRequire("gcCrc");


var $9oPnF = parcelRequire("9oPnF");


});

parcelRegister("kksmx", function(module, exports) {
const $e82f7a932bbd9bed$export$66373c7c22b9de3c = '__LEGACY_MACRO_SSRED__';
const $e82f7a932bbd9bed$export$583da28e18e772e3 = (macroOutput, macroData)=>{
    if (macroOutput) return 'ssr-new';
    else if (macroData) return 'ssr-exp';
    return 'ssr-legacy';
};
const $e82f7a932bbd9bed$export$90da570939dfebac = (macroId)=>window[$e82f7a932bbd9bed$export$66373c7c22b9de3c]?.[macroId];
const $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c = ({ macroId: macroId, renderType: renderType })=>{
    return null;
};
module.exports["getRenderType"] = $e82f7a932bbd9bed$export$583da28e18e772e3;
module.exports["getExtensionSSRMark"] = $e82f7a932bbd9bed$export$90da570939dfebac;
module.exports["ExtensionSSRMark"] = $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c;

});

parcelRegister("9tVje", function(module, exports) {
/* MacroComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $iXCQx = parcelRequire("iXCQx");


var $cO1el = parcelRequire("cO1el");


var $inPa6 = parcelRequire("inPa6");


var $dZMVn = parcelRequire("dZMVn");


var $b1Jpy = parcelRequire("b1Jpy");


var $fwDOR = parcelRequire("fwDOR");


var $9VJDA = parcelRequire("9VJDA");


var $aoVih = parcelRequire("aoVih");


var $2Nwuj = parcelRequire("2Nwuj");


var $9wGTI = parcelRequire("9wGTI");


var $7khND = parcelRequire("7khND");


var $eQyFc = parcelRequire("eQyFc");

const $21c776825c39ac3f$var$i18n = (0, $cgtv4.defineMessages)({
    invalidAnchorMacroLabel: {
        id: "fabric-extension-lib.anchor.placeholder.icon-label",
        defaultMessage: "Invalid anchor link"
    },
    deprecatedExtensionPlaceholderTitle: {
        id: "fabric-extension-lib.deprecated-extension-placeholder.title",
        defaultMessage: "Deprecated macro"
    },
    deprecatedExtensionPlaceholderDescription: {
        id: "fabric-extension-lib.deprecated-extension-placeholder.description",
        defaultMessage: "The {macroName} macro is no longer available in Confluence Cloud."
    },
    deprecatedExtensionPlaceholderLink: {
        id: "fabric-extension-lib.deprecated-extension-placeholder.link",
        defaultMessage: "Learn more."
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21c776825c39ac3f$var$ItemBody = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $21c776825c39ac3f$var$descriptionStyledSelector = 'description-styled-selector'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21c776825c39ac3f$var$Description = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syazazsu _19pk1b66",
            __cmplp.className
        ])
    });
});
$21c776825c39ac3f$var$Description.defaultProps = {
    'data-styled-selector': $21c776825c39ac3f$var$descriptionStyledSelector
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21c776825c39ac3f$var$Item = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditor: isEditor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7vuon _2rkofajl _1e0c1txw _4cvr1h6o",
            __cmplp.isEditor ? "_1yt41ejb" : "_1yt4ze3t",
            __cmplp.className
        ])
    });
});
const $21c776825c39ac3f$var$InlineItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7ysee _1yt41m6u _2rkofajl _11c81d4k _1e0c116y _4cvr1h6o _1xw2u2gc",
            __cmplp.className
        ])
    });
});
const $21c776825c39ac3f$var$ItemIcon = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $7sObp.default)(__cmplp.width, "px"),
            "--_8jvb0j": (0, $7sObp.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _19it1l7x _2rkofajl _11q7vuon _1bsb1rkg _4t3i1474 _vchhusvi _1e0c1txw _1bah1h6o _4cvr1h6o _1qwg1rkg _1iia1474",
            __cmplp.width > 32 ? "_2hwxpxbi" : "_2hwx1b66",
            __cmplp.className
        ])
    });
});
const $21c776825c39ac3f$var$anchorMacroPlaceholderStyles = null;
const $21c776825c39ac3f$export$860ffd8664f09722 = (macro, testId)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7khND.MacroIcon), {
        macro: macro,
        testId: testId
    });
};
const $21c776825c39ac3f$export$19993a849e770b01 = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko12b0 _1e0c1txw _1bah1h6o _4cvr1h6o _bfhki8nm _1bsb1tcg _4t3igktf _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZMVn))), {
        label: intl.formatMessage($21c776825c39ac3f$var$i18n.invalidAnchorMacroLabel),
        color: "var(--ds-icon-danger, #C9372C)"
    }));
};
const $21c776825c39ac3f$var$InlineExtensionPlaceholder = ({ macro: macro, description: description })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "inline-extension-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$var$InlineItem, {
        "data-testid": "inline-extension-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$var$ItemIcon, {
        width: 16,
        height: 16
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7khND.MacroIcon), {
        macro: macro,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$var$ItemBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, macro.title, description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$var$Description, null, description)))));
};
const $21c776825c39ac3f$export$9aa94f8845c5044a = ({ macro: macro, description: description, isEditor: isEditor })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "extension-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$var$Item, {
        isEditor: isEditor,
        "data-testid": "extension-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$var$ItemIcon, {
        width: 40,
        height: 40
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7khND.MacroIcon), {
        macro: macro,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$var$ItemBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small"
    }, macro.title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$var$Description, null, description))));
};
const $21c776825c39ac3f$export$58aff0a49290c040 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
    id: "confluence-fabric-editor.extension.placeholder.missing-config",
    defaultMessage: "Edit to setup"
});
const $21c776825c39ac3f$var$PlaceholderWithAnalytics = ({ macro: macro, extension: extension, isEditor: isEditor })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useMemo)(()=>{
        if (createAnalyticsEvent) {
            const { extensionKey: extensionKey, extensionType: extensionType, parameters: parameters } = extension;
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'viewed',
                    actionSubject: 'macro',
                    actionSubjectId: 'placeholder',
                    source: isEditor ? 'editor' : 'renderer',
                    attributes: {
                        extensionKey: extensionKey,
                        extensionType: extensionType,
                        isMissingRequiredParameters: !!parameters?.macroParams?.isMissingRequiredParameters
                    }
                }
            }).fire();
        } // NOTE: `extension` node changes on resize so can't use it as dependency
    // A deep check can be done using `extension.macroMetadata.macroId` though not needed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        macro,
        isEditor
    ]);
    if (macro.macroName === 'anchor') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$export$19993a849e770b01, null);
    if ((0, $eQyFc.getExtensionBodyType)(macro) === 'inlineExtension') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$var$InlineExtensionPlaceholder, {
        macro: macro,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, "(", $21c776825c39ac3f$export$58aff0a49290c040, ")")
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$export$9aa94f8845c5044a, {
        isEditor: isEditor,
        macro: macro,
        description: $21c776825c39ac3f$export$58aff0a49290c040
    });
};
const $21c776825c39ac3f$export$267f67275f4dde5c = (macro, extension, isEditor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1Jpy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$var$PlaceholderWithAnalytics, {
        macro: macro,
        extension: extension,
        isEditor: isEditor
    }));
const $21c776825c39ac3f$export$cefccc00343a8c80 = (macro, type, isLivePage)=>{
    if (type === 'inlineExtension') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1Jpy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$var$InlineExtensionPlaceholder, {
        macro: macro
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1Jpy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c776825c39ac3f$export$9aa94f8845c5044a, {
        isEditor: true,
        macro: macro,
        description: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "confluence-fabric-editor.extension.placeholder.can-not-render-in-live-page-editor",
            defaultMessage: "The results of this element aren\u2019t visible when editing a live doc. Convert this doc to a page and publish it via the <menuIcon></menuIcon> menu to display it fully.",
            values: {
                menuIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        label: "Icon for publish menu"
                    })
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "confluence-fabric-editor.extension.placeholder.can-not-render-in-editor",
            defaultMessage: "The results of this element aren\u2019t visible when editing. Preview the page or publish it to see how it will look."
        })
    }));
};
const $21c776825c39ac3f$var$deprecatedExtensionPlaceholderStyles = null;
const $21c776825c39ac3f$export$a1346a71a86c0a6f = ({ macroName: macroName })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1Jpy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_11c8i4vh"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "warning",
        title: formatMessage($21c776825c39ac3f$var$i18n.deprecatedExtensionPlaceholderTitle),
        testId: "deprecated-extension-placeholder"
    }, formatMessage($21c776825c39ac3f$var$i18n.deprecatedExtensionPlaceholderDescription, {
        macroName: macroName
    }), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: "https://community.atlassian.com/forums/Confluence-articles/Deprecating-infrequently-used-macros-in-Confluence-Cloud/ba-p/2981360"
    }, formatMessage($21c776825c39ac3f$var$i18n.deprecatedExtensionPlaceholderLink)))));
};
module.exports["getIconComponent"] = $21c776825c39ac3f$export$860ffd8664f09722;
module.exports["AnchorMacroPlaceholder"] = $21c776825c39ac3f$export$19993a849e770b01;
module.exports["ExtensionPlaceholder"] = $21c776825c39ac3f$export$9aa94f8845c5044a;
module.exports["editToSetupMessage"] = $21c776825c39ac3f$export$58aff0a49290c040;
module.exports["getMissingConfigPlaceholderComponent"] = $21c776825c39ac3f$export$267f67275f4dde5c;
module.exports["getNonRenderablePlaceholderComponent"] = $21c776825c39ac3f$export$cefccc00343a8c80;
module.exports["DeprecatedExtensionPlaceholder"] = $21c776825c39ac3f$export$a1346a71a86c0a6f;

});

parcelRegister("7khND", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");


var $6bJyJ = parcelRequire("6bJyJ");


var $jdPfT = parcelRequire("jdPfT");


var $kevJM = parcelRequire("kevJM");


var $av0Vd = parcelRequire("av0Vd");


var $4wwVl = parcelRequire("4wwVl");


var $6767u = parcelRequire("6767u");


var $1bY7o = parcelRequire("1bY7o");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");




const $af996b54de444f03$var$baseStyles = null;
const $af996b54de444f03$export$e64a53b8ea246fd3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(17);
    const t0 = props.label || undefined;
    const t1 = props.label ? "img" : "presentation";
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lswu7qp0 _lcxvglyw _1bsbzwfg _4t3izwfg _vc881r31"
        ]);
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "6",
            y: "7",
            width: "23",
            height: "18",
            rx: "2",
            fill: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "9",
            y: "10",
            width: "2",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "13",
            y: "10",
            width: "13",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "9",
            y: "15",
            width: "2",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "13",
            y: "15",
            width: "13",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "9",
            y: "20",
            width: "2",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "13",
            y: "20",
            width: "13",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "6",
            y: "2",
            width: "23",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "6",
            y: "28",
            width: "23",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M3 3.5L2 2.5",
            stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
            strokeLinecap: "round"
        });
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M3 3.5L4 2.5",
            stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
            strokeLinecap: "round"
        });
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M3.5 29L2.5 30",
            stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
            strokeLinecap: "round"
        });
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M3.5 29L2.5 28",
            stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
            strokeLinecap: "round"
        });
        $[0] = t10;
        $[1] = t11;
        $[2] = t12;
        $[3] = t13;
        $[4] = t14;
        $[5] = t15;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else {
        t10 = $[0];
        t11 = $[1];
        t12 = $[2];
        t13 = $[3];
        t14 = $[4];
        t15 = $[5];
        t2 = $[6];
        t3 = $[7];
        t4 = $[8];
        t5 = $[9];
        t6 = $[10];
        t7 = $[11];
        t8 = $[12];
        t9 = $[13];
    }
    let t16;
    if ($[14] !== t0 || $[15] !== t1) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "child-macro-icon",
            "aria-label": t0,
            role: t1,
            className: t2
        }, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15);
        $[14] = t0;
        $[15] = t1;
        $[16] = t16;
    } else t16 = $[16];
    return t16;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "child-macro-icon",
        "aria-label": props.label || undefined,
        role: props.label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lswu7qp0 _lcxvglyw _1bsbzwfg _4t3izwfg _vc881r31"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "6",
        y: "7",
        width: "23",
        height: "18",
        rx: "2",
        fill: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "9",
        y: "10",
        width: "2",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "13",
        y: "10",
        width: "13",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "9",
        y: "15",
        width: "2",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "13",
        y: "15",
        width: "13",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "9",
        y: "20",
        width: "2",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "13",
        y: "20",
        width: "13",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "6",
        y: "2",
        width: "23",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "6",
        y: "28",
        width: "23",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3 3.5L2 2.5",
        stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3 3.5L4 2.5",
        stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3.5 29L2.5 30",
        stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3.5 29L2.5 28",
        stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
        strokeLinecap: "round"
    }));














const $2d33a6ba968a8025$var$baseStyles = null;
const $2d33a6ba968a8025$export$23d9ef6647bbd44d = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(13);
    const t0 = props.label || undefined;
    const t1 = props.label ? "img" : "presentation";
    let t10;
    let t11;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lswu7qp0 _lcxvglyw _1bsbzwfg _4t3izwfg _vc881r31"
        ]);
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "12",
            y: "8",
            width: "22",
            height: "16",
            rx: "2",
            fill: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "15",
            y: "15",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "15",
            y: "11",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "15",
            y: "4",
            width: "19",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "15",
            y: "30",
            width: "19",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "15",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "15",
            y: "26",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "15",
            y: "19",
            width: "10",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.8965 12.8966C5.85003 12.943 5.81316 12.9981 5.788 13.0588C5.76285 13.1195 5.7499 13.1845 5.7499 13.2501C5.7499 13.3158 5.76285 13.3808 5.788 13.4415C5.81316 13.5021 5.85003 13.5572 5.8965 13.6036L7.793 15.5001H3C2.86739 15.5001 2.74021 15.5528 2.64645 15.6466C2.55268 15.7404 2.5 15.8675 2.5 16.0001C2.5 16.1328 2.55268 16.2599 2.64645 16.3537C2.74021 16.4475 2.86739 16.5001 3 16.5001H7.793L5.8965 18.3966C5.85003 18.443 5.81316 18.4981 5.788 18.5588C5.76285 18.6195 5.7499 18.6845 5.7499 18.7501C5.7499 18.8158 5.76285 18.8808 5.788 18.9415C5.81316 19.0021 5.85003 19.0572 5.8965 19.1036C6.0915 19.2986 6.4085 19.2986 6.604 19.1036L9.3535 16.3536C9.44405 16.2634 9.49649 16.1419 9.5 16.0141V15.9856C9.49642 15.858 9.44398 15.7367 9.3535 15.6466L6.604 12.8966C6.55756 12.8502 6.50242 12.8133 6.44172 12.7881C6.38102 12.763 6.31596 12.75 6.25025 12.75C6.18454 12.75 6.11948 12.763 6.05878 12.7881C5.99808 12.8133 5.94294 12.8502 5.8965 12.8966V12.8966Z",
            fill: "var(--ds-icon, #292A2E)"
        });
        $[0] = t10;
        $[1] = t11;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
    } else {
        t10 = $[0];
        t11 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
        t8 = $[8];
        t9 = $[9];
    }
    let t12;
    if ($[10] !== t0 || $[11] !== t1) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            viewBox: "0 0 34 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "excerpt-include-macro-icon",
            "aria-label": t0,
            role: t1,
            className: t2
        }, t3, t4, t5, t6, t7, t8, t9, t10, t11);
        $[10] = t0;
        $[11] = t1;
        $[12] = t12;
    } else t12 = $[12];
    return t12;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 34 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "excerpt-include-macro-icon",
        "aria-label": props.label || undefined,
        role: props.label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lswu7qp0 _lcxvglyw _1bsbzwfg _4t3izwfg _vc881r31"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "12",
        y: "8",
        width: "22",
        height: "16",
        rx: "2",
        fill: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "15",
        y: "15",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "15",
        y: "11",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "15",
        y: "4",
        width: "19",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "15",
        y: "30",
        width: "19",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "15",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "15",
        y: "26",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "15",
        y: "19",
        width: "10",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.8965 12.8966C5.85003 12.943 5.81316 12.9981 5.788 13.0588C5.76285 13.1195 5.7499 13.1845 5.7499 13.2501C5.7499 13.3158 5.76285 13.3808 5.788 13.4415C5.81316 13.5021 5.85003 13.5572 5.8965 13.6036L7.793 15.5001H3C2.86739 15.5001 2.74021 15.5528 2.64645 15.6466C2.55268 15.7404 2.5 15.8675 2.5 16.0001C2.5 16.1328 2.55268 16.2599 2.64645 16.3537C2.74021 16.4475 2.86739 16.5001 3 16.5001H7.793L5.8965 18.3966C5.85003 18.443 5.81316 18.4981 5.788 18.5588C5.76285 18.6195 5.7499 18.6845 5.7499 18.7501C5.7499 18.8158 5.76285 18.8808 5.788 18.9415C5.81316 19.0021 5.85003 19.0572 5.8965 19.1036C6.0915 19.2986 6.4085 19.2986 6.604 19.1036L9.3535 16.3536C9.44405 16.2634 9.49649 16.1419 9.5 16.0141V15.9856C9.49642 15.858 9.44398 15.7367 9.3535 15.6466L6.604 12.8966C6.55756 12.8502 6.50242 12.8133 6.44172 12.7881C6.38102 12.763 6.31596 12.75 6.25025 12.75C6.18454 12.75 6.11948 12.763 6.05878 12.7881C5.99808 12.8133 5.94294 12.8502 5.8965 12.8966V12.8966Z",
        fill: "var(--ds-icon, #292A2E)"
    }));














const $058eb04dbe2ca1ce$var$baseStyles = null;
const $058eb04dbe2ca1ce$export$49f2115fcc129894 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(12);
    const t0 = props.label || undefined;
    const t1 = props.label ? "img" : "presentation";
    let t10;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lswu7qp0 _lcxvglyw _1bsbzwfg _4t3izwfg _vc881r31"
        ]);
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "5",
            y: "8",
            width: "22",
            height: "16",
            rx: "2",
            fill: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "8",
            y: "15",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "8",
            y: "11",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "8",
            y: "4",
            width: "19",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "8",
            y: "30",
            width: "19",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "8",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "8",
            y: "26",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            x: "8",
            y: "19",
            width: "10",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        $[0] = t10;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
    } else {
        t10 = $[0];
        t2 = $[1];
        t3 = $[2];
        t4 = $[3];
        t5 = $[4];
        t6 = $[5];
        t7 = $[6];
        t8 = $[7];
        t9 = $[8];
    }
    let t11;
    if ($[9] !== t0 || $[10] !== t1) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "excerpt-macro-icon",
            "aria-label": t0,
            role: t1,
            className: t2
        }, t3, t4, t5, t6, t7, t8, t9, t10);
        $[9] = t0;
        $[10] = t1;
        $[11] = t11;
    } else t11 = $[11];
    return t11;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "excerpt-macro-icon",
        "aria-label": props.label || undefined,
        role: props.label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lswu7qp0 _lcxvglyw _1bsbzwfg _4t3izwfg _vc881r31"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "5",
        y: "8",
        width: "22",
        height: "16",
        rx: "2",
        fill: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "8",
        y: "15",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "8",
        y: "11",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "8",
        y: "4",
        width: "19",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "8",
        y: "30",
        width: "19",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "8",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "8",
        y: "26",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "8",
        y: "19",
        width: "10",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }));



var $cb6fO = parcelRequire("cb6fO");

const $efa2272178ef68ba$var$sizeMap = {
    small: 24,
    medium: 32,
    large: 48
};
const $efa2272178ef68ba$var$getSizeInPx = (size)=>$efa2272178ef68ba$var$sizeMap[size];
function $efa2272178ef68ba$export$ead5ed1f51ad51dc({ macro: macro, size: size = 'small', testId: testId }) {
    const { icon: icon, macroName: macroName } = macro;
    switch(macroName){
        case 'children':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $af996b54de444f03$export$e64a53b8ea246fd3), {
                label: ""
            });
        case 'excerpt':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $058eb04dbe2ca1ce$export$49f2115fcc129894), {
                label: ""
            });
        case 'excerpt-include':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2d33a6ba968a8025$export$23d9ef6647bbd44d), {
                label: ""
            });
        case 'recently-updated':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                color: "var(--ds-icon, #292A2E)",
                label: "",
                spacing: "spacious",
                testId: "recently-updated-macro-icon"
            });
        case 'contentbylabel':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($av0Vd))), {
                color: "var(--ds-icon, #292A2E)",
                label: "",
                spacing: "spacious",
                testId: "contentbylabel-macro-icon"
            });
        case 'profile-picture':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4wwVl))), {
                label: "",
                spacing: "spacious",
                testId: "profile-picture-icon"
            });
        case 'profile':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                label: "",
                spacing: "spacious",
                testId: "profile-icon"
            });
        case 'toc':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                label: "",
                testId: "toc-icon",
                spacing: "spacious"
            });
        case 'jira':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: "",
                size: "medium",
                "data-testid": testId
            });
        case 'anchor':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: "",
                spacing: "spacious",
                testId: "anchor-link-icon"
            });
    }
    if (!icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: "",
        spacing: "spacious",
        testId: "default-icon"
    });
    // connect macros will have absolute urls while others
    // will have relative
    const src = (0, $cb6fO.getContextAwareFullPath)(icon.location, true);
    const sizeInPx = $efa2272178ef68ba$var$getSizeInPx(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: src,
        width: sizeInPx,
        height: sizeInPx,
        alt: "",
        "data-testid": testId
    });
}
const $efa2272178ef68ba$export$6185d2f1146c633c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "4",
        cy: "4",
        r: "4",
        fill: "var(--ds-icon, #292A2E)"
    }));
const $efa2272178ef68ba$export$3053c37f1e2867f2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "4",
        cy: "4",
        r: "3.5",
        stroke: "var(--ds-icon, #292A2E)"
    }));
const $efa2272178ef68ba$export$ae8f25be6d60cbf3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4Z",
        fill: "var(--ds-icon, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9 13.9V16C9 16.5523 9.44772 17 10 17H15C15.5523 17 16 16.5523 16 16V11C16 10.4477 15.5523 10 15 10H12.9C12.5023 11.9591 10.9591 13.5023 9 13.9Z",
        fill: "var(--ds-icon, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M4 8.99997C4 11.2091 5.79086 13 8 13C10.2091 13 12 11.2091 12 8.99997C12 7.09292 10.6654 5.49757 8.87929 5.09692C8.80495 5.42907 8.69755 5.74873 8.56074 6.05229C9.9496 6.31488 11 7.53476 11 8.99997C11 10.6568 9.65685 12 8 12C6.34315 12 5 10.6568 5 8.99997C5 8.96639 5.00055 8.93293 5.00165 8.89962C4.67803 8.96542 4.34305 8.99997 4 8.99997Z",
        fill: "var(--ds-icon, #292A2E)"
    }));
const $efa2272178ef68ba$export$c4da8a84cd30471c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "10",
        height: "11",
        viewBox: "0 0 10 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3.41016 10H4.64062V0.135742H3.41699L0.791992 2.02246V3.32129L3.30078 1.50293H3.41016V10ZM8.22266 10.0684C8.71484 10.0684 9.11133 9.66504 9.11133 9.17969C9.11133 8.6875 8.71484 8.29102 8.22266 8.29102C7.7373 8.29102 7.33398 8.6875 7.33398 9.17969C7.33398 9.66504 7.7373 10.0684 8.22266 10.0684Z",
        fill: "var(--ds-icon, #292A2E)"
    }));
const $efa2272178ef68ba$export$d67733307fd2aff1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "8",
        height: "8",
        rx: "1",
        fill: "var(--ds-icon, #292A2E)"
    }));
const $efa2272178ef68ba$export$2be9fd0fc1da44cd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1.80648 7.77764V9.55542C1.80648 10.2037 2.06826 10.8254 2.53401 11.2837C2.99977 11.7423 3.63154 11.9997 4.2904 11.9997H4.96785V10.6665H4.2904C3.99098 10.6665 3.70384 10.5493 3.49198 10.341C3.28029 10.1327 3.16137 9.85009 3.16137 9.55541V7.77764C3.16011 7.10412 2.87676 6.46084 2.37775 5.99986C2.87674 5.53888 3.16008 4.8956 3.16137 4.22209V2.44431C3.16137 2.14964 3.28029 1.86706 3.49198 1.65873C3.70383 1.45041 3.99097 1.33322 4.2904 1.33322H4.96785V0H4.2904C3.63154 0 2.99977 0.257466 2.53401 0.715975C2.06825 1.17434 1.80648 1.79607 1.80648 2.44431V4.22208C1.80648 4.51675 1.68756 4.79933 1.47587 5.00782C1.26402 5.21615 0.976884 5.33318 0.677452 5.33318H0V6.66656H0.677452C0.976876 6.66656 1.26402 6.78359 1.47587 6.99191C1.68756 7.2004 1.80648 7.48297 1.80648 7.77764Z",
        fill: "var(--ds-icon, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.1936 4.2222V2.44443C12.1936 1.79619 11.9318 1.17446 11.4661 0.716097C11.0003 0.257576 10.3685 0.00012207 9.70968 0.00012207H9.03223V1.3335H9.70968V1.33335C10.0091 1.33335 10.2962 1.45053 10.5081 1.65886C10.7198 1.86719 10.8387 2.14976 10.8387 2.44444V4.22221C10.84 4.89573 11.1233 5.53901 11.6223 5.99999C11.1233 6.46097 10.84 7.10425 10.8387 7.77776V9.55554C10.8387 9.85021 10.7198 10.1328 10.5081 10.3411C10.2962 10.5494 10.0091 10.6666 9.70968 10.6666H9.03223V12H9.70968V11.9999C10.3685 11.9999 11.0003 11.7424 11.4661 11.2839C11.9318 10.8255 12.1936 10.2038 12.1936 9.55555V7.77777C12.1936 7.4831 12.3125 7.20052 12.5242 6.99204C12.7361 6.78371 13.0232 6.66668 13.3226 6.66668H14.0001V5.3333H13.3226C13.0232 5.3333 12.7361 5.21627 12.5242 5.00794C12.3125 4.79946 12.1936 4.51688 12.1936 4.2222Z",
        fill: "var(--ds-icon, #292A2E)"
    }));
const $efa2272178ef68ba$export$4298d94e565d5e99 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "12",
        height: "14",
        viewBox: "0 0 12 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M4 1.5H1V12.5H4",
        stroke: "var(--ds-icon, #292A2E)",
        strokeWidth: "1.25"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 12.5H11L11 1.5H8",
        stroke: "var(--ds-icon, #292A2E)",
        strokeWidth: "1.25"
    }));
const $efa2272178ef68ba$export$2a8d2000f2d39e17 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "2",
        height: "12",
        viewBox: "0 0 2 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("line", {
        x1: "0.625",
        y1: "2.73196e-08",
        x2: "0.624999",
        y2: "12",
        stroke: "var(--ds-icon, #292A2E)",
        strokeWidth: "1.25"
    }));
function $efa2272178ef68ba$export$fae4d9254a21fe54({ icon: icon, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: 16,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: 16,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center'
        },
        "data-testId": testId
    }, icon());
}
module.exports["MacroIcon"] = $efa2272178ef68ba$export$ead5ed1f51ad51dc;
module.exports["BulletSVG"] = $efa2272178ef68ba$export$6185d2f1146c633c;
module.exports["CircleSVG"] = $efa2272178ef68ba$export$3053c37f1e2867f2;
module.exports["DiscSVG"] = $efa2272178ef68ba$export$ae8f25be6d60cbf3;
module.exports["NumberedSVG"] = $efa2272178ef68ba$export$c4da8a84cd30471c;
module.exports["SquareSVG"] = $efa2272178ef68ba$export$d67733307fd2aff1;
module.exports["BraceSVG"] = $efa2272178ef68ba$export$2be9fd0fc1da44cd;
module.exports["BracketSVG"] = $efa2272178ef68ba$export$4298d94e565d5e99;
module.exports["PipeSVG"] = $efa2272178ef68ba$export$2a8d2000f2d39e17;
module.exports["DropdownIcon"] = $efa2272178ef68ba$export$fae4d9254a21fe54;

});

parcelRegister("eQyFc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $foRF9 = parcelRequire("foRF9");


var $8pcS0 = parcelRequire("8pcS0");


var $9tVje = parcelRequire("9tVje");


var $e7owm = parcelRequire("e7owm");


var $2E7zk = parcelRequire("2E7zk");

const $60c753854e7a0ebe$export$36f7c0c22d0fa7f7 = (macro)=>macro.alternateId || macro.macroName;
const $60c753854e7a0ebe$export$a508225d9b2c6590 = (macro)=>{
    const { bodyType: bodyType, outputType: outputType } = macro.formDetails.body;
    if (bodyType === 'MULTI_BODY_RICH_TEXT') return 0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE;
    //        none  plain   rich
    // block   ext   ext    body
    // inline  in    in     body
    if (bodyType === 'RICH_TEXT') return 0, $8pcS0.BODIED_EXTENSION_TYPE;
    if (outputType === 'INLINE') return 0, $8pcS0.INLINE_EXTENSION_TYPE;
    return 0, $8pcS0.REGULAR_EXTENSION_TYPE;
};
const $60c753854e7a0ebe$export$4588099541e0954d = (macro)=>{
    return {
        '48': ()=>Promise.resolve(()=>(0, $9tVje.getIconComponent)(macro))
    };
};
const $60c753854e7a0ebe$export$e5e6ffc5fb5056d0 = (macro)=>macro.formDetails && (macro.formDetails.parameters || []).filter((parameter)=>!parameter.hidden) || [];
const $60c753854e7a0ebe$var$hasParameter = (paramName, extension, macro)=>{
    if (extension && extension.parameters && extension.parameters.macroParams) {
        const params = (0, $e7owm.transformParams)('transformBefore', macro, {
            ...extension.parameters.macroParams
        });
        if (paramName in params) {
            let value = params[paramName];
            if (typeof value === 'object' && value !== null && value.hasOwnProperty('value')) value = value.value;
            return (0, $2E7zk.isValueSet)(value);
        }
    }
    return false;
};
const $60c753854e7a0ebe$export$28f78411e8f58606 = (macro, extension)=>macro.formDetails.parameters.some((param)=>param.required && param.defaultValue === null && !param.hidden && !$60c753854e7a0ebe$var$hasParameter(param.name, extension, macro));
const $60c753854e7a0ebe$export$c311b87e097682ae = (macroDefinition, contentId, selectedMacro, intl, isLivePagesFeatureEnabled)=>{
    return (0, $foRF9.fetchMacroAttributes)({
        macroDefinition: {
            name: name,
            body: '',
            params: {},
            ...macroDefinition
        },
        contentId: contentId,
        selectedMacro: selectedMacro,
        intl: intl,
        isLivePagesFeatureEnabled: isLivePagesFeatureEnabled
    });
};
const $60c753854e7a0ebe$export$40ec622ba9bb94df = (macro)=>{
    switch(macro.macroName){
        case 'pagetree':
            // pagetree is not spa friendly and will only work sometimes
            return false;
        default:
            return true;
    }
};
const $60c753854e7a0ebe$export$34e22dfe340bc2f0 = (macro, excluded = [])=>{
    // This is to opt-out a macro quickly from the new experience
    // using the list in `next/packages/editor-features/src/featureFlagsUtils.ts`
    if (excluded.includes(macro.macroName)) return true;
    // Plain text macros are not supported yet
    if (macro.formDetails.body.bodyType === 'PLAIN_TEXT') return true;
    return macro.customConfigEditor;
};
const $60c753854e7a0ebe$export$96720d404c402c6d = (macro)=>{
    // Need to force config for Plain text macros
    if (macro.formDetails.body.bodyType === 'PLAIN_TEXT') return true;
    switch(macro.macroName){
        // CFE-2344: despite not having a required parameter, the children macro should open the macro browser
        // so that the user can select a parent page. Without this, on a brand new page, the children display
        // macro renders a loading state, then completely disappears and looks broken.
        case 'children':
        // CONFDEV-62041: tasks report macro also doesn't have a required parameter, but without any parameters
        // it tries to search the entirety of Confluence for tasks and usually times out, so let's ask for parameters anyway.
        case 'tasks-report-macro':
            // Has issues.
            return true;
        default:
            return macro.customConfigEditor;
    }
};
const $60c753854e7a0ebe$export$b6c9e4779dda4acf = (macro, excludedMacros = [], extension, isEditor)=>// NOTE: Since it's not possible to insert macros without required fields using
    // Macro Browser so there's no point of showing placeholder for them. @see ED-12141
    !$60c753854e7a0ebe$export$34e22dfe340bc2f0(macro, excludedMacros) && // Maintaining the anchor's unique(?) status as a non-rendering-in-publish-view macro
    (isEditor || macro.macroName !== 'anchor') && // Missing required parameters
    $60c753854e7a0ebe$export$28f78411e8f58606(macro, extension);
const $60c753854e7a0ebe$export$d682580434d7a14b = (macro)=>{
    return {
        type: (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE,
        key: macro.macroName,
        title: macro.title,
        description: macro.description,
        icons: $60c753854e7a0ebe$export$4588099541e0954d(macro),
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    async preloadRender () {
                    // Intentionally left empty. But the function needs to be defined
                    },
                    renderSync () {
                        return ()=>{
                            const macroTitle = macro.title.replace(' (Deprecated)', '');
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9tVje.DeprecatedExtensionPlaceholder), {
                                macroName: macroTitle
                            });
                        };
                    },
                    async render () {
                        return this.renderSync();
                    }
                }
            }
        }
    };
};
module.exports["safeGetMacroName"] = $60c753854e7a0ebe$export$36f7c0c22d0fa7f7;
module.exports["getExtensionBodyType"] = $60c753854e7a0ebe$export$a508225d9b2c6590;
module.exports["buildIconObject"] = $60c753854e7a0ebe$export$4588099541e0954d;
module.exports["getVisibleParameters"] = $60c753854e7a0ebe$export$e5e6ffc5fb5056d0;
module.exports["isMissingAnyRequiredParameters"] = $60c753854e7a0ebe$export$28f78411e8f58606;
module.exports["prepareMacro"] = $60c753854e7a0ebe$export$c311b87e097682ae;
module.exports["canRenderInTheEditor"] = $60c753854e7a0ebe$export$40ec622ba9bb94df;
module.exports["shouldUseMacroBrowser"] = $60c753854e7a0ebe$export$34e22dfe340bc2f0;
module.exports["needsToForceConfig"] = $60c753854e7a0ebe$export$96720d404c402c6d;
module.exports["shouldShowPlaceholder"] = $60c753854e7a0ebe$export$b6c9e4779dda4acf;

});

parcelRegister("e7owm", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

// These transformers will run for all macros
const $cea6135e7e84bafe$export$6a5670d7122d77e8 = {
    transformBefore (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            const value = params[key];
            if (field.type.name === 'cql' && typeof value === 'string' && value.length) // Required to migrate old macros inserted via Macro Browser since
            // new config doesn't support . [dot] in field name. For more context @see ED-12857
            params[key] = value.replace(/(contributor|creator|mention)\.accountid = /g, '$1 = ');
        });
        return params;
    }
};


const $8af95a90f3d439a2$export$3fb54149990fb5b5 = {
    transformBefore (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            if (field?.type?.name === 'boolean' && params[key] !== undefined) params[key] = params[key] === 'false' ? false : !!params[key];
        });
        return params;
    }
};


const $c7a8c4deae65a41e$export$6a4d6155f720c963 = {
    transformAfter (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            let remove = false;
            if (field && // Ideally required field shouldn't have defaultValue but it's "macro" ¯\_(ツ)_/¯
            !field.required) {
                // Default behavior
                if (field.defaultValue === params[key]) remove = true;
                else if (field.type.name === 'boolean' && (field.defaultValue === 'false' && params[key] === false || field.defaultValue === 'true' && params[key] === true)) remove = true;
                else if (field.type.name === 'string' && field.defaultValue === null && params[key] === '') remove = true;
            }
            if (remove) delete params[key];
        });
        return params;
    }
};


const $12bc2881105e54ac$export$981278bf1b2aa327 = {
    // Transform all empty keys ([""]) to `defaultParameterValue`
    transformBefore (params, metadata) {
        if (params[''] != null) {
            params.defaultParameterValue = params[''];
            metadata.defaultParameterValue = metadata[''];
        }
        return params;
    },
    // Transforming them back to [""] here.
    transformAfter (params, metadata) {
        if (params.defaultParameterValue != null) {
            params[''] = params.defaultParameterValue;
            metadata[''] = metadata.defaultParameterValue;
            delete params.defaultParameterValue;
        }
        return params;
    }
};


const $9fdcf181e9622d09$var$FIELD_TYPES_TO_FIX = [
    'username',
    'spacekey',
    'enum',
    'label'
];
const $9fdcf181e9622d09$export$e022d5efa3e02dee = {
    transformBefore (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            const value = params[key];
            if (field?.multiple && value !== undefined && typeof value === 'string' && $9fdcf181e9622d09$var$FIELD_TYPES_TO_FIX.includes(field.type.name)) params[key] = value.split(',');
        });
        return params;
    },
    transformAfter (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            const value = params[key];
            if (field?.multiple && Array.isArray(value) && $9fdcf181e9622d09$var$FIELD_TYPES_TO_FIX.includes(field.type.name)) params[key] = value.join(',');
        });
        return params;
    }
};



var $2E7zk = parcelRequire("2E7zk");

/**
 * There is a transformation on data that is happening for tasks report macro that deletes the combined field of spaceAndPage
 * https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/browse/confluence/next/packages/fabric-extension-lib/src/providers/macros/field-mappings/tasks-report.ts#90
 * This code runs prior to the missingRequiredParameters check at causes the check to fail.
 * To properly check if the field is set we need to check the renamed fields.
 * This check may be used for any other renamed parameters.
 */ const $485f60cc477809b5$var$COMPOUND_FIELD_MAP = {
    spaceAndPage: [
        'space',
        'page'
    ]
};
function $485f60cc477809b5$var$checkValueSet(key, params) {
    if (!$485f60cc477809b5$var$COMPOUND_FIELD_MAP[key]) return (0, $2E7zk.isValueSet)(params[key]);
    return (0, $2E7zk.isValueSet)(params[key]) || $485f60cc477809b5$var$COMPOUND_FIELD_MAP[key].some((subfield)=>(0, $2E7zk.isValueSet)(params[subfield]));
}
const $485f60cc477809b5$export$af7e7c08e5e55c8f = {
    transformAfter (params, metadata) {
        if (Object.entries(metadata).some(([key, field])=>// NOTE: CQL has default value inside `field.options.defaultFields`
            // But it doesn't work now
            field && field.required && field.defaultValue == null && !field.hidden && !$485f60cc477809b5$var$checkValueSet(key, params))) params.isMissingRequiredParameters = true;
        return params;
    }
};


const $35b63f91264cd025$export$d68957b367f91137 = (...transformers)=>({
        transformFields: (fields, pageContext, intl)=>transformers.reduce(async (transformedFields, transformer)=>{
                // We await transformedFields accumulator because transformFields returns a Promise<FieldDefinition[] | DynamicFieldDefinitions>
                const fieldsResult = await transformedFields;
                return transformer.transformFields ? transformer.transformFields({
                    fields: fieldsResult,
                    pageContext: pageContext,
                    intl: intl
                }) // Call transformFields on fields if it exists
                 : transformedFields; // Otherwise, return the original fields with any applied transformations thus far
            }, Promise.resolve(fields)),
        transformBefore: (params, metadata, pageContext)=>transformers.reduce((params, transformer)=>transformer.transformBefore ? transformer.transformBefore(params, metadata, pageContext) : params, params),
        transformAfter: (params, metadata, pageContext)=>transformers.reduce((params, transformer)=>transformer.transformAfter ? transformer.transformAfter(params, metadata, pageContext) : params, params)
    });
const $35b63f91264cd025$export$ba9e5d519bc326ca = $35b63f91264cd025$export$d68957b367f91137((0, $cea6135e7e84bafe$export$6a5670d7122d77e8), (0, $12bc2881105e54ac$export$981278bf1b2aa327), (0, $8af95a90f3d439a2$export$3fb54149990fb5b5), (0, $9fdcf181e9622d09$export$e022d5efa3e02dee), (0, $c7a8c4deae65a41e$export$6a4d6155f720c963), (0, $485f60cc477809b5$export$af7e7c08e5e55c8f));



var $cgtv4 = parcelRequire("cgtv4");




const $b0454047538f87a4$var$i18n = (0, $cgtv4.defineMessages)({
    defaultParameterValueFieldLabel: {
        id: "fabric-extension-lib.anchor.config-panel.name-field.label",
        defaultMessage: "Name"
    },
    defaultParameterValueFieldDescription: {
        id: "fabric-extension-lib.anchor.config-panel.name-field.description",
        defaultMessage: "Give this anchor link a unique name for easy reference."
    }
});
const $b0454047538f87a4$export$2e2992790a6f69a8 = {
    transformFields: async ({ fields: fields, intl: intl })=>{
        return fields.map((field)=>{
            if (field.name !== 'defaultParameterValue') return field;
            return {
                ...field,
                type: 'string',
                isRequired: true,
                label: intl.formatMessage($b0454047538f87a4$var$i18n.defaultParameterValueFieldLabel),
                description: intl.formatMessage($b0454047538f87a4$var$i18n.defaultParameterValueFieldDescription)
            };
        });
    },
    // Transforming name that user entered into a valid URI. Not a great experience, need to find a way to inform the user and allow them to pick again.
    transformAfter (params) {
        if (params.defaultParameterValue) {
            // Strip spaces off the beginning and end of the name
            params.defaultParameterValue = params.defaultParameterValue.replace(/^\s+/g, '');
            params.defaultParameterValue = params.defaultParameterValue.replace(/\s+$/g, '');
            // Changing spaces to '-' to match header logic
            params.defaultParameterValue = params.defaultParameterValue.replace(/\s+/g, '-');
            // Stripping out quotes for security (VULN-539679)
            params.defaultParameterValue = params.defaultParameterValue.replace(/["']+/g, '');
            params.defaultParameterValue = params.defaultParameterValue.substr(0, (0, $8pcS0.MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH));
        }
        return params;
    }
};


const $fdf5e213da5d1c5e$export$5ada257c34afac99 = {
    // Converts the "labels" field to be a multi-select
    // which is not supported by the old macro browser
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            if (field.name !== 'labels') return field;
            return {
                ...field,
                type: 'custom',
                isMultiple: true,
                options: {
                    resolver: {
                        type: 'label'
                    }
                }
            };
        });
    },
    // Custom field receives an array
    transformBefore (params) {
        if (params.labels && typeof params.labels === 'string') params.labels = params.labels.split(',');
        return params;
    },
    // Custom field returns an array, so converting it back to string to store
    transformAfter (params) {
        if (Array.isArray(params.labels)) params.labels = params.labels.join(',');
        return params;
    }
};






var $9wGTI = parcelRequire("9wGTI");

const $a51a656fff9da83c$var$i18n = (0, $cgtv4.defineMessages)({
    labelsFieldDescription: {
        id: "fabric-extension-lib.blog-posts.config-panel.labels-field.description",
        defaultMessage: "Add a \u201C-\u201D before any label to exclude blogs with that label.  Add a \u201C+\u201D before any label to require that blogs have that label."
    },
    spacesFieldDescription: {
        id: "fabric-extension-lib.blog-posts.config-panel.spaces-field.description",
        defaultMessage: "Add a \u201C-\u201D before any space to exclude blogs in that space."
    }
});
const $a51a656fff9da83c$var$FIELDS_TO_FIX = [
    'labels',
    'spaces'
];
const $a51a656fff9da83c$export$d09847bb5c97319b = {
    transformFields: async ({ fields: fields, intl: intl })=>{
        return fields.map((field)=>{
            let fieldOverrides = {};
            switch(field.name){
                case 'labels':
                    fieldOverrides = {
                        // Remove old description which talks about entering comma-separated syntax.
                        description: (0, $9wGTI.fg)('confluence_frontend_blog_posts_macro_in_side_panel') ? intl.formatMessage($a51a656fff9da83c$var$i18n.labelsFieldDescription) : undefined,
                        // Converts the "labels" field to be a multi-select
                        // which is not supported by the old macro browser
                        type: 'custom',
                        isMultiple: true,
                        options: {
                            resolver: {
                                // Supports adding "+" or "-" prefixes to exclude or require results with certain labels.
                                type: (0, $9wGTI.fg)('confluence_frontend_blog_posts_macro_in_side_panel') ? 'labelWithPlusMinusPrefixes' : 'label'
                            }
                        }
                    };
                    break;
                case 'spaces':
                    fieldOverrides = {
                        description: (0, $9wGTI.fg)('confluence_frontend_blog_posts_macro_in_side_panel') ? intl.formatMessage($a51a656fff9da83c$var$i18n.spacesFieldDescription) : undefined,
                        type: 'custom',
                        isMultiple: true,
                        options: {
                            resolver: {
                                // Supports special space values like @self
                                // as well as adding "-" prefix to exclude results in a space
                                type: (0, $9wGTI.fg)('confluence_frontend_blog_posts_macro_in_side_panel') ? 'blogRecentlyUpdatedSpaceWithPlusMinusPrefixes' : 'blogRecentlyUpdatedSpace'
                            }
                        }
                    };
                    break;
                case 'author':
                    if ((0, $9wGTI.fg)('confluence_frontend_blog_posts_macro_in_side_panel')) fieldOverrides = {
                        description: ''
                    };
                    break;
            }
            return {
                ...field,
                ...fieldOverrides
            };
        });
    },
    // Custom field receives an array
    transformBefore (params) {
        $a51a656fff9da83c$var$FIELDS_TO_FIX.forEach((field)=>{
            if (params[field] && typeof params[field] === 'string') params[field] = params[field].split(',');
        });
        return params;
    },
    transformAfter (params) {
        $a51a656fff9da83c$var$FIELDS_TO_FIX.forEach((field)=>{
            if (Array.isArray(params[field])) params[field] = params[field].join(',');
        });
        return params;
    }
};



var $bJbIe = parcelRequire("bJbIe");


var $da71s = parcelRequire("da71s");


var $dWCFT = parcelRequire("dWCFT");


var $lEnS1 = parcelRequire("lEnS1");

function $af44a8b67702937d$export$c6813fa23b09b132(date, dateFormat) {
    return (0, $dWCFT.default)((0, $da71s.default)(date), dateFormat);
}
function $af44a8b67702937d$export$f357581637260a(date, dateFormat) {
    return (0, $lEnS1.default)((0, $bJbIe.default)(date, dateFormat, new Date()), {
        representation: 'date'
    });
}
const $af44a8b67702937d$export$3fb54149990fb5b5 = (value)=>{
    if (typeof value === 'boolean') return value;
    return value === 'true';
};


// NOTE: Contributors uses ISO date format so this is only useful when
// the calendar picker will use a different locale.
// Dates must be entered as YYYY/MM/DD
// https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
const $f961a585851fa823$var$PUBLISH_DATE_FORMAT = 'yyyy-MM-dd';
const $f961a585851fa823$export$94a431ed9cc1a33c = {
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            switch(field.name){
                case 'publishDate':
                    return {
                        ...field,
                        description: undefined
                    };
                case 'spaces':
                    return {
                        ...field,
                        options: {
                            resolver: {
                                type: 'contributorsSpaceParamResolver'
                            }
                        }
                    };
                default:
                    return field;
            }
        });
    },
    transformBefore (params) {
        if (params.publishDate?.length) params.publishDate = (0, $af44a8b67702937d$export$f357581637260a)(params.publishDate, $f961a585851fa823$var$PUBLISH_DATE_FORMAT);
        return params;
    },
    transformAfter (params) {
        if (params.publishDate?.length) params.publishDate = (0, $af44a8b67702937d$export$c6813fa23b09b132)(params.publishDate, $f961a585851fa823$var$PUBLISH_DATE_FORMAT);
        return params;
    }
};





const $e537b86479e256a3$var$i18n = (0, $cgtv4.defineMessages)({
    contentIncludeFieldLabel: {
        id: "fabric-extension-lib.field-mappings.include.field.contentInclude.label",
        defaultMessage: "Content to include"
    }
});
const $e537b86479e256a3$export$99920f638bbeb850 = {
    transformFields: async ({ fields: fields, intl: intl, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled })=>{
        return fields.map((field)=>{
            if (field.name !== 'defaultParameterValue') return field;
            return {
                ...field,
                type: 'custom',
                label: isLivePagesFeatureEnabled ? intl.formatMessage($e537b86479e256a3$var$i18n.contentIncludeFieldLabel) : field.label,
                // description talks about entering page using SPACEKEY:Page_title syntax
                // which no longer applies as users are now just picking from a dropdown
                description: undefined
            };
        });
    }
};


const $cc7cae6ecd5fddd6$export$7de1d9fa02de756b = {
    transformFields: async ({ fields: fields })=>{
        return fields// Removes the field altogether
        // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/browse/packages/confluence-macro-browser-overrides/src/office-connector/overrides.js#139-153
        .filter((field)=>![
                'date',
                'space'
            ].includes(field.name))// Adds a hidden field so it will keep existing values
        .map((field)=>{
            if (field.name !== 'page') return field;
            return {
                ...field,
                type: 'string',
                isHidden: true
            };
        });
    },
    transformAfter (params) {
        if (!params.page) delete params.page;
        return params;
    }
};






// Dates must be entered as dd-mm-yyyy
// https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
const $ea80d69ac5e0e244$var$CREATED_DATE_FORMAT = 'dd-MM-yyyy';
const $ea80d69ac5e0e244$export$5e6ec7c8e2ab7cd0 = {
    // Converts the "spaceAndPage" field to be a custom multi-select
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            if (field.name === 'spaceAndPage') return {
                ...field,
                isMultiple: true,
                type: 'custom',
                options: {
                    resolver: {
                        type: 'spaceAndPage'
                    }
                }
            };
            else if (field.name === 'createddateFrom') // Remove the description since we are using a date picker now
            return {
                ...field,
                description: undefined
            };
            return field;
        });
    },
    transformBefore (params) {
        // Handle Space and Pages
        // We store { pages: '123', spaces: '~456' } in macroParams
        // but new config field definition has one `spaceAndPage` field
        // containing both `pages` and `spaces` field values joined together
        let spaceAndPage = '';
        if (params.spaces) spaceAndPage += params.spaces;
        if (params.pages) {
            if (spaceAndPage) spaceAndPage += ',';
            spaceAndPage += params.pages;
        }
        if (spaceAndPage) params.spaceAndPage = spaceAndPage;
        delete params.spaces;
        delete params.pages;
        // Handle Date
        if (params.createddateFrom?.length) params.createddateFrom = (0, $af44a8b67702937d$export$f357581637260a)(params.createddateFrom, $ea80d69ac5e0e244$var$CREATED_DATE_FORMAT);
        return params;
    },
    transformAfter (params) {
        // Before passing it back to macro splitting `spaceAndPage` into `spaces` & `pages`
        if (Array.isArray(params.spaceAndPage)) {
            const spaces = params.spaceAndPage.filter((value)=>!(0, $2E7zk.isPageId)(value));
            if (spaces.length > 0) params.spaces = spaces.join(',');
            const pages = params.spaceAndPage.filter((0, $2E7zk.isPageId));
            if (pages.length > 0) params.pages = pages.join(',');
            delete params.spaceAndPage;
        }
        // Handle Date
        if (params.createddateFrom?.length) params.createddateFrom = (0, $af44a8b67702937d$export$c6813fa23b09b132)(params.createddateFrom, $ea80d69ac5e0e244$var$CREATED_DATE_FORMAT);
        return params;
    }
};





const $d936723dbc3f198e$var$i18n = (0, $cgtv4.defineMessages)({
    fieldRootLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.root.label",
        defaultMessage: "Root content"
    },
    fieldSpacesLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.spaces.label",
        defaultMessage: "Restrict to this space key"
    },
    fieldSortLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.sort.label",
        defaultMessage: "Sort content by"
    },
    fieldExcerptLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.excerpt.label",
        defaultMessage: "Include excerpts in content tree"
    },
    fieldReverseLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.reverse.label",
        defaultMessage: "Reverse order"
    },
    fieldReverseDescription: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.reverse.description",
        defaultMessage: "Used only in conjunction with the \u201CSort content by\u201D field."
    },
    fieldSearchBoxLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.searchBox.label",
        defaultMessage: "Include search box above content tree"
    },
    fieldExpandCollapseAllLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.expandCollapseAll.label",
        defaultMessage: "Show expand/collapse links"
    },
    fieldExpandCollapseAllDescription: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.expandCollapseAll.description",
        defaultMessage: "Displays the \u201Cexpand all\u201D and \u201Ccollapse all\u201D links at the top of the content tree."
    },
    fieldStartDepthLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.startDepth.label",
        defaultMessage: "Tree depth"
    },
    fieldStartDepthDescription: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.startDepth.description",
        defaultMessage: "The number of levels of child items displayed."
    }
});
const $d936723dbc3f198e$export$399a6ae8796e7804 = {
    transformFields: async ({ fields: fields, intl: intl, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled })=>{
        return fields.map((field)=>{
            let fieldResult = {
                ...field
            };
            if (field.name === 'root') fieldResult = {
                ...fieldResult,
                isMultiple: false,
                type: 'custom',
                options: {
                    resolver: {
                        type: 'rootPage'
                    }
                }
            };
            if (isLivePagesFeatureEnabled) {
                let newMacroCopies = {};
                switch(field.name){
                    case 'root':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldRootLabel)
                        };
                        break;
                    case 'spaces':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldSpacesLabel)
                        };
                        break;
                    case 'sort':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldSortLabel)
                        };
                        break;
                    case 'excerpt':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldExcerptLabel)
                        };
                        break;
                    case 'reverse':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldReverseLabel),
                            description: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldReverseDescription)
                        };
                        break;
                    case 'searchBox':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldSearchBoxLabel)
                        };
                        break;
                    case 'expandCollapseAll':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldExpandCollapseAllLabel),
                            description: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldExpandCollapseAllDescription)
                        };
                        break;
                    case 'startDepth':
                        newMacroCopies = {
                            label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldStartDepthLabel),
                            description: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldStartDepthDescription)
                        };
                        break;
                }
                fieldResult = {
                    ...fieldResult,
                    ...newMacroCopies
                };
            }
            return fieldResult;
        });
    }
};





const $836a8b250eda6583$var$i18n = (0, $cgtv4.defineMessages)({
    searchCalendarPlaceholder: {
        id: "fabric-extension-lib.field-mappings.calendar.field.search.placeholder",
        defaultMessage: "Begin typing to search your calendars"
    }
});
const $836a8b250eda6583$export$56bbcdb8aca31149 = {
    transformFields: async ({ fields: fields, intl: intl })=>{
        return fields.map((field)=>{
            if (field.name !== 'id') return field;
            return {
                ...field,
                type: 'custom',
                isMultiple: true,
                options: {
                    resolver: {
                        type: 'calendar'
                    }
                },
                placeholder: intl.formatMessage($836a8b250eda6583$var$i18n.searchCalendarPlaceholder)
            };
        });
    },
    // Custom field receives an array
    transformBefore (params) {
        if (params.id && typeof params.id === 'string') params.id = params.id.split(',');
        return params;
    },
    // Custom field returns an array, so converting it back to string to store
    transformAfter (params) {
        if (Array.isArray(params.id)) params.id = params.id.join(',');
        return params;
    }
};








var $kTVK2 = parcelRequire("kTVK2");

const $6cbac4da7b29df9c$export$aa84be64c5f7ddf4 = (name, fields, intl, _defaultValue, isLivePage)=>{
    let field;
    switch(name){
        case 'spaces':
            field = {
                ...$6cbac4da7b29df9c$var$getSpacesField(fields['spaces']),
                label: intl.formatMessage((0, $kTVK2.i18n).spaceLabel),
                description: '',
                placeholder: intl.formatMessage((0, $kTVK2.i18n).spacePlaceholder)
            };
            break;
        case 'types':
            field = {
                ...fields['types'],
                label: intl.formatMessage((0, $kTVK2.i18n).typesLabel),
                description: '',
                placeholder: intl.formatMessage((0, $kTVK2.i18n).typePlaceholder),
                type: 'enum',
                style: 'select',
                isMultiple: true,
                items: [
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTypes).allLabel),
                        value: ''
                    },
                    {
                        label: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? intl.formatMessage((0, $kTVK2.i18nTypes).livePageLabel) : intl.formatMessage((0, $kTVK2.i18nTypes).pageLabel),
                        value: 'page'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTypes).blogPostLabel),
                        value: 'blogpost'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTypes).commentLabel),
                        value: 'comment'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTypes).attachmentLabel),
                        value: 'attachment'
                    }
                ]
            };
            break;
        case 'maxToggle':
            field = {
                name: 'maxToggle',
                type: 'boolean',
                style: 'toggle',
                label: intl.formatMessage((0, $kTVK2.i18n).maxToggleLabel),
                description: '',
                defaultValue: false,
                isHidden: false,
                isMultiple: false,
                isRequired: false
            };
            break;
        case 'max':
            field = {
                ...fields['max'],
                label: intl.formatMessage((0, $kTVK2.i18n).maxLabel)
            };
            break;
        case 'theme':
            field = {
                ...fields['theme'],
                label: intl.formatMessage((0, $kTVK2.i18n).themeLabel),
                placeholder: intl.formatMessage((0, $kTVK2.i18nTheme).conciseLabel),
                items: [
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTheme).conciseLabel),
                        value: 'concise'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTheme).sidebarLabel),
                        value: 'sidebar'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTheme).socialLabel),
                        value: 'social'
                    }
                ]
            };
            break;
        case 'author':
            field = {
                ...fields['author'],
                label: intl.formatMessage((0, $kTVK2.i18n).authorLabel),
                placeholder: intl.formatMessage((0, $kTVK2.i18n).authorPlaceholder),
                description: ''
            };
            break;
        case 'labels':
            field = {
                ...fields['labels'],
                label: intl.formatMessage((0, $kTVK2.i18n).labelsLabel),
                placeholder: intl.formatMessage((0, $kTVK2.i18n).labelsPlaceholder),
                description: '',
                isMultiple: true,
                type: 'custom',
                options: {
                    resolver: {
                        type: 'label'
                    }
                }
            };
            break;
        case 'width':
            field = {
                ...fields['width'],
                label: intl.formatMessage((0, $kTVK2.i18n).widthLabel),
                placeholder: intl.formatMessage((0, $kTVK2.i18n).widthPlaceholder),
                description: '',
                type: 'custom',
                options: {
                    isCreatable: true,
                    formatCreateLabel: (value)=>{
                        return value;
                    },
                    resolver: {
                        type: 'widthPercentage'
                    }
                }
            };
            break;
        case 'hideHeading':
            field = {
                ...fields['hideHeading'],
                label: intl.formatMessage((0, $kTVK2.i18n).hideHeadingLabel)
            };
            break;
    }
    return field;
};
const $6cbac4da7b29df9c$var$getSpacesField = (field)=>{
    return {
        ...field,
        isMultiple: true,
        type: 'custom',
        options: {
            resolver: {
                type: 'blogRecentlyUpdatedSpace'
            }
        }
    };
};
const $6cbac4da7b29df9c$export$e9aa8a2eb319b54d = (name, fields, intl, currentParams, isLivePage)=>{
    if (name === 'max') {
        const result = [];
        result.push($6cbac4da7b29df9c$export$aa84be64c5f7ddf4('maxToggle', fields, intl, isLivePage));
        if (!(0, $af44a8b67702937d$export$3fb54149990fb5b5)(currentParams?.macroParams?.maxToggle?.value)) result.push($6cbac4da7b29df9c$export$aa84be64c5f7ddf4(name, fields, intl));
        return result;
    }
    return $6cbac4da7b29df9c$export$aa84be64c5f7ddf4(name, fields, intl, isLivePage);
};





const $11540f3edad606fa$var$basicTabFields = [
    'spaces',
    'types',
    'max'
];
const $11540f3edad606fa$var$displayTabFields = [
    'theme',
    'author',
    'labels',
    'width',
    'hideHeading'
];
const $11540f3edad606fa$export$8b4c22b4049c66c3 = {
    transformFields: async ({ fields: fields, intl: intl, createAnalyticsEvent: createAnalyticsEvent, isLivePage: isLivePage })=>{
        const fireErrorAnalytics = (tab, error)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'error',
                    actionSubject: 'transformFields',
                    actionSubjectId: tab,
                    source: 'field-mappings/recently-updated',
                    attributes: {
                        error: error.message,
                        stack: error.stack
                    }
                }
            }).fire();
        };
        const getDynamicFields = (currentParams)=>{
            const fieldsObj = fields.reduce((obj, field)=>{
                obj[field.name] = field;
                return obj;
            }, {});
            return [
                {
                    type: 'tab-group',
                    name: 'tabGroup',
                    label: 'Recent Updates Tab Group',
                    defaultTab: 'basic',
                    fields: [
                        {
                            type: 'tab',
                            label: intl.formatMessage((0, $kTVK2.i18n).basicTabLabel),
                            name: 'basic',
                            fields: [
                                ...$11540f3edad606fa$var$basicTabFields.flatMap((fieldName)=>{
                                    try {
                                        return (0, $6cbac4da7b29df9c$export$e9aa8a2eb319b54d)(fieldName, fieldsObj, intl, currentParams, isLivePage);
                                    } catch (error) {
                                        fireErrorAnalytics('basicTab', error);
                                        return [];
                                    }
                                })
                            ]
                        },
                        {
                            type: 'tab',
                            label: intl.formatMessage((0, $kTVK2.i18n).displayTabLabel),
                            name: 'display',
                            fields: [
                                ...$11540f3edad606fa$var$displayTabFields.map((fieldName)=>{
                                    try {
                                        return (0, $6cbac4da7b29df9c$export$aa84be64c5f7ddf4)(fieldName, fieldsObj, intl);
                                    } catch (error) {
                                        fireErrorAnalytics('displayTab', error);
                                        return [];
                                    }
                                })
                            ]
                        }
                    ]
                }
            ];
        };
        return getDynamicFields;
    },
    transformBefore (params, _metadata, _pageContext) {
        // Convert "Include in list" string to array for FE enum field
        if (params.types) params.types = params.types.split(/[ ,]+/);
        else params.types = [
            ''
        ];
        // Convert labels param from string to array for FE custom field
        if (params.labels) params.labels = params.labels.split(/[ ,]+/);
        // We are hiding "Show User Profile Pictures" checkbox
        // In the BE if this was checked, it sets theme to "social" and overrides the "theme" param
        // So if an existing macro had this checked, set theme to "social" (results in no change to macro view)
        if ((0, $af44a8b67702937d$export$3fb54149990fb5b5)(params.showProfilePic)) {
            params.theme = 'social';
            params.showProfilePic = 'false';
        }
        return params;
    },
    transformAfter (params, _metadata, _pageContext) {
        // "Include in list" param behavior: Default is "All" which is mutually exclusive with other options.
        // i.e. selection in this field can be either "All" by itself, or any content types (but no "All").
        // Also converts array to string for BE field data type
        if (params.types) {
            const types = params.types;
            if (types[types.length - 1] === '') // "All" was just chosen, remove all other selections
            params.types = '';
            else if (types.some((type)=>type === '')) {
                // A content type was selected but "All" exists in the list, so remove "All"
                types.splice(types.indexOf(''), 1);
                params.types = types.join();
            } else params.types = types.join();
        }
        // If "Show all updates" toggle is on, set max param to highest allowed from BE
        const showAll = (0, $af44a8b67702937d$export$3fb54149990fb5b5)(params.maxToggle);
        if (showAll) params.max = 250;
        // Convert labels param from array to string for BE field definition
        if (params.labels) params.labels = params.labels.join();
        return params;
    }
};


const $88990a4623f29192$export$fdb887e9b25aa392 = {
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            if (field.name === 'spaces') return {
                ...field,
                isMultiple: true,
                type: 'custom',
                options: {
                    resolver: {
                        type: 'recentlyUpdatedDashboardSpaceKeyResolver'
                    }
                }
            };
            return field;
        });
    }
};



var $gw2T1 = parcelRequire("gw2T1");

const $a9bebca19b89c955$var$isNumber = (contentId)=>/^[0-9]+$/.test(contentId);
const $a9bebca19b89c955$export$f0ecb46e90798741 = {
    transformFields: async ({ fields: fields, pageContext: pageContext, params: params })=>{
        let templates = [];
        const resolver = (0, $gw2T1.getTemplateResolver)(params?.spaceKey ? params : pageContext);
        if (resolver) templates = await resolver('', '');
        const newFields = fields.map((field)=>{
            if (field.name === 'templateName') return {
                ...field,
                type: 'enum',
                items: templates,
                isRequired: true
            };
            else if (field.name === 'spaceKey') return {
                ...field,
                defaultValue: pageContext.spaceKey,
                isRequired: false
            };
            return field;
        });
        const spaceKeyIndex = newFields.findIndex(({ name: name })=>name === 'spaceKey');
        const templateIndex = newFields.findIndex(({ name: name })=>name === 'templateName');
        newFields.unshift(newFields.splice(templateIndex, 1)[0]);
        newFields.unshift(newFields.splice(spaceKeyIndex, 1)[0]);
        return newFields;
    },
    transformAfter (params) {
        const { templateName: templateName } = params;
        if (templateName) {
            if ($a9bebca19b89c955$var$isNumber(templateName)) {
                params.templateId = templateName;
                delete params.contentBlueprintId;
            } else {
                params.contentBlueprintId = templateName;
                delete params.templateId;
            }
        }
        return params;
    }
};






const $862710ac50c04301$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    pageLabel: {
        id: "fabric-extension-lib.children.field.page.label",
        defaultMessage: "Parent item"
    },
    pagePlaceholder: {
        id: "fabric-extension-lib.children.field.page.placeholder",
        defaultMessage: "Current"
    },
    allChildren: {
        id: "fabric-extension-lib.children.field.allChildren.label",
        defaultMessage: "Show all child items"
    },
    allLabel: {
        id: "fabric-extension-lib.children.field.all.label",
        defaultMessage: "Show all levels"
    },
    depthLabel: {
        id: "fabric-extension-lib.children.field.depth.label",
        defaultMessage: "Max number of levels"
    },
    excerptTypeLabel: {
        id: "fabric-extension-lib.children.field.excerptType.label",
        defaultMessage: "Display preview"
    },
    excerptTypeDescription: {
        id: "fabric-extension-lib.children.field.excerptType.description",
        defaultMessage: "Lists can display a preview of the top of a child item, or the content of its excerpt."
    },
    firstLabel: {
        id: "fabric-extension-lib.children.field.first.label",
        defaultMessage: "Max number in list"
    },
    sortLabel: {
        id: "fabric-extension-lib.children.field.sort.label",
        defaultMessage: "Sort order"
    },
    styleLabel: {
        id: "fabric-extension-lib.children.field.style.label",
        defaultMessage: "List style"
    },
    basicTabLabel: {
        id: "fabric-extension-lib.config.tab.basic.label",
        defaultMessage: "Basic"
    },
    displayTabLabel: {
        id: "fabric-extension-lib.config.tab.display.label",
        defaultMessage: "Display"
    }
});
const $862710ac50c04301$export$e7de9fb1789252ba = (0, $cgtv4.defineMessages)({
    one: {
        id: "fabric-extension-lib.children.field.depth.item.one",
        defaultMessage: "1 level"
    },
    two: {
        id: "fabric-extension-lib.children.field.depth.item.two",
        defaultMessage: "2 levels"
    },
    three: {
        id: "fabric-extension-lib.children.field.depth.item.three",
        defaultMessage: "3 levels"
    },
    four: {
        id: "fabric-extension-lib.children.field.depth.item.four",
        defaultMessage: "4 levels"
    },
    five: {
        id: "fabric-extension-lib.children.field.depth.item.five",
        defaultMessage: "5 levels"
    },
    six: {
        id: "fabric-extension-lib.children.field.depth.item.six",
        defaultMessage: "6 levels"
    },
    seven: {
        id: "fabric-extension-lib.children.field.depth.item.seven",
        defaultMessage: "7 levels"
    },
    eight: {
        id: "fabric-extension-lib.children.field.depth.item.eight",
        defaultMessage: "8 levels"
    },
    nine: {
        id: "fabric-extension-lib.children.field.depth.item.nine",
        defaultMessage: "9 levels"
    }
});
const $862710ac50c04301$export$22a6a8b908f4792e = (0, $cgtv4.defineMessages)({
    titleGroup: {
        id: "fabric-extension-lib.children.field.sort.group.title",
        defaultMessage: "Title"
    },
    titleItem: {
        id: "fabric-extension-lib.children.field.sort.item.title",
        defaultMessage: "A \u2192 Z"
    },
    titleReverseItem: {
        id: "fabric-extension-lib.children.field.sort.item.titlereverse",
        defaultMessage: "Z \u2192 A"
    },
    creationGroup: {
        id: "fabric-extension-lib.children.field.sort.group.creation",
        defaultMessage: "Created"
    },
    creationItem: {
        id: "fabric-extension-lib.children.field.sort.item.creation",
        defaultMessage: "Newest \u2192 Oldest"
    },
    creationReverseItem: {
        id: "fabric-extension-lib.children.field.sort.item.creationreverse",
        defaultMessage: "Oldest \u2192 Newest"
    },
    modifiedGroup: {
        id: "fabric-extension-lib.children.field.sort.group.modified",
        defaultMessage: "Modified"
    },
    modifiedItem: {
        id: "fabric-extension-lib.children.field.sort.item.modified",
        defaultMessage: "Old \u2192 Recent"
    },
    modifiedReverseItem: {
        id: "fabric-extension-lib.children.field.sort.item.modifiednreverse",
        defaultMessage: "Recent \u2192 Old"
    },
    defaultGroup: {
        id: "fabric-extension-lib.children.field.sort.group.default",
        defaultMessage: "Content Tree"
    },
    defaultItem: {
        id: "fabric-extension-lib.children.field.sort.item.default",
        defaultMessage: "Current"
    },
    defaultReverseItem: {
        id: "fabric-extension-lib.children.field.sort.item.defaultreverse",
        defaultMessage: "Reverse"
    }
});
const $862710ac50c04301$export$937ee27e4f72fd9f = (0, $cgtv4.defineMessages)({
    default: {
        id: "fabric-extension-lib.children.field.style.item.default",
        defaultMessage: "Bulleted"
    },
    h1: {
        id: "fabric-extension-lib.children.field.style.item.h1",
        defaultMessage: "H1"
    },
    h2: {
        id: "fabric-extension-lib.children.field.style.item.h2",
        defaultMessage: "H2"
    },
    h3: {
        id: "fabric-extension-lib.children.field.style.item.h3",
        defaultMessage: "H3"
    },
    h4: {
        id: "fabric-extension-lib.children.field.style.item.h4",
        defaultMessage: "H4"
    },
    h5: {
        id: "fabric-extension-lib.children.field.style.item.h5",
        defaultMessage: "H5"
    },
    h6: {
        id: "fabric-extension-lib.children.field.style.item.h6",
        defaultMessage: "H6"
    }
});
const $862710ac50c04301$export$981659feafe35cff = (0, $cgtv4.defineMessages)({
    none: {
        id: "fabric-extension-lib.children.field.excerptType.item.none",
        defaultMessage: "None"
    },
    richContent: {
        id: "fabric-extension-lib.children.field.excerptType.item.richContent",
        defaultMessage: "Preview content"
    },
    simple: {
        id: "fabric-extension-lib.children.field.excerptType.item.simple",
        defaultMessage: "Excerpt preview"
    }
});




const $8b7d499a5aa031b6$export$4c39dc4ba3b26bb7 = (name, fields, intl, defaultValue)=>{
    let field;
    switch(name){
        case 'page':
            field = {
                ...fields['page'],
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).pageLabel),
                placeholder: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).pagePlaceholder),
                description: ''
            };
            break;
        case 'allChildren':
            field = {
                name: 'allChildren',
                type: 'boolean',
                style: 'toggle',
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).allChildren),
                description: '',
                defaultValue: defaultValue,
                isHidden: false,
                isMultiple: false,
                isRequired: false
            };
            break;
        case 'first':
            field = {
                ...fields['first'],
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).firstLabel),
                description: ''
            };
            break;
        case 'all':
            field = {
                ...fields['all'],
                style: 'toggle',
                defaultValue: 'false',
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).allLabel)
            };
            break;
        case 'depth':
            field = {
                ...fields['depth'],
                type: 'enum',
                style: 'select',
                defaultValue: '1',
                isMultiple: false,
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).depthLabel),
                items: [
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).one),
                        value: '1'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).two),
                        value: '2'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).three),
                        value: '3'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).four),
                        value: '4'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).five),
                        value: '5'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).six),
                        value: '6'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).seven),
                        value: '7'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).eight),
                        value: '8'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).nine),
                        value: '9'
                    }
                ]
            };
            break;
        case 'sort':
            field = {
                ...fields['sort'],
                name: 'sortAndReverse',
                type: 'enum',
                style: 'select',
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).sortLabel),
                defaultValue: '',
                items: [
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).defaultGroup),
                        options: [
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).defaultItem),
                                value: ''
                            },
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).defaultReverseItem),
                                value: '.true'
                            }
                        ]
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).titleGroup),
                        options: [
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).titleItem),
                                value: 'title'
                            },
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).titleReverseItem),
                                value: 'title.true'
                            }
                        ]
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).creationGroup),
                        options: [
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).creationItem),
                                value: 'creation.true'
                            },
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).creationReverseItem),
                                value: 'creation'
                            }
                        ]
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).modifiedGroup),
                        options: [
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).modifiedReverseItem),
                                value: 'modified.true'
                            },
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).modifiedItem),
                                value: 'modified'
                            }
                        ]
                    }
                ]
            };
            break;
        case 'style':
            field = {
                ...fields['style'],
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).styleLabel),
                defaultValue: '',
                items: [
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).default),
                        value: ''
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).h1),
                        value: 'h1'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).h2),
                        value: 'h2'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).h3),
                        value: 'h3'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).h4),
                        value: 'h4'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).h5),
                        value: 'h5'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).h6),
                        value: 'h6'
                    }
                ]
            };
            break;
        case 'excerptType':
            field = {
                ...fields['excerptType'],
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).excerptTypeLabel),
                description: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).excerptTypeDescription),
                items: [
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$981659feafe35cff).none),
                        value: 'none'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$981659feafe35cff).richContent),
                        value: 'rich content'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$981659feafe35cff).simple),
                        value: 'simple'
                    }
                ]
            };
            break;
    }
    return field;
};
const $8b7d499a5aa031b6$export$d0c9dc351b89eb65 = (all, depth)=>{
    if (all && depth > 0) return false;
    return all;
};
const $8b7d499a5aa031b6$export$e9aa8a2eb319b54d = (name, fields, intl, currentParams)=>{
    if (name === 'page') return $8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('page', fields, intl);
    const result = [];
    if (name === 'first') {
        // "Max number in list" field
        // Add an FE-only toggle field `allChildren` to conditionally display the "Max # in list" (`first`) field
        // Since it's an FE-only param, dynamically set its defaultValue depending on `first` param's current value
        // Toggle is TRUE if `first` is undefined or 0, i.e. no child page limit
        const defaultValue = !currentParams?.macroParams?.first?.value || parseInt(currentParams.macroParams.first.value) === 0 ? 'true' : 'false';
        result.push($8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('allChildren', fields, intl, defaultValue));
        // If param is null (i.e. on initial load), manually update its state
        if (currentParams?.macroParams && !currentParams.macroParams.allChildren) currentParams.macroParams.allChildren = {
            value: defaultValue
        };
        // Only render "Max number in list" field when toggle is FALSE
        if (!(0, $af44a8b67702937d$export$3fb54149990fb5b5)(currentParams?.macroParams?.allChildren?.value)) result.push($8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('first', fields, intl));
    }
    if (name === 'all') {
        // "Show all levels" toggle
        result.push($8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('all', fields, intl));
        // Only render "Max number of levels" field when `all` toggle is FALSE
        // (or edge case described in validateDepthFields)
        if (!$8b7d499a5aa031b6$export$d0c9dc351b89eb65((0, $af44a8b67702937d$export$3fb54149990fb5b5)(currentParams?.macroParams?.all?.value), parseInt(currentParams?.macroParams?.depth?.value ?? ''))) result.push($8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('depth', fields, intl));
    }
    return result;
};


const $2ed2a9038132d075$var$basicTabFields = [
    'page',
    'first',
    'all'
];
const $2ed2a9038132d075$var$displayTabFields = [
    'sort',
    'style',
    'excerptType'
];
const $2ed2a9038132d075$export$bacb5cc5a11aef16 = {
    transformFields: async ({ fields: fields, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>{
        const fireErrorAnalytics = (tab, error)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'error',
                    actionSubject: 'transformFields',
                    actionSubjectId: tab,
                    source: 'field-mappings/children',
                    attributes: {
                        error: error.message,
                        stack: error.stack
                    }
                }
            }).fire();
        };
        const getDynamicFields = (currentParams)=>{
            const fieldsObj = fields.reduce((obj, field)=>{
                obj[field.name] = field;
                return obj;
            }, {});
            return [
                {
                    type: 'tab-group',
                    name: 'tabGroup',
                    label: 'Child Pages Tab Group',
                    defaultTab: 'basic',
                    fields: [
                        {
                            type: 'tab',
                            label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).basicTabLabel),
                            name: 'basic',
                            fields: [
                                ...$2ed2a9038132d075$var$basicTabFields.flatMap((fieldName)=>{
                                    try {
                                        return (0, $8b7d499a5aa031b6$export$e9aa8a2eb319b54d)(fieldName, fieldsObj, intl, currentParams);
                                    } catch (error) {
                                        fireErrorAnalytics('basicTab', error);
                                        return [];
                                    }
                                })
                            ]
                        },
                        {
                            type: 'tab',
                            label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).displayTabLabel),
                            name: 'display',
                            fields: [
                                ...$2ed2a9038132d075$var$displayTabFields.map((fieldName)=>{
                                    try {
                                        return (0, $8b7d499a5aa031b6$export$4c39dc4ba3b26bb7)(fieldName, fieldsObj, intl);
                                    } catch (error) {
                                        fireErrorAnalytics('displayTab', error);
                                        return [];
                                    }
                                })
                            ]
                        }
                    ]
                }
            ];
        };
        return getDynamicFields;
    },
    transformBefore (params) {
        // We need to update 'Show all levels' toggle here as well to align param state with UI
        params.all = (0, $8b7d499a5aa031b6$export$d0c9dc351b89eb65)((0, $af44a8b67702937d$export$3fb54149990fb5b5)(params.all), typeof params.depth === 'number' ? params.depth : parseInt(params.depth ?? ''));
        // `sort` and `reverse` params have been combined into a single `sortAndReverse` field
        // so we need to combine their values into one to pass into the new enum field
        params.sortAndReverse = params.sort ?? '';
        if ((0, $af44a8b67702937d$export$3fb54149990fb5b5)(params.reverse)) params.sortAndReverse += '.true';
        return params;
    },
    transformAfter (params) {
        // 'Show all child pages' toggle field
        const allChildren = (0, $af44a8b67702937d$export$3fb54149990fb5b5)(params.allChildren);
        if (allChildren) params.first = 0; // 'Max number in list' field
        if (!allChildren && !params.first) params.first = 10; // set some non-0 value
        // 'Show all levels' depth toggle field
        const allLevels = (0, $af44a8b67702937d$export$3fb54149990fb5b5)(params.all);
        if (allLevels) params.depth = 0;
        if (!allLevels && params.depth === 0) params.depth = 1;
        // Convert sort/reverse field back to manifest definition for BE handling
        [params.sort = '', params.reverse] = (params.sortAndReverse ?? '').split('.');
        if (!params.sort) delete params.sort;
        return params;
    }
};


const $0f335227b4c76418$export$f8e8f85027c88e59 = {
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            // Mark this field as required in the FE to display the UI red asterisk, but we will not
            // enforce it in the backend as this breaks existing untitled excerpts
            if (field.name === 'name') return {
                ...field,
                isRequired: true
            };
            return field;
        });
    }
};





const $2d464ae24baf1d6f$var$i18n = (0, $cgtv4.defineMessages)({
    fieldIdLabel: {
        id: "fabric-extension-lib.field-mappings.details.field.id.label",
        defaultMessage: "Content properties ID (optional)"
    },
    fieldIdDescription: {
        id: "fabric-extension-lib.field-mappings.details.field.id.description",
        defaultMessage: "Specify an ID if you have multiple content properties macros on this page or doc and want to report on them separately."
    },
    fieldHiddenLabel: {
        id: "fabric-extension-lib.field-mappings.details.field.hidden.label",
        defaultMessage: "Hide from view"
    },
    fieldHiddenDescription: {
        id: "fabric-extension-lib.field-mappings.details.field.hidden.description",
        defaultMessage: "Hide macro contents from view, but continue to display them in the Content Properties Report macro."
    }
});
const $2d464ae24baf1d6f$export$41ee12f6f6f05843 = {
    transformFields: async ({ fields: fields, intl: intl, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled })=>{
        if (isLivePagesFeatureEnabled) return fields.map((field)=>{
            if (field.name === 'id') return {
                ...field,
                label: intl.formatMessage($2d464ae24baf1d6f$var$i18n.fieldIdLabel),
                description: intl.formatMessage($2d464ae24baf1d6f$var$i18n.fieldIdDescription)
            };
            if (field.name === 'hidden') return {
                ...field,
                label: intl.formatMessage($2d464ae24baf1d6f$var$i18n.fieldHiddenLabel),
                description: intl.formatMessage($2d464ae24baf1d6f$var$i18n.fieldHiddenDescription)
            };
            return field;
        });
        return fields;
    }
};


const $763d528574677310$var$makeObject = (xs)=>xs.reduce((obj, x)=>{
        obj[x.name] = x;
        return obj;
    }, {});
const $763d528574677310$export$78a98cfbfc91bcb5 = ()=>({
        attachments: $fdf5e213da5d1c5e$export$5ada257c34afac99,
        'blog-posts': (0, $a51a656fff9da83c$export$d09847bb5c97319b),
        calendar: $836a8b250eda6583$export$56bbcdb8aca31149,
        children: $2ed2a9038132d075$export$bacb5cc5a11aef16,
        contributors: $f961a585851fa823$export$94a431ed9cc1a33c,
        'contributors-summary': (0, $f961a585851fa823$export$94a431ed9cc1a33c),
        'create-from-template': (0, $a9bebca19b89c955$export$f0ecb46e90798741),
        details: $2d464ae24baf1d6f$export$41ee12f6f6f05843,
        excerpt: // content properties (page properties) macro
        $0f335227b4c76418$export$f8e8f85027c88e59,
        include: $e537b86479e256a3$export$99920f638bbeb850,
        pagetree: $d936723dbc3f198e$export$399a6ae8796e7804,
        viewpdf: (0, $cc7cae6ecd5fddd6$export$7de1d9fa02de756b),
        viewdoc: (0, $cc7cae6ecd5fddd6$export$7de1d9fa02de756b),
        viewxls: (0, $cc7cae6ecd5fddd6$export$7de1d9fa02de756b),
        viewppt: (0, $cc7cae6ecd5fddd6$export$7de1d9fa02de756b),
        'tasks-report-macro': (0, $ea80d69ac5e0e244$export$5e6ec7c8e2ab7cd0),
        anchor: $b0454047538f87a4$export$2e2992790a6f69a8,
        'recently-updated': (0, $11540f3edad606fa$export$8b4c22b4049c66c3),
        'recently-updated-dashboard': (0, $88990a4623f29192$export$fdb887e9b25aa392)
    });
const $763d528574677310$export$5a5c6ccdb287233d = async ({ macroName: macroName }, fields, pageContext, intl, params, createAnalyticsEvent, isLivePage, isLivePagesFeatureEnabled)=>{
    const transformFields = $763d528574677310$export$78a98cfbfc91bcb5()[macroName]?.transformFields;
    const alwaysFn = (0, $35b63f91264cd025$export$ba9e5d519bc326ca)?.transformFields;
    if (macroName === 'create-from-template') return transformFields ? transformFields({
        fields: fields,
        pageContext: pageContext,
        intl: intl,
        params: params,
        createAnalyticsEvent: createAnalyticsEvent,
        isLivePage: isLivePage
    }) : fields;
    else {
        let newFields;
        if (transformFields) try {
            newFields = await transformFields({
                fields: fields,
                pageContext: pageContext,
                intl: intl,
                params: params,
                createAnalyticsEvent: createAnalyticsEvent,
                isLivePage: isLivePage,
                isLivePagesFeatureEnabled: isLivePagesFeatureEnabled
            });
        } catch (error) {
            if ((0, $8pcS0.MODERENIZED_MACRO_KEYS).includes(macroName)) $763d528574677310$var$fireErrorAnalytics(macroName, 'transformFields', error, createAnalyticsEvent);
        }
        else newFields = fields;
        return alwaysFn ? alwaysFn(newFields, pageContext, intl) : newFields;
    }
};
const $763d528574677310$export$db6c1732c1c4814c = (transformType, macro, params, pageContext, createAnalyticsEvent)=>{
    const { macroName: macroName, formDetails: formDetails } = macro;
    const metadata = $763d528574677310$var$makeObject(formDetails.parameters);
    const transformFn = $763d528574677310$export$78a98cfbfc91bcb5()[macroName]?.[transformType];
    const alwaysFn = (0, $35b63f91264cd025$export$ba9e5d519bc326ca)?.[transformType];
    let newParams;
    if (transformFn) try {
        newParams = transformFn(params, metadata, pageContext);
    } catch (error) {
        if ((0, $8pcS0.MODERENIZED_MACRO_KEYS).includes(macroName)) $763d528574677310$var$fireErrorAnalytics(macroName, transformType, error, createAnalyticsEvent);
    }
    else newParams = params;
    return alwaysFn ? alwaysFn(newParams, metadata, pageContext) : newParams;
};
const $763d528574677310$var$fireErrorAnalytics = (macroName, fn, error, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'error',
            actionSubject: fn,
            actionSubjectId: macroName,
            source: 'field-mappings',
            attributes: {
                error: error.message,
                stack: error.stack
            }
        }
    }).fire();
};
module.exports["remapCustomFields"] = $763d528574677310$export$5a5c6ccdb287233d;
module.exports["transformParams"] = $763d528574677310$export$db6c1732c1c4814c;

});

parcelRegister("2E7zk", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $f7B1p = parcelRequire("f7B1p");


var $4VJDS = parcelRequire("4VJDS");


var $9Cbhx = parcelRequire("9Cbhx");


var $fgbpl = parcelRequire("fgbpl");


var $8pcS0 = parcelRequire("8pcS0");


var $eQyFc = parcelRequire("eQyFc");


var $cgtv4 = parcelRequire("cgtv4");


var $kyKWe = parcelRequire("kyKWe");








var $2E7zk = parcelRequire("2E7zk");




const $7b3d41287d889ce8$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    excerptPlaceholder: {
        id: "fabric-extension-lib.excerpt.placeholder",
        defaultMessage: "Type or paste something here to turn it into an excerpt."
    },
    tocZonePlaceholder: {
        id: "fabric-extension-lib.toc.zone.placeholder",
        defaultMessage: "A table of contents based on the headings within this frame will appear here."
    },
    pagePropertiesKeyTablePlaceholder: {
        id: "fabric-extension-lib.page.properties.table.key.placeholder",
        defaultMessage: "List \u2018keys\u2019 in this column - these will be the column headings in your report table"
    },
    pagePropertiesValueTablePlaceholder: {
        id: "fabric-extension-lib.page.properties.table.value.placeholder",
        defaultMessage: "List the \u2018value\u2019 for each key in this column - these will populate the rows in your report table"
    }
});
const $7b3d41287d889ce8$var$maybeGetGadgetUrl = (macro)=>macro.macroName === 'gadget' && macro?.formDetails?.parameters?.[0]?.defaultValue && {
        gadgetUrl: new URL(// This is gross, but this is the only way to get the URL of the
        // the gadget. We use the same url in the view event to know
        // which gadget was actually inserted, thus track gadget usage
        macro.formDetails.parameters[0].defaultValue, location.origin).pathname
    };
const $7b3d41287d889ce8$var$createBaseMacroAction = (macro, pageContext, intl, createAnalyticsEvent, isLivePage = false, isLivePagesFeatureEnabled)=>async ()=>{
        const node = await (0, $eQyFc.prepareMacro)({
            name: macro.macroName
        }, pageContext.contentId, null, intl, isLivePagesFeatureEnabled);
        if (macro.macroName === 'excerpt') (0, $2E7zk.insertMacroPlaceholder)(node, intl.formatMessage($7b3d41287d889ce8$export$a7357cdd1f0b0168.excerptPlaceholder));
        if (macro.macroName === 'details') (0, $2E7zk.insertContentPropertiesMacroPlaceholder)(node, intl.formatMessage($7b3d41287d889ce8$export$a7357cdd1f0b0168.pagePropertiesKeyTablePlaceholder), intl.formatMessage($7b3d41287d889ce8$export$a7357cdd1f0b0168.pagePropertiesValueTablePlaceholder));
        if (macro.macroName === 'toc-zone') (0, $2E7zk.insertMacroPlaceholder)(node, intl.formatMessage($7b3d41287d889ce8$export$a7357cdd1f0b0168.tocZonePlaceholder));
        const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(macro.macroName, node.attrs.parameters?.macroParams?.['serverId']?.value);
        if (createAnalyticsEvent) {
            const isSupportedMacro = await $7b3d41287d889ce8$export$f3046997f1755ab7(macro.macroName);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'inserted',
                    actionSubject: 'macro',
                    actionSubjectId: macro.macroName,
                    source: 'quick insert menu',
                    attributes: {
                        extensionType: node?.type,
                        appKey: (0, $2E7zk.getConnectAppKey)(macro.moduleKey),
                        isLivePage: isLivePage,
                        jiraHostingOption: jiraHostingOption,
                        ...isLivePage && isSupportedMacro !== undefined && {
                            isSupportedMacro: isSupportedMacro
                        },
                        ...$7b3d41287d889ce8$var$maybeGetGadgetUrl(macro)
                    }
                }
            }).fire();
        }
        return node;
    };
const $7b3d41287d889ce8$var$createActionForMacrosThatRequireMacroBrowser = (macro, openMacroBrowserForInitialConfiguration, editorAPI, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage = false)=>async ()=>{
        if (!macroBrowserConfig) throw new Error(`Macro Browser Config is missing`);
        if (!editorActions) throw new Error(`editorActions is missing`);
        const macroFilter = undefined;
        const extensionAnalyticsInfo = {
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: macroBrowserConfig.contentId
        };
        const updateMacro = (node)=>{
            const selectedNode = (0, $2E7zk.getSelectedBodiedExtensionNode)(editorActions);
            if (selectedNode) editorAPI?.extension?.actions?.editSelectedExtension();
            else {
                // initial insert of the roadmap macro
                editorActions.replaceSelection(node);
                editorAPI?.extension?.actions?.editSelectedExtension();
            }
        };
        const node = await openMacroBrowserForInitialConfiguration(macro, macroBrowserConfig, macroFilter, extensionAnalyticsInfo, onCompleteCallback, updateMacro);
        const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(macro.macroName, node.attrs.parameters?.macroParams?.['serverId']?.value);
        if (editorActions.replaceSelection(node) && createAnalyticsEvent) {
            const isSupportedMacro = await $7b3d41287d889ce8$export$f3046997f1755ab7(macro.macroName);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'inserted',
                    actionSubject: 'macro',
                    actionSubjectId: macro.macroName,
                    source: 'quick insert menu',
                    attributes: {
                        inputMethod: 'macroBrowser',
                        extensionType: node?.type,
                        appKey: (0, $2E7zk.getConnectAppKey)(macro.moduleKey),
                        isLivePage: isLivePage,
                        jiraHostingOption: jiraHostingOption,
                        ...isLivePage && isSupportedMacro !== undefined && {
                            isSupportedMacro: isSupportedMacro
                        },
                        ...$7b3d41287d889ce8$var$maybeGetGadgetUrl(macro)
                    }
                }
            }).fire();
        }
    };
const $7b3d41287d889ce8$var$createActionForMacrosThatCanUseNewConfig = (macro, pageContext, intl, editorAPI, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage = false, isLivePagesFeatureEnabled)=>async ()=>{
        if (!editorActions) throw new Error(`editorActions is missing`);
        const getNode = $7b3d41287d889ce8$var$createBaseMacroAction(macro, pageContext, intl, undefined, isLivePage, isLivePagesFeatureEnabled);
        const node = await getNode();
        // Default the TOC style to none
        if (node?.attrs?.extensionKey === 'toc') {
            if (node?.attrs?.parameters?.macroParams) node.attrs.parameters.macroParams['style'] = {
                value: 'none'
            };
        }
        // Default the anchor macro name to a random UUID
        if (node?.attrs?.extensionKey === 'anchor') {
            if (node?.attrs?.parameters?.macroParams) node.attrs.parameters.macroParams[''] = {
                value: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
            };
        }
        // Add a param to show that the macro is missing required parameters
        const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = node.attrs;
        if ((0, $eQyFc.isMissingAnyRequiredParameters)(macro, {
            extensionType: extensionType,
            extensionKey: extensionKey,
            parameters: parameters
        })) {
            if (node.attrs.parameters?.macroParams) node.attrs.parameters.macroParams['isMissingRequiredParameters'] = {
                // Need to be `string` to be able to persist
                value: 'true'
            };
        }
        if (editorActions.replaceSelection(node) && createAnalyticsEvent) {
            const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(macro.macroName, node.attrs.parameters?.macroParams?.['serverId']?.value);
            const isSupportedMacro = await $7b3d41287d889ce8$export$f3046997f1755ab7(macro.macroName);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'inserted',
                    actionSubject: 'macro',
                    actionSubjectId: macro.macroName,
                    source: 'quick insert menu',
                    attributes: {
                        inputMethod: 'configPanel',
                        extensionType: node?.type,
                        appKey: (0, $2E7zk.getConnectAppKey)(macro.moduleKey),
                        isLivePage: isLivePage,
                        jiraHostingOption: jiraHostingOption,
                        ...isLivePage && isSupportedMacro !== undefined && {
                            isSupportedMacro: isSupportedMacro
                        },
                        ...$7b3d41287d889ce8$var$maybeGetGadgetUrl(macro)
                    }
                }
            }).fire();
        }
        editorAPI?.extension?.actions?.editSelectedExtension();
        onCompleteCallback?.({
            macro: macro.macroName,
            isBodiedExtension: (0, $fgbpl.isBodiedExtension)(node?.type)
        });
    };
const $7b3d41287d889ce8$export$5f32dd5e0bdce03 = (macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, isLivePagesFeatureEnabled)=>{
    const { enabled: isConfigPanelEnabled, optedOut: excludedMacros } = pageContext.features.configPanel || {};
    // using the detailed legacy macro manifest list, the attributes `anyParameterRequired` and `alwaysShowConfig` are not available so we need to calculate ourselves
    const hasRequiredParameter = macro.anyParameterRequired || macro.formDetails.parameters.some((param)=>param.required && param.defaultValue === null);
    const useNewConfigExperience = isConfigPanelEnabled && !(0, $eQyFc.shouldUseMacroBrowser)(macro, excludedMacros);
    const showInitialConfig = // always show the config panel if we are using the new config experience
    useNewConfigExperience || hasRequiredParameter || macro.alwaysShowConfig || (0, $eQyFc.needsToForceConfig)(macro);
    if (showInitialConfig) {
        if (!useNewConfigExperience) return $7b3d41287d889ce8$var$createActionForMacrosThatRequireMacroBrowser(macro, openMacroBrowserForInitialConfiguration, editorAPI, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage);
        else return $7b3d41287d889ce8$var$createActionForMacrosThatCanUseNewConfig(macro, pageContext, intl, editorAPI, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, isLivePagesFeatureEnabled);
    } else return $7b3d41287d889ce8$var$createBaseMacroAction(macro, pageContext, intl, createAnalyticsEvent, isLivePage, isLivePagesFeatureEnabled);
};
const $7b3d41287d889ce8$export$f3046997f1755ab7 = async (macroKey)=>{
    if (!macroKey) return undefined;
    const macroFallbackUiAllowlist = (0, $4VJDS.default).getStringList('confluence_frontend_macro_fallback_ui_allowlist', []);
    if (macroFallbackUiAllowlist.length === 0) return undefined;
    else if (macroFallbackUiAllowlist[0] === 'ALLOW_ALL') return true;
    const macros = macroFallbackUiAllowlist.map((m)=>m.trim().toLowerCase());
    return macros.includes(macroKey.toLowerCase());
};



var $9tVje = parcelRequire("9tVje");

const $7dade95d99fee536$var$pageIdRegex = /^[0-9]+$/;
const $7dade95d99fee536$export$a1337ae19b5dbc53 = (id)=>$7dade95d99fee536$var$pageIdRegex.test(id);
const $7dade95d99fee536$export$ab1c71053e82e441 = (editorActions)=>{
    const editorView = editorActions?._privateGetEditorView();
    if (editorView) {
        let maybeNode = editorView.state.selection.node;
        if (!maybeNode || !(0, $fgbpl.isBodiedExtension)(maybeNode.type.name)) {
            const { $head: $head } = editorView.state.selection;
            // If current selection isn't bodied extension traverse upward
            for(let i = $head.depth; i > 0; i--){
                const node = $head.node(i);
                if ((0, $fgbpl.isBodiedExtension)(node.type.name)) maybeNode = node;
            }
        }
        return maybeNode?.toJSON();
    }
};
const $7dade95d99fee536$export$aa7156f87802b87e = (value)=>(value === 0 || value === false || !!value) && (!Array.isArray(value) || value.length > 0);
const $7dade95d99fee536$export$80b5cdf6b2ae3720 = (macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, isLivePagesFeatureEnabled)=>{
    // Hidden macros don't appear in the slash menu
    // but still need to be defined in a manifest so old pages can show them
    if (macro.hidden) return [];
    const macroName = (0, $eQyFc.safeGetMacroName)(macro);
    try {
        const action = (0, $7b3d41287d889ce8$export$5f32dd5e0bdce03)(macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, isLivePagesFeatureEnabled);
        return [
            {
                key: macroName,
                title: macro.title,
                description: macro.description,
                keywords: [
                    macro.macroName,
                    ...macro.aliases
                ],
                categories: macro.categories,
                icon: async ()=>()=>(0, $9tVje.getIconComponent)(macro),
                featured: pageContext.features.elementBrowser && (0, $8pcS0.allowedMacrosForInsertMenu).includes(macroName),
                action: action
            }
        ];
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return [];
    }
};
const $7dade95d99fee536$export$b57d0f2bae8a9afe = (macroKey)=>{
    if (!macroKey || !macroKey.startsWith('com.atlassian.plugins.atlassian-connect-plugin')) return '';
    const chunks = macroKey.split('__');
    if (chunks.length !== 3) return '';
    return chunks[1];
};
const $7dade95d99fee536$export$7ea0c9b6e4a8ed9f = (node, placeholderText)=>{
    node.content = [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'placeholder',
                    attrs: {
                        text: placeholderText
                    }
                }
            ]
        }
    ];
};
const $7dade95d99fee536$export$907c23452d19a3a0 = (node, keyPlaceholderHeading, valuePlaceholderHeading)=>{
    node.content = [
        {
            type: 'table',
            attrs: {
                isNumberColumnEnabled: false,
                layout: 'default',
                localId: (0, $9Cbhx.getMacroId)(null),
                width: 760
            },
            content: [
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'placeholder',
                                            attrs: {
                                                text: keyPlaceholderHeading
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {
                                background: '#ffffff'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'placeholder',
                                            attrs: {
                                                text: valuePlaceholderHeading
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {
                                background: '#f4f5f7'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {
                                background: '#f4f5f7'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
};
const $7dade95d99fee536$var$getMatchingAppLinkForViewPage = async (selectedServerId)=>{
    try {
        const res = await (0, $f7B1p.cfetch)('/wiki/rest/jiraanywhere/1.0/servers');
        const appLinks = await res.json();
        return appLinks.find((appLink)=>appLink.id === selectedServerId);
    } catch  {}
};
const $7dade95d99fee536$var$isCloudAppLinkFromUrl = (url)=>{
    if (!url) return;
    return url.includes('atlassian.net') || url.includes('jira-dev.com');
};
const $7dade95d99fee536$export$e907759e00918f39 = async (macroName, selectedServerId = '', isViewPage = false)=>{
    if (macroName !== 'jira') return;
    let isCloudAppLink;
    if (isViewPage) {
        const selectedServerObject = await $7dade95d99fee536$var$getMatchingAppLinkForViewPage(selectedServerId);
        isCloudAppLink = $7dade95d99fee536$var$isCloudAppLinkFromUrl(selectedServerObject?.url) || $7dade95d99fee536$var$isCloudAppLinkFromUrl(selectedServerObject?.rpcUrl);
    } else try {
        // module is only available on edit page
        const ApplinksBridge = window.require('confluence/jim/jira/applinks-bridge-for-spa');
        isCloudAppLink = await ApplinksBridge.isCloudAppLinkFromServerId(selectedServerId);
    } catch  {}
    if (isCloudAppLink === undefined) return 'unknown';
    return isCloudAppLink ? 'cloud' : 'server';
};
const $7dade95d99fee536$export$b44fac35bec9acb1 = new Set([
    'anchor',
    'attachments',
    'calendar',
    'children',
    'contentbylabel',
    'content-report-table',
    'create-from-template',
    'decisionreport',
    'detailssummary',
    'gadget',
    'excerpt',
    'excerpt-include',
    'expand',
    'iframe',
    'include',
    'jira',
    'listlabels',
    'pagetree',
    'pagetreesearch',
    'panel',
    'popular-labels',
    'profile',
    'recently-updated-dashboard',
    'roadmap',
    'spaces',
    'tasks-report-macro',
    'toc',
    'toc-zone',
    'userlister',
    'viewpdf',
    'viewxls'
]);
const $7dade95d99fee536$export$30d8e5826b733890 = (macros, hideMacrosOptions)=>{
    const newMacros = [];
    const macrosToHideLivePage = new Set((0, $4VJDS.default).getStringList('confluence_frontend_hide_selected_macros', []));
    for (const macro of macros){
        const hideCompanyHubMacro = hideMacrosOptions?.isCompanyHub && $7dade95d99fee536$export$b44fac35bec9acb1.has(macro?.macroName);
        const hideLivePageMacro = hideMacrosOptions?.isLivePage && macrosToHideLivePage.has(macro?.macroName);
        if (hideCompanyHubMacro || hideLivePageMacro) {
            const hiddenMacro = {
                ...macro,
                hidden: true
            };
            newMacros.push(hiddenMacro);
        } else newMacros.push(macro);
    }
    return newMacros;
};
module.exports["isPageId"] = $7dade95d99fee536$export$a1337ae19b5dbc53;
module.exports["getSelectedBodiedExtensionNode"] = $7dade95d99fee536$export$ab1c71053e82e441;
module.exports["isValueSet"] = $7dade95d99fee536$export$aa7156f87802b87e;
module.exports["createQuickInsertModule"] = $7dade95d99fee536$export$80b5cdf6b2ae3720;
module.exports["getConnectAppKey"] = $7dade95d99fee536$export$b57d0f2bae8a9afe;
module.exports["insertMacroPlaceholder"] = $7dade95d99fee536$export$7ea0c9b6e4a8ed9f;
module.exports["insertContentPropertiesMacroPlaceholder"] = $7dade95d99fee536$export$907c23452d19a3a0;
module.exports["getJiraHostingOption"] = $7dade95d99fee536$export$e907759e00918f39;
module.exports["filterOutHiddenMacros"] = $7dade95d99fee536$export$30d8e5826b733890;

});

parcelRegister("lEnS1", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc2fd989ef58b0b5$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $dWysp = parcelRequire("dWysp");


var $b5utg = parcelRequire("b5utg");

function $fc2fd989ef58b0b5$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $b5utg.default)(1, arguments);
    var originalDate = (0, $egXhZ.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $dWysp.default)(originalDate.getDate(), 2);
        var month = (0, $dWysp.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $dWysp.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $dWysp.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $dWysp.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $dWysp.default)(originalDate.getHours(), 2);
        var minute = (0, $dWysp.default)(originalDate.getMinutes(), 2);
        var second = (0, $dWysp.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("kTVK2", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $735a35f26a402a9b$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    basicTabLabel: {
        id: "fabric-extension-lib.recently-updated.tab.basic.label",
        defaultMessage: "Basic"
    },
    displayTabLabel: {
        id: "fabric-extension-lib.recently-updated.tab.display.label",
        defaultMessage: "Display"
    },
    spaceLabel: {
        id: "fabric-extension-lib.recently-updated.field.spaces.label",
        defaultMessage: "Space"
    },
    spacePlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.spaces.placeholder",
        defaultMessage: "Search and select by name"
    },
    typesLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.label",
        defaultMessage: "Include in list"
    },
    typePlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.types.placeholder",
        defaultMessage: "Select one or several"
    },
    maxToggleLabel: {
        id: "fabric-extension-lib.recently-updated.field.maxToggle.label",
        defaultMessage: "Show all updates"
    },
    maxLabel: {
        id: "fabric-extension-lib.recently-updated.field.max.label",
        defaultMessage: "Max number of updates"
    },
    themeLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.label",
        defaultMessage: "List style"
    },
    authorLabel: {
        id: "fabric-extension-lib.recently-updated.field.author.label",
        defaultMessage: "Filter by user"
    },
    authorPlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.author.placeholder",
        defaultMessage: "Search and select user(s)"
    },
    labelsLabel: {
        id: "fabric-extension-lib.recently-updated.field.labels.label",
        defaultMessage: "Filter by label"
    },
    labelsPlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.labels.placeholder",
        defaultMessage: "Search and select label(s)"
    },
    widthLabel: {
        id: "fabric-extension-lib.recently-updated.field.width.label",
        defaultMessage: "List width"
    },
    widthPlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.width.placeholder",
        defaultMessage: "Select or enter width"
    },
    hideHeadingLabel: {
        id: "fabric-extension-lib.recently-updated.field.hideHeading.label",
        defaultMessage: "Hide list header"
    }
});
const $735a35f26a402a9b$export$e89c4678ffd2a62b = (0, $cgtv4.defineMessages)({
    allLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.all",
        defaultMessage: "All"
    },
    pageLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.page",
        defaultMessage: "Pages"
    },
    livePageLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.live-page",
        defaultMessage: "Live docs"
    },
    blogPostLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.blogpost",
        defaultMessage: "Blog posts"
    },
    commentLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.comment",
        defaultMessage: "Comments"
    },
    attachmentLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.attachment",
        defaultMessage: "Attachments"
    }
});
const $735a35f26a402a9b$export$cfae297845436803 = (0, $cgtv4.defineMessages)({
    conciseLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.concise",
        defaultMessage: "Title + user name"
    },
    sidebarLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.sidebar",
        defaultMessage: "Title"
    },
    socialLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.social",
        defaultMessage: "User name + profile picture"
    }
});
const $735a35f26a402a9b$export$9227588ce3953cff = (0, $cgtv4.defineMessages)({
    fullLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.full",
        defaultMessage: "100% of frame"
    },
    threeQuartersLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.threeQuarters",
        defaultMessage: "75% of frame"
    },
    halfLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.half",
        defaultMessage: "50% of frame"
    },
    quarterLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.quarter",
        defaultMessage: "25% of frame"
    }
});
module.exports["i18n"] = $735a35f26a402a9b$export$a7357cdd1f0b0168;
module.exports["i18nTypes"] = $735a35f26a402a9b$export$e89c4678ffd2a62b;
module.exports["i18nTheme"] = $735a35f26a402a9b$export$cfae297845436803;
module.exports["i18nWidth"] = $735a35f26a402a9b$export$9227588ce3953cff;

});

parcelRegister("gw2T1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $eSUdr = parcelRequire("eSUdr");


var $hp2SH = parcelRequire("hp2SH");


var $2DGtt = parcelRequire("2DGtt");


var $10Oe6 = parcelRequire("10Oe6");


var $c2cyb = parcelRequire("c2cyb");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

var $dcac0b0097aba21f$var$SortOrder = /*#__PURE__*/ function(SortOrder) {
    SortOrder["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    return SortOrder;
}($dcac0b0097aba21f$var$SortOrder || {});
const $dcac0b0097aba21f$var$AllTemplatesQuery = // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Read https://go/connie-relay-migration-fyi
(0, $eSUdr.default)`query AllTemplatesQuery($spaceKey:String!$sortingScheme:String!){allTemplates(spaceKey:$spaceKey sortingScheme:$sortingScheme){nodes{name description templateId contentBlueprintId iconURL darkModeIconURL}}}`;
const $dcac0b0097aba21f$var$loadLegacyTemplateStyles = (0, $2XqLN.default)((0, $2DGtt.requireStyleClassResourcesForTemplates));
const $dcac0b0097aba21f$var$getAllTemplates = async (spaceKey)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const allTemplatesData = await (0, $hp2SH.getApolloClient)().query({
        query: $dcac0b0097aba21f$var$AllTemplatesQuery,
        variables: {
            spaceKey: spaceKey,
            sortingScheme: "web.item.sorting.scheme.relevancy"
        }
    });
    return allTemplatesData?.data.allTemplates?.nodes;
};
const $dcac0b0097aba21f$var$search = async (spaceKey)=>{
    try {
        const templates = await $dcac0b0097aba21f$var$getAllTemplates(spaceKey);
        return templates.map((template)=>({
                label: template.name,
                description: template.description,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c2cyb.TemplateIcon), {
                    size: "small",
                    template: template
                }),
                value: (0, $10Oe6.getTemplateId)(template)
            }));
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Failed to fetch templates from template resolver in macro config panel with error: ${error}`), {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        return [];
    }
};
const $dcac0b0097aba21f$export$a95dc440d0d8d0bc = (spaceKey)=>async (_searchTerm, _selectedValue)=>{
        return spaceKey ? $dcac0b0097aba21f$var$search(spaceKey) : [];
    };
const $dcac0b0097aba21f$export$e9ae85abdbcb00ec = ({ spaceKey: spaceKey })=>{
    $dcac0b0097aba21f$var$loadLegacyTemplateStyles();
    return $dcac0b0097aba21f$export$a95dc440d0d8d0bc(spaceKey);
};
module.exports["getTemplateResolver"] = $dcac0b0097aba21f$export$e9ae85abdbcb00ec;

});

parcelRegister("2DGtt", function(module, exports) {

var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $19aF3 = parcelRequire("19aF3");


var $6Ywr0 = parcelRequire("6Ywr0");


var $cpjd2 = parcelRequire("cpjd2");

const $86243521f2d43c3e$export$8a6adc80de847409 = ()=>{
    (0, $cpjd2.requireLegacyWRM)([
        'wrc!com.atlassian.plugins.atlassian-connect-plugin:blueprint-css-resources',
        'wrc!com.atlassian.plugins.atlassian-connect-plugin:dynamic-css-resources'
    ], ()=>{
        // Although we've included 'wr!com.atlassian.plugins.atlassian-connect-plugin:dynamic-css-resources' here
        // The 'link-style-css' may have been executed somewhere else previously.
        // Requiring it again will not have effect. Here we are going to manually initialize it.
        (0, $6Ywr0.waitForRequiredModule)({
            listener: 'TemplateList',
            module: 'ac/confluence/style/link-style-css'
        }, ()=>{
            const linkStyleCSS = (0, $19aF3.globalRequire)('ac/confluence/style/link-style-css');
            if (linkStyleCSS && typeof linkStyleCSS.addLinkTags === 'function') linkStyleCSS.addLinkTags();
        });
    }, ()=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error('Style classes cannot be initialized when WRM is disabled.'), {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    });
};
module.exports["requireStyleClassResourcesForTemplates"] = $86243521f2d43c3e$export$8a6adc80de847409;

});

parcelRegister("ebUME", function(module, exports) {
/* eslint-disable react/jsx-no-bind */ 
var $42omo = parcelRequire("42omo");


var $lspPP = parcelRequire("lspPP");


var $8pcS0 = parcelRequire("8pcS0");


var $eS4Za = parcelRequire("eS4Za");


var $5kjCz = parcelRequire("5kjCz");


var $hEeUR = parcelRequire("hEeUR");


var $5a4cC = parcelRequire("5a4cC");


var $9m03g = parcelRequire("9m03g");


var $frIzR = parcelRequire("frIzR");





var $jJli4 = parcelRequire("jJli4");


var $2w2Hu = parcelRequire("2w2Hu");

var $3GQl6 = parcelRequire("3GQl6");

const $073def04dea47e25$export$682885b7d6415d72 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, spaceKey: spaceKey, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, Renderer: Renderer, getExtensionHandlers: getExtensionHandlers } = t0;
    (0, $3GQl6.mustPreloadWhenRenderingSPA)([
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicRendererLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicEditorContextProviderLoader
    ]);
    let t1;
    if ($[0] !== Renderer || $[1] !== appearance || $[2] !== getExtensionHandlers || $[3] !== showTemplateInputInPreview || $[4] !== showTemplateVariablesInPreview || $[5] !== spaceKey) {
        t1 = (t2)=>{
            const { targetContentId: targetContentId, adf: adf, mediaToken: mediaToken } = t2;
            const document = {
                type: "doc",
                version: 1,
                content: adf
            };
            const extensionHandlers = getExtensionHandlers({
                adf: document,
                contentId: targetContentId,
                appearance: appearance,
                showTemplateInputInPreview: showTemplateInputInPreview,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Renderer, {
                contentId: targetContentId,
                document: document,
                hasInlineComments: false,
                showTemplateInputInPreview: showTemplateInputInPreview,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview,
                extensionHandlers: extensionHandlers,
                appearance: appearance || "default",
                spaceKey: spaceKey,
                mediaToken: mediaToken
            });
        };
        $[0] = Renderer;
        $[1] = appearance;
        $[2] = getExtensionHandlers;
        $[3] = showTemplateInputInPreview;
        $[4] = showTemplateVariablesInPreview;
        $[5] = spaceKey;
        $[6] = t1;
    } else t1 = $[6];
    const RendererWrapper = t1;
    let t2;
    if ($[7] !== RendererWrapper || $[8] !== contentId || $[9] !== extensionKey || $[10] !== mode || $[11] !== node || $[12] !== spaceKey) {
        const componentProps = {
            mode: mode,
            contentId: contentId,
            spaceKey: spaceKey,
            extensionKey: extensionKey,
            macroNode: node,
            RendererWrapper: RendererWrapper,
            isLegacyRenderer: false
        };
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJli4.ExcerptIncludeLoader), componentProps);
        $[7] = RendererWrapper;
        $[8] = contentId;
        $[9] = extensionKey;
        $[10] = mode;
        $[11] = node;
        $[12] = spaceKey;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
};



var $l86Zj = parcelRequire("l86Zj");


var $6v9Za = parcelRequire("6v9Za");


var $2LCBF = parcelRequire("2LCBF");


var $hKeSi = parcelRequire("hKeSi");


var $1aGr8 = parcelRequire("1aGr8");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");








var $6mEZ3 = parcelRequire("6mEZ3");


var $l7BGZ = parcelRequire("l7BGZ");

const $3f248c73bf14394e$export$e8ac5007ab7a695a = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { macroDefaultProps: macroDefaultProps } = t0;
    const { node: node } = macroDefaultProps;
    let t1;
    if ($[0] !== node) {
        t1 = (0, $6mEZ3.extensionToADF)(node);
        $[0] = node;
        $[1] = t1;
    } else t1 = $[1];
    const macroNode = t1;
    let t2;
    if ($[2] !== macroNode) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l7BGZ.LiveSearchLoader), {
            macroNode: macroNode
        });
        $[2] = macroNode;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};









var $dwS6P = parcelRequire("dwS6P");

const $13135e29d0f1ffa1$export$cf1c26fcb7e6ff9f = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { macroDefaultProps: macroDefaultProps, adf: adf, cloudId: cloudId, userId: userId } = t0;
    let t1;
    if ($[0] !== adf || $[1] !== cloudId || $[2] !== macroDefaultProps || $[3] !== userId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dwS6P.TableOfContentsLoader), {
            userId: userId,
            cloudId: cloudId,
            adf: adf,
            macroDefaultProps: macroDefaultProps
        });
        $[0] = adf;
        $[1] = cloudId;
        $[2] = macroDefaultProps;
        $[3] = userId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};









var $cYJC5 = parcelRequire("cYJC5");

const $3211097f4985a15f$export$30c773822372f598 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { macroDefaultProps: macroDefaultProps, cloudId: cloudId, userId: userId, ssrButtonLabel: ssrButtonLabel } = t0;
    let t1;
    if ($[0] !== cloudId || $[1] !== macroDefaultProps || $[2] !== ssrButtonLabel || $[3] !== userId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cYJC5.CreateFromTemplateLoader), {
            userId: userId,
            cloudId: cloudId,
            macroDefaultProps: macroDefaultProps,
            ssrButtonLabel: ssrButtonLabel
        });
        $[0] = cloudId;
        $[1] = macroDefaultProps;
        $[2] = ssrButtonLabel;
        $[3] = userId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};



var $989nU = parcelRequire("989nU");

















var $4KFTW = parcelRequire("4KFTW");


var $aJPUt = parcelRequire("aJPUt");


var $fPNzj = parcelRequire("fPNzj");











var $5VmpF = parcelRequire("5VmpF");


var $e4o8D = parcelRequire("e4o8D");

function $91e6b8d2baf46122$export$3ecdc0417ec1be45(t0) {
    const $ = (0, $frIzR.c)(6);
    const { children: children, macroId: macroId } = t0;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    if ($[0] !== macroId || $[1] !== renderServerPlaceholder) {
        t1 = renderServerPlaceholder ? {
            ssrPlaceholder: macroId
        } : {
            ssrPlaceholderReplace: macroId
        };
        $[0] = macroId;
        $[1] = renderServerPlaceholder;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== children || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5VmpF.InlineNodeRendererWrapper), t1, children);
        $[3] = children;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
}


const $10f699a561b7c8ad$export$4481a29084474468 = ({ contentId: contentId })=>(0, $eS4Za.createMacroExtensionHandler)((extension)=>{
        if (!extension) return null;
        const { type: type, extensionKey: extensionKey, parameters: parameters } = extension;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const macroId = attributes?.macroId;
        const defaultProps = {
            contentId: contentId,
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey,
            attributes: attributes,
            node: extension
        };
        let content = null;
        if (extensionKey === (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE) {
            const inlineExternalImageProps = parameters;
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
                name: (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension),
                mode: (0, $5kjCz.RENDERER),
                extensionKey: extensionKey,
                attributes: attributes,
                timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                contentId: contentId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fPNzj.InlineExternalImage), {
                ...inlineExternalImageProps,
                ...defaultProps
            })));
        }
        // This boundary is not directly used but it provides reference for fixing nested div under span.
        // See next/packages/ssr-scripts-utils/src/fixUnbalancedPlaceholderCommentMarkers.ts for details
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1aGr8.LoadablePlaceholderServer), {
            placeholderId: `migration-ext-container-${macroId}`
        }, type === 'inlineExtension' ? // Mimic the logic in platform/packages/editor/renderer/src/ui/ExtensionRenderer.tsx
        // We don't update the platform code for 2 reasons:
        // 1. Backwards compatibility. I don't know if other product supplies this wrapper already (unlikely)
        // 2. More importantly this needs to be inside the migration-ext-container-${macroId} boundary.
        //    Inline macros has <span> nested in <div> problem. We are using the boundary as guide to fix them.
        //    See next/packages/ssr-scripts-utils/src/fixUnbalancedPlaceholderCommentMarkers.ts
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $91e6b8d2baf46122$export$3ecdc0417ec1be45), {
            macroId: macroId
        }, content) : content);
    });



const $dff9e4cf0075d57c$var$context = {
    insertCss: (styles)=>styles._insertCss()
};
const $dff9e4cf0075d57c$export$be8c01ded2deab2c = ({ adf: adf, contentId: contentId, spaceKey: spaceKey, cloudId: cloudId, userId: userId, macroRenderedOutput: macroRenderedOutput, includeSuperbatch: includeSuperbatch, mediaToken: mediaToken })=>({
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: $dff9e4cf0075d57c$var$getMacroExtensionHandlerForRenderer({
            adf: adf,
            contentId: contentId,
            spaceKey: spaceKey,
            cloudId: cloudId,
            userId: userId,
            macroRenderedOutput: macroRenderedOutput,
            includeSuperbatch: includeSuperbatch,
            mediaToken: mediaToken
        }),
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES]: $dff9e4cf0075d57c$var$getEmptyHandlers(),
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: (0, $10f699a561b7c8ad$export$4481a29084474468)({
            contentId: contentId
        }),
        [(0, $8pcS0.EXTENSION_TYPE).TEMPLATE]: $dff9e4cf0075d57c$var$getEmptyHandlers()
    });
const $dff9e4cf0075d57c$var$getEmptyHandlers = ()=>(0, $eS4Za.createMacroExtensionHandler)(()=>null);
const $dff9e4cf0075d57c$export$d3d0d63f461591f5 = ({ macroDefaultProps: macroDefaultProps, extension: extension, cloudId: cloudId, contentId: contentId, userId: userId, adf: adf, mediaToken: mediaToken })=>{
    function getSsrButtonLabel() {
        const { buttonLabel: buttonLabel, createButtonLabel: createButtonLabel } = macroDefaultProps.node.parameters.macroParams;
        const labelText = buttonLabel?.value || createButtonLabel?.value;
        return labelText || undefined;
    }
    return {
        [(0, $8pcS0.EXTENSION_KEY).TOC]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13135e29d0f1ffa1$export$cf1c26fcb7e6ff9f), {
                macroDefaultProps: macroDefaultProps,
                adf: adf,
                cloudId: cloudId,
                userId: userId
            }),
        [(0, $8pcS0.EXTENSION_KEY).CREATE_FROM_TEMPLATE]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3211097f4985a15f$export$30c773822372f598), {
                macroDefaultProps: macroDefaultProps,
                cloudId: cloudId,
                userId: userId,
                ssrButtonLabel: getSsrButtonLabel()
            }),
        [(0, $8pcS0.EXTENSION_KEY).LIVE_SEARCH]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3f248c73bf14394e$export$e8ac5007ab7a695a), {
                macroDefaultProps: macroDefaultProps
            }),
        [(0, $8pcS0.EXTENSION_KEY).DETAILS]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hKeSi.DetailsExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                isLegacyRenderer: false,
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            }),
        [(0, $8pcS0.EXTENSION_KEY).EXPAND]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6v9Za.ExpandExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                isLegacyRenderer: false,
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            }),
        [(0, $8pcS0.EXTENSION_KEY).EXCERPT]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2LCBF.ExcerptExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                isLegacyRenderer: false,
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c,
                mediaToken: mediaToken
            }),
        [(0, $8pcS0.EXTENSION_KEY).ANCHOR]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l86Zj.AnchorExtensionHandler), {
                ...macroDefaultProps,
                isSSR: true
            }),
        [(0, $8pcS0.EXTENSION_KEY).EXCERPT_INCLUDE]: ()=>{
            if (contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $073def04dea47e25$export$682885b7d6415d72), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            });
            else return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).PROFILE_PICTURE]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9m03g.ProfilePictureMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            }),
        [(0, $8pcS0.EXTENSION_KEY).PROFILE]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5a4cC.UserProfileMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            }),
        /* These macros have React implementation on SPA */ [(0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY]: ()=>null,
        [(0, $8pcS0.EXTENSION_KEY).REDACTED_MACRO_PLACEHOLDER]: ()=>null,
        [(0, $8pcS0.EXTENSION_KEY).CONFLUENCE_DATABASES]: ()=>null
    };
};
const $dff9e4cf0075d57c$var$getMacroExtensionHandlerForRenderer = ({ adf: adf, contentId: contentId, spaceKey: spaceKey, cloudId: cloudId, userId: userId, includeSuperbatch: includeSuperbatch, macroRenderedOutput: macroRenderedOutput, mediaToken: mediaToken })=>(0, $eS4Za.createMacroExtensionHandler)((extension)=>{
        const { type: type, extensionKey: extensionKey } = extension;
        const macroId = extension?.parameters?.macroMetadata?.macroId?.value;
        const macroDefaultProps = {
            node: extension,
            contentId: contentId,
            spaceKey: spaceKey,
            context: $dff9e4cf0075d57c$var$context,
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey
        };
        // This callback won't be available on a recursive call for handlers from bodied macros
        // but it only needs to be called on the top level of recursion.
        if (includeSuperbatch) includeSuperbatch();
        const serverExtensionHandlersMap = $dff9e4cf0075d57c$export$d3d0d63f461591f5({
            adf: adf,
            userId: userId,
            contentId: contentId,
            cloudId: cloudId,
            extension: extension,
            macroDefaultProps: macroDefaultProps,
            ...(0, $6mKj3.expVal)('confluence_frontend_fix_excerpt_media_issue', 'isEnabled', false) ? {
                mediaToken: mediaToken
            } : {}
        });
        const handlerContent = serverExtensionHandlersMap[extensionKey];
        // When early webpanel initialization is enabled, Connect resources are preloaded during SSR.
        // To prevent flickering during React hydration, we need to hide Connect macros in the SSR phase
        // by setting renderedByProvider=false. After hydration, when macros are re-rendered through
        // the provider flow (LegacyMacroRendererComponent), they will have renderedByProvider=true
        const shouldHideDuringSSR = (0, $9wGTI.fg)('content_early_connect_iframe_initialization') || (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false);
        const content = typeof handlerContent === 'function' ? handlerContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $989nU.FabricLegacyMacrosServerRenderer), {
            macroRenderedOutput: macroRenderedOutput,
            macroDefaultProps: macroDefaultProps,
            macroOutput: extension?.parameters?.macroOutput,
            renderedByProvider: !shouldHideDuringSSR
        });
        // This boundary is not directly used but it provides reference for fixing nested div under span.
        // See next/packages/ssr-scripts-utils/src/fixUnbalancedPlaceholderCommentMarkers.ts for details
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1aGr8.LoadablePlaceholderServer), {
            placeholderId: `legacy-macro-container-${macroId}`
        }, // Mimic the logic in platform/packages/editor/renderer/src/ui/ExtensionRenderer.tsx
        // We don't update the platform code for 2 reasons:
        // 1. Backwards compatibility. I don't know if other product supplies this wrapper already (unlikely)
        // 2. More importantly this needs to be inside the legacy-macro-container-${macroId} boundary.
        //    Inline macros has <span> nested in <div> problem. We are using the boundary as guide to fix them.
        //    See next/packages/ssr-scripts-utils/src/fixUnbalancedPlaceholderCommentMarkers.ts
        type === 'inlineExtension' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $91e6b8d2baf46122$export$3ecdc0417ec1be45), {
            macroId: macroId
        }, content) : content));
    });
module.exports["getSsrExtensionHandlers"] = $dff9e4cf0075d57c$export$be8c01ded2deab2c;

});

parcelRegister("eS4Za", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $hp2SH = parcelRequire("hp2SH");

const $b665af2ad4850853$export$399071cd24abe8c9 = (extensionHandler)=>(extension, ...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j1Ss3.ApolloProvider), {
            client: (0, $hp2SH.getApolloClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                value: sessionData
            }, extensionHandler(extension, args)))));
module.exports["createMacroExtensionHandler"] = $b665af2ad4850853$export$399071cd24abe8c9;

});

parcelRegister("5a4cC", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f06d0ac854f743bf$export$6e074cbc05db83c0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HdoLX",
    name: "UserProfileMacroHandler",
    loader: async ()=>(await (parcelRequire("ekKnS"))).UserProfileMacroRenderer
});
module.exports["UserProfileMacroHandler"] = $f06d0ac854f743bf$export$6e074cbc05db83c0;

});

parcelRegister("ekKnS", function(module, exports) {

let $a6f6e9dc7b68a79f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a6f6e9dc7b68a79f$var$load("6wr18"),
    $a6f6e9dc7b68a79f$var$load("ffEVr"),
    $a6f6e9dc7b68a79f$var$load("1a9Rr")
]).then(()=>parcelRequire('7fnEu'));

});

parcelRegister("9m03g", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3a1aa0d1408c31a1$export$ef74c28fadeef856 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9VP6s",
    name: "ProfilePictureMacroHandler",
    loader: async ()=>(await (parcelRequire("jFLvv"))).ProfilePictureMacroRenderer
});
module.exports["ProfilePictureMacroHandler"] = $3a1aa0d1408c31a1$export$ef74c28fadeef856;

});

parcelRegister("jFLvv", function(module, exports) {

let $e526b29b79a98a15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e526b29b79a98a15$var$load("1mjYg").then(()=>parcelRequire('lhP7Q'));

});

parcelRegister("jJli4", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $f9KPY = parcelRequire("f9KPY");


const $7549d063fe593b21$export$2800e3d415e59020 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8zrD8",
    name: "ExcerptIncludeLoader",
    loader: async ()=>(await (parcelRequire("j15Bh"))).ExcerptInclude,
    // Component shadow is a subset of ExcerptIncludeProps so this would generate a TS error here as Loadable
    // expects the prop types to match.
    // @ts-expect-error
    loading: (0, $f9KPY.ExcerptIncludeComponentShadow)
});
module.exports["ExcerptIncludeLoader"] = $7549d063fe593b21$export$2800e3d415e59020;

});

parcelRegister("f9KPY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $lOkIA = parcelRequire("lOkIA");


var $dhEYL = parcelRequire("dhEYL");

class $747c563e4499b240$export$8f88facf076a2d46 extends (0, $42omo.PureComponent) {
    render() {
        const { shouldPanelBeDisplayed: shouldPanelBeDisplayed, targetContentTitle: targetContentTitle } = this.props;
        return shouldPanelBeDisplayed ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": "excerpt-include-panel",
            style: (0, $dhEYL.panel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: (0, $dhEYL.panelHeader)
        }, targetContentTitle || // eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "editor.excerpt.include.panel.title.loading"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: (0, $dhEYL.panelBody)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        }))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        });
    }
}
module.exports["ExcerptIncludeComponentShadow"] = $747c563e4499b240$export$8f88facf076a2d46;

});

parcelRegister("dhEYL", function(module, exports) {
const $9b021e0aba5455d5$export$21f42ab9b6679f44 = {
    display: 'block',
    // DEBUGGING
    borderWidth: "var(--ds-border-width, 1px)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    borderImage: 'initial'
};
const $9b021e0aba5455d5$export$92937d9937dc7ce9 = {
    display: 'block',
    // DEBUGGING
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    minWidth: '128px',
    padding: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $9b021e0aba5455d5$export$d763905bda51ef54 = {
    display: 'block',
    // DEBUGGING
    minWidth: '128px',
    borderWidth: `${"var(--ds-border-width, 1px)"} 0px 0px 0px`,
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    padding: "var(--ds-space-100, 8px)"
};
const $9b021e0aba5455d5$export$99e3f651fb62ec86 = {
    color: "var(--ds-text-subtlest, #6B6E76)",
    paddingLeft: "var(--ds-space-050, 4px)"
};
module.exports["panel"] = $9b021e0aba5455d5$export$21f42ab9b6679f44;
module.exports["panelHeader"] = $9b021e0aba5455d5$export$92937d9937dc7ce9;
module.exports["panelBody"] = $9b021e0aba5455d5$export$d763905bda51ef54;
module.exports["panelHeaderExcerpt"] = $9b021e0aba5455d5$export$99e3f651fb62ec86;

});

parcelRegister("j15Bh", function(module, exports) {

let $dd82746dd95db38f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd82746dd95db38f$var$load("9tNcH").then(()=>parcelRequire('c6u22'));

});

parcelRegister("l86Zj", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $aFUXX = parcelRequire("aFUXX");


var $jxpvN = parcelRequire("jxpvN");


var $hrAmX = parcelRequire("hrAmX");


var $2tHI8 = parcelRequire("2tHI8");

const $9df11074aa88af9a$var$anchorWrapperStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    display: 'inline-block',
    height: '1em',
    width: '0'
});
const $9df11074aa88af9a$var$anchorStyles = (0, $ecnYn.xcss)({
    position: 'absolute'
});
const $9df11074aa88af9a$var$getAnchorName = (node)=>{
    const rawValue = node?.parameters?.macroParams?.['']?.value;
    if (typeof rawValue !== 'string') return null;
    return rawValue.replaceAll(/[%"'\s]/g, '');
};
const $9df11074aa88af9a$var$getLegacyAnchorName = (node)=>{
    return node?.parameters?.macroParams?.['legacyAnchorId']?.value;
};
const $9df11074aa88af9a$export$d5c71aa37ef97617 = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { node: node, isSSR: isSSR } = t0;
    const isHidden = Boolean(node?.parameters?.macroParams?.hidden?.value);
    let t1;
    if ($[0] !== node) {
        t1 = $9df11074aa88af9a$var$getAnchorName(node);
        $[0] = node;
        $[1] = t1;
    } else t1 = $[1];
    const anchorName = t1;
    let t2;
    if ($[2] !== node) {
        t2 = $9df11074aa88af9a$var$getLegacyAnchorName(node);
        $[2] = node;
        $[3] = t2;
    } else t2 = $[3];
    const legacyAnchorName = t2;
    const { includeTopNav: includeTopNav } = (0, $42omo.useContext)((0, $jxpvN.BannerContext));
    const panelHeight = (0, $2tHI8.useGeneralWebPanelHeight)();
    let t3;
    if ($[4] !== anchorName || $[5] !== isSSR) {
        t3 = isSSR ? {} : {
            name: anchorName
        };
        $[4] = anchorName;
        $[5] = isSSR;
        $[6] = t3;
    } else t3 = $[6];
    const anchorAttr = t3;
    let t4;
    if ($[7] !== isSSR || $[8] !== legacyAnchorName) {
        t4 = isSSR ? {} : {
            name: legacyAnchorName
        };
        $[7] = isSSR;
        $[8] = legacyAnchorName;
        $[9] = t4;
    } else t4 = $[9];
    const legacyAnchorAttr = t4;
    let t5;
    if ($[10] !== anchorAttr || $[11] !== anchorName || $[12] !== includeTopNav || $[13] !== isHidden || $[14] !== legacyAnchorAttr || $[15] !== legacyAnchorName || $[16] !== panelHeight) {
        t5 = !isHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "span",
            xcss: $9df11074aa88af9a$var$anchorWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $hrAmX.BannerStateContainer)
            ]
        }, (bannerState)=>{
            const navAndExtensionHeight = bannerState.getTotalHeight(includeTopNav) + panelHeight;
            const toolbarHeight = (0, $aFUXX.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !!anchorName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                as: "a",
                "data-group": "deeplink",
                testId: "anchor-extension-handler-anchor",
                xcss: $9df11074aa88af9a$var$anchorStyles,
                style: {
                    bottom: `calc(${navAndExtensionHeight}px + ${toolbarHeight})`
                },
                ...anchorAttr
            }), !!legacyAnchorName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                as: "a",
                "data-group": "deeplink",
                testId: "anchor-extension-handler-anchor-legacy",
                xcss: $9df11074aa88af9a$var$anchorStyles,
                style: {
                    bottom: `calc(${navAndExtensionHeight}px + ${toolbarHeight})`
                },
                ...legacyAnchorAttr
            }));
        })) : null;
        $[10] = anchorAttr;
        $[11] = anchorName;
        $[12] = includeTopNav;
        $[13] = isHidden;
        $[14] = legacyAnchorAttr;
        $[15] = legacyAnchorName;
        $[16] = panelHeight;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5);
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
};
module.exports["AnchorExtensionHandler"] = $9df11074aa88af9a$export$d5c71aa37ef97617;

});

parcelRegister("2tHI8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");

const $ba840c49dd70d4e9$export$322c13354cdebc20 = ()=>{
    const [panelHeight, setPanelHeight] = (0, $42omo.useState)(()=>{
        if (typeof window !== 'undefined' && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expValEquals)('confluence_editor_wrapper_ttvc_fix', 'isEnabled', true)) {
            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'];
            return initialHeight ?? 0;
        }
        return 0;
    });
    (0, $42omo.useEffect)(()=>{
        const updateHeight = (e)=>{
            if ((0, $6mKj3.expValEquals)('confluence_editor_wrapper_ttvc_fix', 'isEnabled', true)) // Use event detail height if available, otherwise fallback to 0
            setPanelHeight(e?.detail?.height ?? 0);
            else // Legacy behavior: read from CSS variable
            try {
                const heightValue = getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height');
                const numericValue = parseInt(heightValue, 10);
                setPanelHeight(!isNaN(numericValue) && numericValue >= 0 ? numericValue : 0);
            } catch (e) {
                setPanelHeight(0);
            }
        };
        !(0, $6mKj3.expValEquals)('confluence_editor_wrapper_ttvc_fix', 'isEnabled', true) && updateHeight();
        // Listen for height changes
        document.addEventListener('atlGeneralWebPanelHeightUpdated', updateHeight);
        return ()=>{
            document.removeEventListener('atlGeneralWebPanelHeightUpdated', updateHeight);
        };
    }, []);
    return panelHeight;
};
module.exports["useGeneralWebPanelHeight"] = $ba840c49dd70d4e9$export$322c13354cdebc20;

});

parcelRegister("6v9Za", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $6R5uz = parcelRequire("6R5uz");


var $eEA8O = parcelRequire("eEA8O");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $2w2Hu = parcelRequire("2w2Hu");

var $3GQl6 = parcelRequire("3GQl6");


var $6gj4X = parcelRequire("6gj4X");

const $2d8d2baed7861ad9$export$1ade295ab0337f6b = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                padding: "var(--ds-space-100, 8px) var(--ds-space-0, 0px) var(--ds-space-0, 0px) var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: {
                display: "inline-block",
                borderRadius: "var(--ds-radius-small, 3px)",
                backgroundColor: "var(--ds-surface, #FFFFFF)",
                width: "var(--ds-space-200, 16px)",
                height: "var(--ds-space-200, 16px)",
                margin: "var(--ds-space-025, 2px) var(--ds-space-200, 16px) var(--ds-space-025, 2px)\n        var(--ds-space-0, 0px)"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: {
                display: "inline-block",
                borderRadius: "var(--ds-radius-small, 3px)",
                backgroundColor: "var(--ds-surface, #FFFFFF)",
                width: 120,
                height: 20
            }
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $2d8d2baed7861ad9$var$EXPANDED_STYLES = {
    transition: 'opacity 0.5s',
    height: 'auto',
    opacity: 1,
    paddingLeft: "var(--ds-space-600, 48px)"
};
const $2d8d2baed7861ad9$var$COLLAPSED_STYLES = {
    transition: '0s',
    height: "var(--ds-space-0, 0px)",
    opacity: 0,
    overflow: 'hidden',
    paddingLeft: "var(--ds-space-600, 48px)",
    pointerEvents: 'none'
};
const $2d8d2baed7861ad9$export$633f4824b681947a = (t0)=>{
    const $ = (0, $frIzR.c)(57);
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, Renderer: Renderer, isLegacyRenderer: isLegacyRenderer, getExtensionHandlers: getExtensionHandlers, annotationProvider: annotationProvider } = t0;
    (0, $3GQl6.mustPreloadWhenRenderingSPA)([
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicRendererLoader
    ]);
    const [isExpanded, setExpanded] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setExpanded($2d8d2baed7861ad9$var$_temp);
        };
        $[0] = t1;
    } else t1 = $[0];
    const toggleExpand = t1;
    let t2;
    let t3;
    if ($[1] !== isExpanded) {
        t2 = ()=>{
            if (isExpanded) window.dispatchEvent(new Event("resize"));
        };
        t3 = [
            isExpanded
        ];
        $[1] = isExpanded;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[4] !== node) {
        t4 = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
        $[4] = node;
        $[5] = t4;
    } else t4 = $[5];
    const attributes = t4;
    const t5 = node?.content;
    let T0;
    let T1;
    let extensionHandlers;
    let t6;
    let t7;
    let t8;
    if ($[6] !== Renderer || $[7] !== appearance || $[8] !== contentId || $[9] !== getExtensionHandlers || $[10] !== isExpanded || $[11] !== isLegacyRenderer || $[12] !== node?.parameters?.macroParams?.title || $[13] !== showTemplateInputInPreview || $[14] !== showTemplateVariablesInPreview || $[15] !== t5) {
        const document = {
            type: "doc",
            version: 1,
            content: t5
        };
        const title = node?.parameters?.macroParams?.title;
        extensionHandlers = getExtensionHandlers && !isLegacyRenderer ? getExtensionHandlers({
            adf: document,
            contentId: contentId,
            appearance: appearance,
            showTemplateInputInPreview: showTemplateInputInPreview,
            showTemplateVariablesInPreview: showTemplateVariablesInPreview
        }) : undefined;
        T1 = (0, $42omo.Fragment);
        const t9 = isExpanded ? "rotate(90deg)" : "rotate(0deg)";
        let t10;
        if ($[22] !== t9) {
            t10 = {
                transform: t9,
                transition: "0.2s"
            };
            $[22] = t9;
            $[23] = t10;
        } else t10 = $[23];
        let t11;
        if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                color: "currentColor",
                spacing: "spacious",
                label: "",
                size: "small"
            });
            $[24] = t11;
        } else t11 = $[24];
        let t12;
        if ($[25] !== t10) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                style: t10
            }, t11);
            $[25] = t10;
            $[26] = t12;
        } else t12 = $[26];
        let t13;
        if ($[27] !== title) {
            t13 = title !== undefined ? title : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "content-renderer-extension-handlers.expand-macro.default-title",
                defaultMessage: "Click here to expand..."
            });
            $[27] = title;
            $[28] = t13;
        } else t13 = $[28];
        if ($[29] !== t12 || $[30] !== t13) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "link",
                iconBefore: t12,
                onClick: toggleExpand
            }, t13);
            $[29] = t12;
            $[30] = t13;
            $[31] = t8;
        } else t8 = $[31];
        t7 = isExpanded ? $2d8d2baed7861ad9$var$EXPANDED_STYLES : $2d8d2baed7861ad9$var$COLLAPSED_STYLES;
        T0 = Renderer;
        t6 = (0, $6gj4X.convertRendererProps)(isLegacyRenderer, {
            contentId: contentId,
            document: document
        });
        $[6] = Renderer;
        $[7] = appearance;
        $[8] = contentId;
        $[9] = getExtensionHandlers;
        $[10] = isExpanded;
        $[11] = isLegacyRenderer;
        $[12] = node?.parameters?.macroParams?.title;
        $[13] = showTemplateInputInPreview;
        $[14] = showTemplateVariablesInPreview;
        $[15] = t5;
        $[16] = T0;
        $[17] = T1;
        $[18] = extensionHandlers;
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
    } else {
        T0 = $[16];
        T1 = $[17];
        extensionHandlers = $[18];
        t6 = $[19];
        t7 = $[20];
        t8 = $[21];
    }
    const t9 = !!annotationProvider;
    let t10;
    if ($[32] !== T0 || $[33] !== annotationProvider || $[34] !== extensionHandlers || $[35] !== showTemplateInputInPreview || $[36] !== showTemplateVariablesInPreview || $[37] !== t6 || $[38] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t6,
            extensionHandlers: extensionHandlers,
            showTemplateInputInPreview: showTemplateInputInPreview,
            showTemplateVariablesInPreview: showTemplateVariablesInPreview,
            annotationProvider: annotationProvider,
            allowAnnotations: t9
        });
        $[32] = T0;
        $[33] = annotationProvider;
        $[34] = extensionHandlers;
        $[35] = showTemplateInputInPreview;
        $[36] = showTemplateVariablesInPreview;
        $[37] = t6;
        $[38] = t9;
        $[39] = t10;
    } else t10 = $[39];
    let t11;
    if ($[40] !== t10 || $[41] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: t7
        }, t10);
        $[40] = t10;
        $[41] = t7;
        $[42] = t11;
    } else t11 = $[42];
    let t12;
    if ($[43] !== mode || $[44] !== node) {
        t12 = (0, $5kjCz.getExperienceName)(mode, node);
        $[43] = mode;
        $[44] = node;
        $[45] = t12;
    } else t12 = $[45];
    let t13;
    if ($[46] !== attributes || $[47] !== contentId || $[48] !== extensionKey || $[49] !== mode || $[50] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: t12,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes
        });
        $[46] = attributes;
        $[47] = contentId;
        $[48] = extensionKey;
        $[49] = mode;
        $[50] = t12;
        $[51] = t13;
    } else t13 = $[51];
    let t14;
    if ($[52] !== T1 || $[53] !== t11 || $[54] !== t13 || $[55] !== t8) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T1, null, t8, t11, t13);
        $[52] = T1;
        $[53] = t11;
        $[54] = t13;
        $[55] = t8;
        $[56] = t14;
    } else t14 = $[56];
    return t14;
};
function $2d8d2baed7861ad9$var$_temp(expanded) {
    return !expanded;
}
module.exports["ExpandExtensionHandler"] = $2d8d2baed7861ad9$export$633f4824b681947a;

});

parcelRegister("2LCBF", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iu6m9 = parcelRequire("iu6m9");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $gGHFp = parcelRequire("gGHFp");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $2w2Hu = parcelRequire("2w2Hu");

var $3GQl6 = parcelRequire("3GQl6");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $6gj4X = parcelRequire("6gj4X");

const $63bceb6b2cfa43e7$export$1c60c335317f0c91 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, spaceKey: spaceKey, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, Renderer: Renderer, isLegacyRenderer: isLegacyRenderer, getExtensionHandlers: getExtensionHandlers, mediaToken: mediaToken, annotationProvider: annotationProvider } = t0;
    (0, $3GQl6.mustPreloadWhenRenderingSPA)([
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicRendererLoader
    ]);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const hiddenMacroParamValue = node?.parameters?.macroParams?.hidden?.value;
    const isHidden = hiddenMacroParamValue === "false" ? false : Boolean(hiddenMacroParamValue);
    let t1;
    if ($[0] !== node) {
        t1 = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
        $[0] = node;
        $[1] = t1;
    } else t1 = $[1];
    const attributes = t1;
    const document = {
        type: "doc",
        version: 1,
        content: node?.content
    };
    let t2;
    if ($[2] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[2] = contentId;
        $[3] = t2;
    } else t2 = $[3];
    const { mode: contentMode } = (0, $gGHFp.useEditorContentModeValue)(t2);
    const isCompactModeSupported = (0, $6mKj3.expValEquals)("confluence_compact_text_format", "isEnabled", true) || (0, $6mKj3.expValEquals)("cc_editor_ai_content_mode", "variant", "test") && (0, $9wGTI.fg)("platform_editor_content_mode_button_mvp");
    const extensionHandlers = getExtensionHandlers && !isLegacyRenderer ? getExtensionHandlers({
        adf: document,
        contentId: contentId,
        appearance: appearance,
        showTemplateInputInPreview: showTemplateInputInPreview,
        showTemplateVariablesInPreview: showTemplateVariablesInPreview
    }) : undefined;
    let t3;
    if ($[4] !== node) {
        t3 = (0, $6gj4X.getMacroId)(node);
        $[4] = node;
        $[5] = t3;
    } else t3 = $[5];
    const macroId = t3;
    const t4 = "excerpt-macro";
    let t5;
    if ($[6] !== macroId || $[7] !== renderServerPlaceholder) {
        t5 = renderServerPlaceholder ? {
            "data-ssr-placeholder": macroId
        } : {
            "data-ssr-placeholder-replace": macroId
        };
        $[6] = macroId;
        $[7] = renderServerPlaceholder;
        $[8] = t5;
    } else t5 = $[8];
    const t6 = isHidden ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Renderer, {
        ...(0, $6gj4X.convertRendererProps)(isLegacyRenderer, {
            contentId: contentId,
            document: document
        }),
        spaceKey: spaceKey,
        appearance: appearance || "default",
        contentMode: isCompactModeSupported ? contentMode : undefined,
        allowStickyHeaders: false,
        extensionHandlers: extensionHandlers,
        showTemplateInputInPreview: showTemplateInputInPreview,
        showTemplateVariablesInPreview: showTemplateVariablesInPreview,
        mediaToken: mediaToken,
        annotationProvider: annotationProvider,
        allowAnnotations: !!annotationProvider,
        ...(0, $iu6m9.editorExperiment)("comment_on_bodied_extensions", true) ? {
            allowInlineComments: true
        } : {}
    });
    let t7;
    if ($[9] !== mode || $[10] !== node) {
        t7 = (0, $5kjCz.getExperienceName)(mode, node);
        $[9] = mode;
        $[10] = node;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== attributes || $[13] !== contentId || $[14] !== extensionKey || $[15] !== mode || $[16] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: t7,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            contentId: contentId
        });
        $[12] = attributes;
        $[13] = contentId;
        $[14] = extensionKey;
        $[15] = mode;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== macroId || $[19] !== t5 || $[20] !== t6 || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-fabric-macro": macroId,
            "data-vc": t4,
            ...t5
        }, t6, t8);
        $[18] = macroId;
        $[19] = t5;
        $[20] = t6;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
const $63bceb6b2cfa43e7$export$32fd79437615e824 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($63bceb6b2cfa43e7$export$1c60c335317f0c91, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["ExcerptExtensionHandler"] = $63bceb6b2cfa43e7$export$32fd79437615e824;

});

parcelRegister("hKeSi", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iu6m9 = parcelRequire("iu6m9");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $gGHFp = parcelRequire("gGHFp");


var $2w2Hu = parcelRequire("2w2Hu");

var $3GQl6 = parcelRequire("3GQl6");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $e4o8D = parcelRequire("e4o8D");


var $6gj4X = parcelRequire("6gj4X");

const $a9b8ba98dfcca4d1$export$5a0ddb4204896541 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, spaceKey: spaceKey, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, Renderer: Renderer, isLegacyRenderer: isLegacyRenderer, getExtensionHandlers: getExtensionHandlers, annotationProvider: annotationProvider } = t0;
    (0, $3GQl6.mustPreloadWhenRenderingSPA)([
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicRendererLoader
    ]);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const isHidden = Boolean(node?.parameters?.macroParams?.hidden?.value);
    let t1;
    if ($[0] !== node) {
        t1 = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
        $[0] = node;
        $[1] = t1;
    } else t1 = $[1];
    const attributes = t1;
    const document = {
        type: "doc",
        version: 1,
        content: node?.content
    };
    let t2;
    if ($[2] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[2] = contentId;
        $[3] = t2;
    } else t2 = $[3];
    const { mode: contentMode } = (0, $gGHFp.useEditorContentModeValue)(t2);
    const isCompactModeSupported = (0, $6mKj3.expValEquals)("confluence_compact_text_format", "isEnabled", true) || (0, $6mKj3.expValEquals)("cc_editor_ai_content_mode", "variant", "test") && (0, $9wGTI.fg)("platform_editor_content_mode_button_mvp");
    const extensionHandlers = getExtensionHandlers && !isLegacyRenderer ? getExtensionHandlers({
        adf: document,
        contentId: contentId,
        appearance: appearance,
        showTemplateInputInPreview: showTemplateInputInPreview,
        showTemplateVariablesInPreview: showTemplateVariablesInPreview
    }) : undefined;
    let t3;
    if ($[4] !== node) {
        t3 = (0, $6gj4X.getMacroId)(node);
        $[4] = node;
        $[5] = t3;
    } else t3 = $[5];
    const macroId = t3;
    const t4 = "page-properties-macro";
    let t5;
    if ($[6] !== macroId || $[7] !== renderServerPlaceholder) {
        t5 = renderServerPlaceholder ? {
            "data-ssr-placeholder": macroId
        } : {
            "data-ssr-placeholder-replace": macroId
        };
        $[6] = macroId;
        $[7] = renderServerPlaceholder;
        $[8] = t5;
    } else t5 = $[8];
    const t6 = isHidden ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Renderer, {
        ...(0, $6gj4X.convertRendererProps)(isLegacyRenderer, {
            contentId: contentId,
            document: document
        }),
        showTemplateInputInPreview: showTemplateInputInPreview,
        showTemplateVariablesInPreview: showTemplateVariablesInPreview,
        extensionHandlers: extensionHandlers,
        appearance: appearance || "default",
        contentMode: isCompactModeSupported ? contentMode : undefined,
        spaceKey: spaceKey,
        UNSTABLE_allowTableResizing: false,
        annotationProvider: annotationProvider,
        allowAnnotations: !!annotationProvider,
        ...(0, $iu6m9.editorExperiment)("comment_on_bodied_extensions", true) ? {
            allowInlineComments: true
        } : {}
    });
    let t7;
    if ($[9] !== mode || $[10] !== node) {
        t7 = (0, $5kjCz.getExperienceName)(mode, node);
        $[9] = mode;
        $[10] = node;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== attributes || $[13] !== contentId || $[14] !== extensionKey || $[15] !== mode || $[16] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: t7,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            contentId: contentId
        });
        $[12] = attributes;
        $[13] = contentId;
        $[14] = extensionKey;
        $[15] = mode;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== macroId || $[19] !== t5 || $[20] !== t6 || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-fabric-macro": macroId,
            "data-vc": t4,
            ...t5
        }, t6, t8);
        $[18] = macroId;
        $[19] = t5;
        $[20] = t6;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
module.exports["DetailsExtensionHandler"] = $a9b8ba98dfcca4d1$export$5a0ddb4204896541;

});

parcelRegister("l7BGZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $076f2e82bb035170$export$b5586d12ffc2e1b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Qw8xt",
    name: "LiveSearchLoader",
    loader: async ()=>(await (parcelRequire("3nXAJ"))).LiveSearch
});

const $076f2e82bb035170$export$e7e4bc50f3fd132e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cgOQy",
    name: "LazyLiveSearchLoader",
    loader: async ()=>(await (parcelRequire("3nXAJ"))).LiveSearch
});
module.exports["LiveSearchLoader"] = $076f2e82bb035170$export$b5586d12ffc2e1b;
module.exports["LazyLiveSearchLoader"] = $076f2e82bb035170$export$e7e4bc50f3fd132e;

});

parcelRegister("3nXAJ", function(module, exports) {

let $2771beb87f6187dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2771beb87f6187dc$var$load("hIzQl"),
    $2771beb87f6187dc$var$load("8059b"),
    $2771beb87f6187dc$var$load("6wr18"),
    $2771beb87f6187dc$var$load("kjZZD"),
    $2771beb87f6187dc$var$load("ffEVr"),
    $2771beb87f6187dc$var$load("2IX0x")
]).then(()=>parcelRequire('jF1MT'));

});

parcelRegister("cYJC5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c1c34d439a5f73ff$export$d9cdb53348aba8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "BS09z",
    name: "CreateFromTemplateLoader",
    loader: async ()=>(await (parcelRequire("6HndP"))).CreateFromTemplate
});

const $c1c34d439a5f73ff$export$3ecbbe8a82bf4f99 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ikblw",
    name: "LazyCreateFromTemplateLoader",
    loader: async ()=>(await (parcelRequire("6HndP"))).CreateFromTemplate
});
module.exports["CreateFromTemplateLoader"] = $c1c34d439a5f73ff$export$d9cdb53348aba8;
module.exports["LazyCreateFromTemplateLoader"] = $c1c34d439a5f73ff$export$3ecbbe8a82bf4f99;

});

parcelRegister("6HndP", function(module, exports) {

let $4e08c5a3d751ec1a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e08c5a3d751ec1a$var$load("blfwh"),
    $4e08c5a3d751ec1a$var$load("b1vDf")
]).then(()=>parcelRequire('6JR3B'));

});

parcelRegister("fPNzj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5kjCz = parcelRequire("5kjCz");


var $hUS75 = parcelRequire("hUS75");

const $526a767bde0d5c12$export$4eba1572aa6d0aed = ({ width: width = 'auto', height: height = 'auto', src: src, mode: mode, node: node, contentId: contentId })=>{
    const stopMacroExperience = (error)=>{
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hUS75.MacroExperienceStop), {
            name: (0, $5kjCz.getExperienceName)(mode, node),
            contentId: contentId,
            mode: mode,
            error: error,
            attributes: attributes,
            source: "InlineExternalImage"
        });
    };
    return(// eslint-disable-next-line @atlassian/a11y/alt-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            cursor: 'move'
        },
        "data-testid": "external-image",
        width: width,
        height: height,
        src: src,
        onError: stopMacroExperience,
        onLoad: stopMacroExperience
    }));
};
module.exports["InlineExternalImage"] = $526a767bde0d5c12$export$4eba1572aa6d0aed;

});

parcelRegister("5LTS4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $6VdZc = parcelRequire("6VdZc");


var $4JC0x = parcelRequire("4JC0x");


var $4VJDS = parcelRequire("4VJDS");


var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $63112e910a0def69$export$841f5507db609445 = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.LEGACY_EXTENSION_LOADING_CUSTOM_KEY)
});



var $h8C1D = parcelRequire("h8C1D");


var $kksmx = parcelRequire("kksmx");

const $ebb4d303074e1a0c$var$NOT_SSRED = 'none';
const $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED = 'ssr-blocked';
// Limit performance tracking for only top 10 extensions on initial load.
// The value is semi-arbitrary, as this is +2 to the number of extensions
// we attempt to SSR on initial load - this will give us an idea how the
// non-SSRed extensions are performing.
// This will lead to ~39% more tracking events send overall, comparing to
// 50/50 rollout we had before, but will prevent from sending huge amount
// of events for individual pages with a lot of extensions.
const $ebb4d303074e1a0c$var$TRACKING_LIMIT = 10;
const $ebb4d303074e1a0c$var$isBlocklisted = (ssrPreloadFailure)=>ssrPreloadFailure?.startsWith('blocklist') ? $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED : $ebb4d303074e1a0c$var$NOT_SSRED;
// This check is being made only upon initial render, and therefore is sufficient for
// checking whether element (in our case the marker) appears above the fold when rendered.
const $ebb4d303074e1a0c$var$isMarkerAboveTheFold = (el)=>{
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
};
const $ebb4d303074e1a0c$var$getPerformanceEntry = (entryName)=>{
    if (performance && typeof performance.getEntriesByName === 'function') return performance.getEntriesByName(entryName);
    return [];
};
const $ebb4d303074e1a0c$export$64e91845ba744516 = ({ node: node, contentId: contentId, extensionKey: extensionKey })=>{
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { localId: localId } = node;
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const extensionBlocklist = (0, $4VJDS.default).getString('confluence-extensions-server-render-blocklist', '');
    const markerRef = (0, $42omo.useRef)(null);
    const { extensionIndex: extensionIndex, isUnsupportedExtension: isUnsupportedExtension } = (0, $h8C1D.useExtensionIndex)(macroId);
    const doNotTrackExtension = extensionIndex === (0, $h8C1D.UNKNOWN_INDEX) || extensionIndex >= $ebb4d303074e1a0c$var$TRACKING_LIMIT;
    (0, $42omo.useEffect)(()=>{
        // NOTE: as of now, this metric is tailored to monitoring the performance of extensions
        // on initial load. We're not planning to use this metric in any way on transitions yet
        // thus we don't want to spam analytics with the data we don't use.
        if (doNotTrackExtension || !(0, $6VdZc.isInitial)()) return;
        // WARN: Complexity alert! The logic of fmp/tti/duration calculation is convoluted
        // here because of several reasons. Due to the timing of creating performance marks
        // that we use here, we may report extension timing *before* TTI measure is evaluated,
        // since TTI measure is waiting for several page segments. Thus on initial load we have
        // to rely on other reference points, that are available before extensions are rendered.
        const pageTTI = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('rendererRendered.end')?.pop()?.startTime : $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric:tti')?.pop()?.duration;
        const pageFMP = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('CFP-63.ssr-ttr')?.pop()?.startTime : pageTTI;
        const clientRouteStart = $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric.start')?.pop()?.startTime;
        const ssrPreloadFailure = (0, $4JC0x.getPreloadFailures)(macroId) || '';
        const ssrGeneralFailure = (0, $4JC0x.getGeneralFailures)() || '';
        const isExtensionSSRed = (0, $6VdZc.isInitial)() ? (0, $kksmx.getExtensionSSRMark)(macroId) || $ebb4d303074e1a0c$var$isBlocklisted(ssrPreloadFailure) : $ebb4d303074e1a0c$var$NOT_SSRED;
        // On transition we cannot reliably expect that "browser-metric:tti" measure is there
        // before macro rendering. Thus, use routing start as a base point for extension performance
        // measurement on transition. Note that FMP=TTI on transition.
        const startTime = ((0, $6VdZc.isInitial)() ? pageFMP : clientRouteStart) ?? 0;
        const customData = {
            isExtensionSSRed: isExtensionSSRed,
            extensionIndex: extensionIndex,
            extensionKey: extensionKey,
            contentId: contentId,
            pageFMP: pageFMP ?? 0,
            pageTTI: pageTTI ?? 0,
            isATF: $ebb4d303074e1a0c$var$isMarkerAboveTheFold(markerRef.current),
            ssrPreloadFailure: isUnsupportedExtension ? 'unsupportedContentInternalExtension' : ssrPreloadFailure || ssrGeneralFailure,
            clientRouteStart: clientRouteStart ?? 0,
            hydratable: window?.__HYDRATABLE__ || false,
            hydrationFailed: window?.__HYDRATION_FAILED__ || false
        };
        const metric = (0, $63112e910a0def69$export$841f5507db609445)(`${extensionKey}.${contentId}.${localId}`);
        metric.start({
            startTime: startTime
        });
        metric.stop({
            customData: customData
        });
    }, [
        doNotTrackExtension,
        extensionBlocklist,
        extensionKey,
        extensionIndex,
        isUnsupportedExtension,
        routeName,
        localId,
        contentId,
        macroId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: markerRef
    });
};
module.exports["ExtensionLoadingComplete"] = $ebb4d303074e1a0c$export$64e91845ba744516;

});

parcelRegister("h8C1D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lcuos = parcelRequire("lcuos");


var $8pcS0 = parcelRequire("8pcS0");

const $028a91b33dee434b$export$7affafe0528b70b1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    indexes: new Map()
});
const $028a91b33dee434b$var$extractExtensions = (adf)=>(0, $lcuos.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $028a91b33dee434b$export$e4ac003417d6dace = 'UNKNOWN';
const $028a91b33dee434b$export$981cab9712b3b1a3 = ({ document: document, children: children })=>{
    const indexes = (0, $42omo.useMemo)(()=>{
        const extensions = $028a91b33dee434b$var$extractExtensions(document);
        return new Map(extensions.map((node, idx)=>{
            window['unsupportedExtension'] = window['unsupportedExtension'] || {};
            if (node.attrs?.parameters?.nestedContent?.content && node.attrs.extensionKey === '__confluenceADFMigrationUnsupportedContentInternalExtension__') node.attrs.parameters.nestedContent.content.forEach((each)=>{
                window['unsupportedExtension'][each.attrs?.parameters?.macroMetadata?.macroId?.value] = idx;
            });
            return [
                node.attrs?.parameters?.macroMetadata?.macroId?.value,
                idx
            ];
        }));
    }, [
        document
    ]);
    const value = (0, $42omo.useMemo)(()=>({
            indexes: indexes
        }), [
        indexes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($028a91b33dee434b$export$7affafe0528b70b1.Provider, {
        value: value
    }, children);
};
const $028a91b33dee434b$export$ea9830505fbaa6ad = (macroId)=>{
    const { indexes: indexes } = (0, $42omo.useContext)($028a91b33dee434b$export$7affafe0528b70b1);
    let index = indexes.get(macroId);
    const unsupportedExtensions = window['unsupportedExtension'];
    let isUnsupportedExtension = false;
    if (unsupportedExtensions && unsupportedExtensions[macroId]) {
        index = unsupportedExtensions[macroId];
        isUnsupportedExtension = true;
    }
    return {
        extensionIndex: typeof index === 'number' ? index : $028a91b33dee434b$export$e4ac003417d6dace,
        isUnsupportedExtension: isUnsupportedExtension
    };
};
module.exports["UNKNOWN_INDEX"] = $028a91b33dee434b$export$e4ac003417d6dace;
module.exports["ExtrensionIndexProvider"] = $028a91b33dee434b$export$981cab9712b3b1a3;
module.exports["useExtensionIndex"] = $028a91b33dee434b$export$ea9830505fbaa6ad;

});

parcelRegister("3Btfb", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4o1RV = parcelRequire("4o1RV");

function $fa7a566b22788032$export$a039e57df2bba181(InnerComponent) {
    function WithNavigationPolicy(props) {
        const $ = (0, $frIzR.c)(3);
        const navigationPolicy = (0, $4o1RV.useNavigationPolicy)();
        const t0 = props;
        let t1;
        if ($[0] !== navigationPolicy || $[1] !== t0) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                ...t0,
                navigationPolicy: navigationPolicy
            });
            $[0] = navigationPolicy;
            $[1] = t0;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    WithNavigationPolicy.displayName = `withNavigationPolicy(${InnerComponent.displayName || InnerComponent.name})`;
    return WithNavigationPolicy;
}
module.exports["withNavigationPolicy"] = $fa7a566b22788032$export$a039e57df2bba181;

});

parcelRegister("giS6h", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a6c7790f33c3e831$export$bbe9955f93d6ed27 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
module.exports["ClassicEditorContext"] = $a6c7790f33c3e831$export$bbe9955f93d6ed27;

});

parcelRegister("aQw7y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3jwuS = parcelRequire("3jwuS");


var $j0gZR = parcelRequire("j0gZR");


var $4VJDS = parcelRequire("4VJDS");

const $9d7353a17557989b$export$27f1b40a08e363aa = (extensionKey, isBodiedExtension)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    return (0, $42omo.useMemo)(()=>{
        if (!extensionKey) return false;
        const is2PNonBodied = !(0, $j0gZR.is1PMacro)(extensionKey) && !isBodiedExtension;
        if (is2PNonBodied || isLivePage) return true;
        const extensionsToHideOverlays = (0, $4VJDS.default).getStringList('confluence_frontend_extension_overlay_removal_list', []);
        if (extensionsToHideOverlays.length === 0) return false;
        if (extensionsToHideOverlays[0] === 'ALLOW_ALL') return true;
        const extensionKeys = extensionsToHideOverlays.map((ext)=>ext.trim().toLowerCase());
        return extensionKeys.includes(extensionKey.toLowerCase());
    }, [
        extensionKey,
        isLivePage,
        isBodiedExtension
    ]);
};
module.exports["useShouldHideOverlay"] = $9d7353a17557989b$export$27f1b40a08e363aa;

});

parcelRegister("kDIns", function(module, exports) {
/**
 * @generated SignedSource<<35bc0f32ae3715628d3b3d5c62ff81d1>>
 * @relayHash d689c46cc95f36419f19f207f3ceb687
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da0d02555fb2e7138559c38df00467b0a1669fe42733ebf6cfa8115dbdbb4a2f
const $f5022931ec1c887f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "confluenceCommentFilter",
                    "value": {
                        "commentState": "UNRESOLVED",
                        "commentType": "INLINE"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": [
                        "INLINE"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "inlineMarkerRef"
                                        },
                                        {
                                            "concreteType": "InlineCommentResolveProperties",
                                            "kind": "LinkedField",
                                            "name": "inlineResolveProperties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "resolved"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "InlineComment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v3 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "d689c46cc95f36419f19f207f3ceb687",
            "id": "da0d02555fb2e7138559c38df00467b0a1669fe42733ebf6cfa8115dbdbb4a2f",
            "metadata": {},
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "operationKind": "query",
            "text": "query stateResolverPreloadAnnotationsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:INLINE},type:[INLINE],depth:ROOT,first:$first){nodes{id,contentStatus,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}},totalCount,__typename}}"
        }
    };
}();
$f5022931ec1c887f$var$node.hash = "af92d028ec6cef46bb981d53522dfe18";
var $f5022931ec1c887f$export$2e2bcd8739ae039 = $f5022931ec1c887f$var$node;



var $2XqLN = parcelRequire("2XqLN");


var $a4TK8 = parcelRequire("a4TK8");


var $cUycv = parcelRequire("cUycv");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $eSUdr = parcelRequire("eSUdr");

const $951c06b69b244c75$export$dedc8dce0be2f721 = (0, $eSUdr.default)`query AnnotationStateQuery($pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId contentStatus:$contentStatus type:[INLINE UNRESOLVED]depth:ROOT first:1500){nodes{id location{type ...on InlineComment{inlineMarkerRef inlineResolveProperties{resolved resolvedUser}}}}}}`;



var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $gtj7V = parcelRequire("gtj7V");


var $cD1qu = parcelRequire("cD1qu");


var $c0rhi = parcelRequire("c0rhi");

const $655a1f23a26f4e27$export$c53aa0aa4a7c5e4 = (0, $f5022931ec1c887f$export$2e2bcd8739ae039);
const $655a1f23a26f4e27$export$7037a4d88a618a89 = (contentId, pageMode)=>({
        pageId: contentId,
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        first: (0, $NYiei.MAX_COMMENTS_TO_RETURN)
    });
const $655a1f23a26f4e27$var$logger = (0, $7W8i8.getLogger)('inline-comments-common:state-resolver');
const $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData = async ({ contentId: contentId, pageMode: pageMode })=>{
    if (!contentId) return [];
    // Check if processed comments data is available
    const processedData = (0, $4L9ve.getProcessedCommentsDataState)();
    // If data is processed, use it directly
    if (processedData.isDataProcessed) return processedData.openInlineComments;
    // Data not processed yet - fetch fresh data directly with network-only
    // This is simpler (albeit slightly slower) than preloading and guarantees fresh data
    // If we do preload in the future - keep in mind that we have to satisfy the following use cases
    // 1. We load in SSR and preload fails --> no cache data
    // 2. We load in SPA and preload hasn't completed before we check the cache value
    // 3. We load in SPA and have a stale value in the cache
    // If preloading you can also show stale data initially and refresh by manually updating annotations states
    // However if you do this, be careful for integrations w/ focused comments
    try {
        const result = await (0, $c0rhi.queryInterop)({
            query: $655a1f23a26f4e27$export$c53aa0aa4a7c5e4,
            variables: $655a1f23a26f4e27$export$7037a4d88a618a89(contentId, pageMode),
            fetchPolicy: 'network-only'
        });
        return result?.data?.comments?.nodes?.filter((node)=>node?.location) || [];
    } catch  {
        return [];
    }
};
const $655a1f23a26f4e27$export$8f0e4480674935ab = (0, $2XqLN.default)((annotations, validAnnotationsCallback, states)=>{
    const rendererAnnotationMap = {};
    const annotationState = [];
    annotations.forEach((id, idx)=>{
        // this will override any repeat ids given by the Renderer
        rendererAnnotationMap[id] = idx;
        annotationState.push({
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
            id: id,
            state: (0, $cUycv.AnnotationMarkStates).RESOLVED
        });
    });
    states?.forEach((state)=>{
        const isResolved = Boolean(state.location?.inlineResolveProperties?.resolved);
        // mark all unresolved annotations to be displayed by the renderer
        if (!isResolved) {
            const annotationId = state.location.inlineMarkerRef;
            if (annotationId) {
                const index = rendererAnnotationMap[annotationId];
                /**
         * If the BE returns an annotation that the Renderer did not
         * provide, we could error here. Also account for 0 index.
         */ if (index || index === 0) annotationState[index].state = (0, $cUycv.AnnotationMarkStates).ACTIVE;
            }
        }
    });
    const validAnnotations = annotations.filter((annotation)=>{
        const index = rendererAnnotationMap[annotation];
        return annotationState[index].state === (0, $cUycv.AnnotationMarkStates).ACTIVE;
    });
    // Record the valid annotations to use for navigation and query params
    validAnnotationsCallback(validAnnotations);
    return annotationState;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $655a1f23a26f4e27$export$228a0d958905d789 = (0, $2XqLN.default)((annotations, states, updateUnresolvedInlineComment)=>{
    /**
   * Build a map of annotation states with a default of true for resolved.
   * This is to accommodate deleted annotations that still exist in the ADF.
   */ const editorAnnotationMap = {};
    const annotationState = [];
    annotations.forEach((id, idx)=>{
        // this will override any repeat ids given by the Editor
        editorAnnotationMap[id] = idx;
        annotationState.push({
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
            id: id,
            state: {
                resolved: true
            }
        });
    });
    states.forEach((state)=>{
        const isResolved = Boolean(state?.location?.inlineResolveProperties?.resolved);
        // mark all unresolved annotations to be displayed by the editor
        if (!isResolved) {
            const annotationId = state?.location?.inlineMarkerRef || '';
            const index = editorAnnotationMap[annotationId];
            /**
       * If the BE returns an annotation that the Editor did not
       * provide, we could error here. Also account for 0 index.
       */ if (index || index === 0) annotationState[index].state.resolved = false;
        }
    });
    //Ordered list of unresolved inline comments
    const unresolvedInlineComments = annotations.filter((annotationId)=>{
        const index = editorAnnotationMap[annotationId];
        if (!annotationState[index].state.resolved) return annotationId;
    });
    updateUnresolvedInlineComment(unresolvedInlineComments);
    return annotationState;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $655a1f23a26f4e27$export$38c1ce6adefc79a5 = async ({ annotations: annotations, pageId: pageId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    if (!annotations.length) {
        updateUnresolvedInlineComment([]);
        return Promise.resolve([]);
    }
    try {
        let annotationStateNodes;
        // Check if we should use the new comments data manager flow
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // NEW FLOW: Use preload-aware annotations data utility
        annotationStateNodes = await $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData({
            contentId: pageId,
            pageMode: (0, $cD1qu.PageMode).LIVE // same as PageMode.EDIT for our case
        });
        else {
            // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const data = await (0, $hp2SH.getApolloClient)().query({
                query: (0, $951c06b69b244c75$export$dedc8dce0be2f721),
                fetchPolicy: 'network-only',
                variables: {
                    pageId: pageId,
                    // @ts-ignore - Legacy contentStatus values passed before typecheck changes
                    contentStatus: [
                        'DRAFT',
                        'CURRENT'
                    ]
                }
            });
            // Filter null elements
            annotationStateNodes = data.data.comments?.nodes?.filter((node)=>node !== null);
        }
        // Common logic: map annotation state nodes to editor states
        return $655a1f23a26f4e27$export$228a0d958905d789(annotations, annotationStateNodes, updateUnresolvedInlineComment);
    } catch (error) {
        // COMMENTS-211 - When this code executes sometimes the `triggerAnalyticsEvent` is passed in as a promise
        //                this causes this call to throw an error where `.fire()` is not defined and thus the
        //                code below it which handles the various expected errors thrown to not run and thus
        //                the errors are thrown up the stack as unhandled ui errors causing a lot of noise
        try {
            if (triggerAnalyticsEvent) triggerAnalyticsEvent({
                data: {
                    source: 'editorComponent',
                    action: 'failed',
                    actionSubject: 'annotationState',
                    actionSubjectId: 'inlineComments',
                    attributes: {
                        errorName: error.name,
                        errorMessage: error.message
                    }
                },
                type: 'sendOperationalEvent'
            }).fire();
        } catch (e) {
            $655a1f23a26f4e27$var$logger.error`Error when logging analytics event, ${e}`;
        }
        if ((0, $1uFM6.isUnauthorizedError)(error) || // CEMS-1343 - Some specific pages have annotations that have a "null" id because we
        //             still informed the editor on failed creation attempts
        error?.message.includes('java.lang.NullPointerException') || // COMMENTS-211 - If we don't find any inline comments for the given markerRefList
        //               we should mark it handled and return an empty list to be consumed
        error?.message.includes('.NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return [];
        } else {
            $655a1f23a26f4e27$var$logger.error`Error when retrieving resolved status for marks, ${error}`;
            throw error;
        }
    }
};
let $655a1f23a26f4e27$var$rendererAnnotationsIds;
const $655a1f23a26f4e27$export$a0fcca613dd8b2c7 = async ({ annotations: annotations, pageId: pageId, triggerAnalyticsEvent: triggerAnalyticsEvent, validAnnotationsCallback: validAnnotationsCallback, isNestedRender: isNestedRender })=>{
    // We need to have the page level renderer annotations
    // When the page renders the value of isNestedRender is false as per PageContentRendererFabrics
    // Later, when the macro renders isNestedRender is true
    // so, we will hold the value of annotations for the page renderer when isNestedRender is false
    if (!annotations.length) {
        validAnnotationsCallback([]);
        return Promise.resolve([]);
    }
    if (!isNestedRender) $655a1f23a26f4e27$var$rendererAnnotationsIds = annotations;
    try {
        let annotationStateNodes;
        // Check if we should use the new comments data manager flow
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // NEW FLOW: Use preload-aware annotations data utility
        annotationStateNodes = await $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData({
            contentId: pageId,
            pageMode: (0, $cD1qu.PageMode).VIEW
        });
        else {
            // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const data = await (0, $hp2SH.getApolloClient)().query({
                query: (0, $951c06b69b244c75$export$dedc8dce0be2f721),
                fetchPolicy: isNestedRender ? 'cache-first' : 'network-only',
                variables: {
                    pageId: pageId
                }
            });
            // Filter null elements
            annotationStateNodes = data.data.comments?.nodes?.filter((node)=>node !== null);
        }
        // Common logic: map annotation state nodes to renderer states
        return $655a1f23a26f4e27$export$8f0e4480674935ab($655a1f23a26f4e27$var$rendererAnnotationsIds, validAnnotationsCallback, annotationStateNodes);
    } catch (error) {
        // COMMENTS-1131 - When this code executes sometimes the `triggerAnalyticsEvent` is passed in as a promise
        //                this causes this call to throw an error where `.fire()` is not defined and thus the
        //                code below it which handles the various expected errors thrown to not run and thus
        //                the errors are thrown up the stack as unhandled ui errors causing a lot of noise
        try {
            if (triggerAnalyticsEvent) triggerAnalyticsEvent({
                source: 'rendererComponent',
                action: 'failed',
                actionSubject: 'annotationState',
                actionSubjectId: 'inlineComments',
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    errorName: error.name,
                    errorMessage: error.message
                }
            }).fire();
        } catch (e) {
            $655a1f23a26f4e27$var$logger.error`Error when logging analytics event, ${e}`;
        }
        if ((0, $1uFM6.isUnauthorizedError)(error) || // CEMS-1343 - Some specific pages have annotations that have a "null" id because we
        //             still informed the editor on failed creation attempts
        error?.message.includes('java.lang.NullPointerException') || // COMMENTS-211 - If we don't find any inline comments for the given markerRefList
        //               we should mark it handled and return an empty list to be consumed
        error?.message.includes('.NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return [];
        } else {
            $655a1f23a26f4e27$var$logger.error`Error when retrieving resolved status for marks, ${error}`;
            throw error;
        }
    }
};
module.exports["getEditorResolvedState"] = $655a1f23a26f4e27$export$38c1ce6adefc79a5;
module.exports["getRendererAnnotationStates"] = $655a1f23a26f4e27$export$a0fcca613dd8b2c7;

});

parcelRegister("8Ij3v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gczDe = parcelRequire("gczDe");


var $hXzKU = parcelRequire("hXzKU");


var $kDIns = parcelRequire("kDIns");




const $dc72366b6b9218cc$export$6c8a5aaad13c9852 = ({ pageId: pageId, isArchived: isArchived, setSelectionProps: setSelectionProps, updateDocument: updateDocument, onCommentButtonMount: onCommentButtonMount })=>/*#__PURE__*/ (0, $42omo.memo)((props)=>{
        const { range: range, draftRange: draftRange, wrapperDOM: wrapperDOM, isAnnotationAllowed: isAnnotationAllowed, onCreate: onCreate, onClose: onClose, applyDraftMode: applyDraftMode, removeDraftMode: removeDraftMode, inlineNodeTypes: inlineNodeTypes } = props;
        (0, $42omo.useEffect)(()=>{
            setSelectionProps({
                pageId: pageId,
                isArchived: isArchived,
                updateDocument: updateDocument,
                range: range,
                draftRange: draftRange,
                wrapperDOM: wrapperDOM,
                isAnnotationAllowed: isAnnotationAllowed,
                onCreate: onCreate,
                onClose: onClose,
                applyDraftMode: applyDraftMode,
                removeDraftMode: removeDraftMode,
                inlineNodeTypes: inlineNodeTypes,
                onCommentButtonMount: onCommentButtonMount
            });
        // We only want to listen to changes that signifies a new selection
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            range,
            draftRange,
            wrapperDOM
        ]);
        return null;
    });






var $bSvtO = parcelRequire("bSvtO");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $cZa7r = parcelRequire("cZa7r");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $gtj7V = parcelRequire("gtj7V");


var $9wGTI = parcelRequire("9wGTI");

const $913e742c4c6d0363$export$76599b5777b5fa44 = ({ pageId: pageId, updateDocument: updateDocument, setViewProps: setViewProps, isArchived: isArchived, annotations: annotations, clickElementTarget: clickElementTarget, deleteAnnotation: deleteAnnotation, getInlineNodeTypes: getInlineNodeTypes })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { newlyCreatedAnnotationId: newlyCreatedAnnotationId, storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { handleClose: handleSelectionClose, setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId, clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    // Clear stored comment data when annotation changes (before new component renders)
    (0, $42omo.useEffect)(()=>{
        if (storedCommentData) {
            const currentAnnotationId = annotations?.[0]?.id;
            const storedAnnotationId = storedCommentData?.location?.inlineMarkerRef;
            // Clear stored data if we're viewing a different annotation
            if (currentAnnotationId && storedAnnotationId && currentAnnotationId !== storedAnnotationId) clearStoredCommentData();
        }
    }, [
        annotations,
        storedCommentData,
        clearStoredCommentData
    ]);
    (0, $42omo.useEffect)(()=>{
        const wasHighlightClicked = Boolean(annotations.length && clickElementTarget);
        const handleSetViewProps = ()=>{
            // Below logic has been added to prevent the nested renderers like
            // excerpt/page properties macros to not set the wrong value of isArchived.
            // Thus, we need to setViewProps only when the "PageStatusQuery" defined in ViewPageComponent resolves
            if (isArchived !== undefined) setViewProps({
                pageId: pageId,
                updateDocument: updateDocument,
                isArchived: isArchived,
                annotations: annotations,
                clickElementTarget: clickElementTarget,
                deleteAnnotation: deleteAnnotation,
                wasHighlightClicked: wasHighlightClicked,
                getInlineNodeTypes: getInlineNodeTypes
            });
            // If we're showing this coming from a newly created comment, clear the props and succeed the experience
            if (annotations.length && annotations[0].id === newlyCreatedAnnotationId) {
                setNewlyCreatedAnnotationId(undefined);
                experienceTracker.succeed({
                    name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
                });
            }
        };
        // the if will be replaced with the new preemptive gate next/packages/annotation-provider-inline-comments/src/hooks/usePreemptiveGate.ts when cleanup platform_editor_comments_api_manager
        if (hasContentChanged && wasHighlightClicked && !(0, $9wGTI.fg)('platform_editor_comments_api_manager')) {
            let abortedKeyboardExperience = false;
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_keyboard')) {
                const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE));
                /*
				 * If a keyboard shortcut is used to navigate when the content has changed, we abort and restart
				 * the experience on confirm because we can't predict if the user will confirm the navigation, or
				 * how long the user will take to confirm.
				 */ if (experienceState !== null && experienceState?.hasStopped === false && experienceState?.attributes?.entryPoint === 'comments-shortcuts/ViewCommentShortcutListener') {
                    experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment warning dialog displayed',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: 'annotation-provider-inline-comments/renderer/ViewManager'
                        }
                    });
                    abortedKeyboardExperience = true;
                }
            }
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    if (abortedKeyboardExperience) {
                        experienceTracker.start({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                            attributes: {
                                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                                annotationId: annotations.length && annotations[0].id,
                                entryPoint: 'annotation-provider-inline-comments/renderer/ViewManager',
                                pageClass: 'renderer'
                            }
                        });
                        experienceTracker.attachDebugPoint({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            message: 'Restarting experience after comment was discarded from comment warning dialog. Initial entrypoint: comments-shortcuts/ViewCommentShortcutListener'
                        });
                    }
                    resetContentChanged();
                    handleSelectionClose();
                    handleSetViewProps();
                }
            });
        } else handleSetViewProps();
    // We only want to listen to changes that signifies a new comment click
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        annotations,
        clickElementTarget
    ]);
    return null;
};
const $913e742c4c6d0363$export$e2fb22396d3bf4b8 = ({ pageId: pageId, updateDocument: updateDocument, setViewProps: setViewProps, isArchived: isArchived })=>/*#__PURE__*/ (0, $42omo.memo)((viewComponentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($913e742c4c6d0363$export$76599b5777b5fa44, {
            pageId: pageId,
            updateDocument: updateDocument,
            setViewProps: setViewProps,
            isArchived: isArchived,
            ...viewComponentProps
        }));





const $a7b8dfb125d18cb3$export$a74c7df2718eaab3 = ({ pageId: pageId, updateDocument: updateDocument, isArchived: isArchived, setHoverProps: setHoverProps, onCommentButtonMount: onCommentButtonMount })=>/*#__PURE__*/ (0, $42omo.memo)((props)=>{
        const { range: range, isWithinRange: isWithinRange, wrapperDOM: wrapperDOM, isAnnotationAllowed: isAnnotationAllowed, onCreate: onCreate, onClose: onClose, applyDraftMode: applyDraftMode, removeDraftMode: removeDraftMode } = props;
        const handleClose = (0, $42omo.useCallback)(()=>{
            onClose();
            setHoverProps(null);
        }, [
            onClose
        ]);
        (0, $42omo.useEffect)(()=>{
            setHoverProps({
                pageId: pageId,
                updateDocument: updateDocument,
                isArchived: isArchived,
                range: range,
                wrapperDOM: wrapperDOM,
                isAnnotationAllowed: isAnnotationAllowed,
                onCreate: onCreate,
                onClose: handleClose,
                applyDraftMode: applyDraftMode,
                removeDraftMode: removeDraftMode,
                isWithinRange: isWithinRange,
                onCommentButtonMount: onCommentButtonMount
            });
        // We only want to listen to changes that signifies a new selection
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            range,
            wrapperDOM,
            isWithinRange
        ]);
        return null;
    });


const $6c72ee9a775e4c5b$export$e5e59df64f812c64 = ({ pageId: pageId, validAnnotationsCallback: validAnnotationsCallback, triggerAnalyticsEvent: triggerAnalyticsEvent, setSelectionProps: setSelectionProps, setViewProps: setViewProps, updateDocument: updateDocument, isArchived: isArchived, setHoverProps: setHoverProps, isHighlightOptionPanelEnabled: isHighlightOptionPanelEnabled })=>{
    let updateSubscriber = (0, $gczDe.getRendererAnnotationEventEmitter)();
    if (!updateSubscriber?.off) updateSubscriber = undefined;
    return {
        selectionComponent: isHighlightOptionPanelEnabled ? (0, $dc72366b6b9218cc$export$6c8a5aaad13c9852)({
            pageId: pageId,
            updateDocument: updateDocument,
            isArchived: isArchived,
            setSelectionProps: setSelectionProps,
            onCommentButtonMount: ()=>(0, $hXzKU.LazyCommentEditor).preload()
        }) : undefined,
        viewComponent: (0, $913e742c4c6d0363$export$e2fb22396d3bf4b8)({
            pageId: pageId,
            updateDocument: updateDocument,
            isArchived: isArchived,
            setViewProps: setViewProps
        }),
        hoverComponent: (0, $a7b8dfb125d18cb3$export$a74c7df2718eaab3)({
            pageId: pageId,
            updateDocument: updateDocument,
            isArchived: isArchived,
            setHoverProps: setHoverProps,
            onCommentButtonMount: ()=>(0, $hXzKU.LazyCommentEditor).preload()
        }),
        getState: (annotations, isNestedRender)=>(0, $kDIns.getRendererAnnotationStates)({
                annotations: annotations,
                pageId: pageId,
                validAnnotationsCallback: validAnnotationsCallback,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                isNestedRender: isNestedRender
            }),
        updateSubscriber: updateSubscriber,
        disallowOnWhitespace: true,
        isToolbarAbove: true,
        allowDraftMode: true,
        allowCommentsOnMedia: true
    };
};









var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");

const $dc4cdd28902d8267$export$6bf92d32985d66db = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useIsHighlightOptionPanelEnabledQuery{userPreferences{highlightOptionPanelEnabled}}`, {
        fetchPolicy: 'cache-and-network',
        skip: !userId
    });
    return (0, $42omo.useMemo)(()=>{
        // We always want to default to true until we get a result
        let isHighlightOptionPanelEnabled = true;
        if (error) // We always want to handle errors caused from this, just default to existing behavior
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!loading && data?.userPreferences) isHighlightOptionPanelEnabled = data?.userPreferences.highlightOptionPanelEnabled;
        return {
            isHighlightOptionPanelEnabled: isHighlightOptionPanelEnabled
        };
    }, [
        data,
        loading,
        error
    ]);
};


const $0880ee54bb9fbae3$export$8a100b863f90f2c5 = ({ pageId: pageId, validAnnotationsCallback: validAnnotationsCallback, triggerAnalyticsEvent: triggerAnalyticsEvent, updateDocument: updateDocument, isArchived: isArchived })=>{
    const { setSelectionProps: setSelectionProps, setViewProps: setViewProps, setHoverProps: setHoverProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { isHighlightOptionPanelEnabled: isHighlightOptionPanelEnabled } = (0, $dc4cdd28902d8267$export$6bf92d32985d66db)();
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    return (0, $42omo.useMemo)(()=>({
            inlineComment: (0, $6c72ee9a775e4c5b$export$e5e59df64f812c64)({
                pageId: pageId,
                validAnnotationsCallback: validAnnotationsCallback,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                setSelectionProps: setSelectionProps,
                setHoverProps: setHoverProps,
                setViewProps: setViewProps,
                updateDocument: updateDocument,
                isArchived: isArchived,
                isHighlightOptionPanelEnabled: isHighlightOptionPanelEnabled
            }),
            annotationManager: annotationManager
        }), [
        pageId,
        validAnnotationsCallback,
        triggerAnalyticsEvent,
        setSelectionProps,
        setHoverProps,
        setViewProps,
        updateDocument,
        isArchived,
        isHighlightOptionPanelEnabled,
        annotationManager
    ]);
};
module.exports["useRendererAnnotationProviderOptions"] = $0880ee54bb9fbae3$export$8a100b863f90f2c5;

});

parcelRegister("gHCIk", function(module, exports) {
const $9fa754652de9cba0$var$replacer = (_, value)=>value !== null && typeof value === 'object' && !(value instanceof Array) ? Object.keys(value).sort().reduce((sorted, key)=>{
        sorted[key] = value[key];
        return sorted;
    }, {}) : value;
const $9fa754652de9cba0$export$af78762ebd645d38 = (adf)=>JSON.stringify(adf, $9fa754652de9cba0$var$replacer);
module.exports["serializeExtensionADF"] = $9fa754652de9cba0$export$af78762ebd645d38;

});

parcelRegister("1bl0g", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $4tb0i = parcelRequire("4tb0i");


var $lEgye = parcelRequire("lEgye");

class $26165acd862f475d$export$ab608a64509503ae {
    emit(id, adfReference) {
        this.dataSourceProvider.createOrUpdate(id, adfReference);
    }
    constructor(dataSourceProvider){
        this.dataSourceProvider = void 0;
        this.dataSourceProvider = dataSourceProvider;
    }
}



var $2pjJ5 = parcelRequire("2pjJ5");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gjBRE = parcelRequire("gjBRE");

var $3oRlx = parcelRequire("3oRlx");





var $42omo = parcelRequire("42omo");


var $fPlBD = parcelRequire("fPlBD");

const $5a206d91b5b3f476$export$eba5603251c4feaf = ({ editorView: editorView, node: node, dataSourceProvider: dataSourceProvider })=>{
    const dataSourceId = node.marks?.find((mark)=>mark.type === editorView.state.schema.marks?.dataConsumer)?.attrs?.sources?.[0];
    const [reference, setReference] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(()=>{
        const dataSourceReference = dataSourceProvider?.get(dataSourceId);
        if (dataSourceReference) return dataSourceReference;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        dataSourceProvider?.unsubscribe(dataSourceId, setReference);
        dataSourceProvider?.subscribe(dataSourceId, setReference);
        return ()=>dataSourceProvider?.unsubscribe(dataSourceId, setReference);
    }, [
        dataSourceProvider,
        dataSourceId
    ]);
    return reference ? [
        reference
    ] : [];
};
const $5a206d91b5b3f476$var$ExtensionWithDataSource = (props)=>{
    const reference = $5a206d91b5b3f476$export$eba5603251c4feaf(props);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fPlBD.Extension), {
        ...props,
        references: reference
    });
};
var $5a206d91b5b3f476$export$2e2bcd8739ae039 = $5a206d91b5b3f476$var$ExtensionWithDataSource;





class $9a0ebb093ddd3646$export$63dcdbe82ab2119 extends (0, $gjBRE.ExtensionNode) {
    render(props, forwardRef) {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3oRlx.ExtensionNodeWrapper), {
            nodeType: this.node.type.name,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5a206d91b5b3f476$export$2e2bcd8739ae039), {
                editorAppearance: props.extensionNodeViewOptions.appearance,
                editorView: this.view,
                node: this.node,
                // The getPos arg is always a function when used with nodes
                // the version of the types we use has a union with the type
                // for marks.
                // This has been fixed in later versions of the definitly typed
                // types (and also in prosmirror-views inbuilt types).
                // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57384
                getPos: this.getPos,
                providerFactory: props.providerFactory,
                handleContentDOMRef: forwardRef,
                extensionHandlers: props.extensionHandlers,
                dataSourceProvider: props.dataSourceProvider,
                pluginInjectionApi: props.pluginInjectionApi,
                macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
                showLivePagesBodiedMacrosRendererView: props.showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: props.showUpdatedLivePages1PBodiedExtensionUI,
                rendererExtensionHandlers: props.rendererExtensionHandlers
            })
        });
    }
}
function $9a0ebb093ddd3646$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers) {
    return (node, view, getPos)=>{
        const pluginState = (0, $4tb0i.getPluginState)(view.state);
        return new $9a0ebb093ddd3646$export$63dcdbe82ab2119(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            extensionHandlers: extensionHandlers,
            extensionNodeViewOptions: extensionNodeViewOptions,
            dataSourceProvider: pluginState?.dataSourceProvider,
            pluginInjectionApi: pluginInjectionApi,
            macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: rendererExtensionHandlers
        }).init();
    };
}



var $gcCrc = parcelRequire("gcCrc");


var $ks2lK = parcelRequire("ks2lK");


var $fO7hX = parcelRequire("fO7hX");


var $h9yJL = parcelRequire("h9yJL");


var $2T4ch = parcelRequire("2T4ch");





var $5SAOw = parcelRequire("5SAOw");








var $8m4tT = parcelRequire("8m4tT");


var $9oPnF = parcelRequire("9oPnF");

const $2e1ac7157de99f01$export$8174b2693cae81eb = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return [
        table,
        extension,
        bodiedExtension,
        inlineExtension
    ];
};
const $2e1ac7157de99f01$export$3fdc75161fb8ee49 = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return new Map([
        [
            table,
            'Table'
        ],
        [
            extension,
            'Extension'
        ],
        [
            bodiedExtension,
            'Extension'
        ],
        [
            inlineExtension,
            'Extension'
        ]
    ]);
};
const $2e1ac7157de99f01$export$549d0eefc6fd05c0 = (schema)=>{
    const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return new Set([
        extension,
        bodiedExtension,
        inlineExtension
    ].filter(Boolean));
};
const $2e1ac7157de99f01$export$54a3e405bb0d0a4a = (node, id, name)=>({
        linkNode: {
            localId: id,
            name: name ?? id,
            node: {
                type: node.type.name,
                attrs: {
                    ...node.attrs
                }
            }
        },
        sources: [],
        targets: []
    });
const $2e1ac7157de99f01$export$368b1080eb192086 = (name)=>{
    const splitName = name.split(' '); // ['Awesome', 'list', '2.0', '5']
    if (splitName.length < 2) return null;
    const lastNumberInName = Number(splitName[splitName.length - 1]);
    if (typeof lastNumberInName !== 'number') return null;
    const nameWithoutLastNumber = splitName.slice(0, splitName.length - 1) // ['Awesome', 'list', '2.0']
    .join(' '); // 'Awesome list 2.0'
    return {
        defaultName: nameWithoutLastNumber,
        defaultNameNumber: lastNumberInName
    };
};
const $2e1ac7157de99f01$export$8a9a3ce4139f59c3 = ({ type: type, attrs: attrs }, schema, fragmentMarkNameLastNumbers, nodeNameCallback)=>{
    const nodesSupportingFragmentMark = $2e1ac7157de99f01$export$3fdc75161fb8ee49(schema);
    const nodesSupportingNameCallback = $2e1ac7157de99f01$export$549d0eefc6fd05c0(schema);
    let markName = '';
    if (nodesSupportingNameCallback.has(type)) {
        if (nodeNameCallback) markName = nodeNameCallback({
            node: {
                type: type.name,
                attrs: attrs
            }
        });
    }
    if (!markName) markName = nodesSupportingFragmentMark.get(type) ?? 'Element';
    const markNameNumber = (fragmentMarkNameLastNumbers?.[markName] ?? 0) + 1;
    return {
        markNameWithNumber: `${markName} ${markNameNumber}`,
        markName: markName,
        markNameNumber: markNameNumber
    };
};
const $2e1ac7157de99f01$export$7503e197531554a8 = ({ normalizedId: normalizedId, name: name, node: node })=>$2e1ac7157de99f01$export$dbdf2d08277c626e(normalizedId, name, node);
const $2e1ac7157de99f01$export$dbdf2d08277c626e = (localId, name, node)=>{
    const jsonNode = new (0, $h9yJL.JSONTransformer)().encodeNode(node);
    return {
        localId: localId,
        name: name,
        node: {
            type: jsonNode.type,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            attrs: jsonNode.attrs
        }
    };
};
const $2e1ac7157de99f01$export$c85fa7574bd3ee0b = (context, target, source)=>{
    if (target.normalizedId === source.normalizedId) return true;
    // Try and get a consumer from the source, this is because we don't care about the initial link between target -> source
    // we only care if somewhere down the chain after the source; is there a link back to this target.
    return !!source.dataConsumer?.attrs.sources.some((src)=>{
        const nextSrc = context.getById(src);
        return !!nextSrc && $2e1ac7157de99f01$export$c85fa7574bd3ee0b(context, target, nextSrc);
    });
};
const $2e1ac7157de99f01$export$b25165d24a0db921 = (state, localId)=>{
    let found = false;
    const { doc: doc, schema: schema } = state;
    const { fragment: fragment } = schema.marks;
    const nodesSupportingFragmentMark = $2e1ac7157de99f01$export$3fdc75161fb8ee49(schema);
    // TODO: ED-26962 - Update scanning method to abort the scan immediately once a node has been found.
    doc.descendants((node)=>{
        if (found) return false;
        if (!nodesSupportingFragmentMark.has(node.type)) return true;
        if (node.attrs?.localId === localId) {
            found = true;
            return false;
        }
        const fragmentMark = fragment.isInSet(node.marks);
        // If node cannot be referenced by any means then abort.
        if (!fragmentMark) return true;
        if (fragmentMark?.attrs?.localId === localId) found = true;
        return !found;
    });
    return found;
};
const $2e1ac7157de99f01$export$aadcc3ba2430b = (localId, state)=>{
    const { doc: doc, schema: schema } = state;
    const fragment = schema.marks.fragment;
    const nodesSupportingFragmentMark = $2e1ac7157de99f01$export$3fdc75161fb8ee49(schema);
    let foundNode = null;
    doc.descendants((node, pos)=>{
        if (foundNode) return false;
        if (!nodesSupportingFragmentMark.has(node.type)) return true;
        const existingFragmentMark = fragment.isInSet(node.marks) ?? null;
        if (existingFragmentMark && existingFragmentMark.attrs.localId === localId) {
            foundNode = {
                node: node,
                pos: pos,
                fragmentMark: existingFragmentMark
            };
            return false;
        }
        if (node.attrs.localId === localId) {
            foundNode = {
                node: node,
                pos: pos,
                fragmentMark: existingFragmentMark
            };
            return false;
        }
        return true;
    });
    return foundNode;
};
const $2e1ac7157de99f01$export$ebf688cb60f59a94 = (schema, localId, name, sources)=>{
    const { fragment: fragment, dataConsumer: dataConsumer } = schema.marks;
    return [
        fragment.create({
            localId: localId,
            name: name
        }),
        sources && dataConsumer.create({
            sources: Array.from(sources) ?? []
        })
    ].filter(Boolean);
};
const $2e1ac7157de99f01$export$270e7ba5936d3c48 = (schema, type, attrs, marks)=>{
    const { table: table } = schema.nodes;
    const createNodeContent = type === table ? $2e1ac7157de99f01$export$d142f815ac656d : $2e1ac7157de99f01$export$85ceaeb5400c34da;
    return type.createChecked({
        ...attrs,
        localId: (0, $fO7hX.uuid).generate()
    }, createNodeContent(schema, type), marks);
};
const $2e1ac7157de99f01$export$d142f815ac656d = (schema, type)=>{
    const { tableCell: tableCell, tableHeader: tableHeader, tableRow: tableRow } = schema.nodes;
    const cells = [];
    const headerCells = [];
    for(let i = 0; i < 3; i++){
        const cell = tableCell.createAndFill();
        if (cell) cells.push(cell);
        const headerCell = tableHeader.createAndFill();
        if (headerCell) headerCells.push(headerCell);
    }
    const rows = [];
    for(let i = 0; i < 3; i++)rows.push(tableRow.createChecked(null, i === 0 ? headerCells : cells));
    return rows;
};
const $2e1ac7157de99f01$export$85ceaeb5400c34da = (schema, type)=>{
    const { bodiedExtension: bodiedExtension, paragraph: paragraph } = schema.nodes;
    if (type === bodiedExtension) return [
        paragraph.createChecked()
    ];
    return (0, $5SAOw.Fragment).empty;
};
const $2e1ac7157de99f01$export$9c63b8d16fa708c5 = (localId, node, state, tr, options)=>{
    tr = tr ?? state.tr;
    const nodePos = $2e1ac7157de99f01$export$aadcc3ba2430b(localId, state);
    const insertPosition = nodePos ? nodePos.pos + nodePos.node.nodeSize : undefined;
    tr = (0, $8m4tT.safeInsert)(node, insertPosition)(tr);
    return tr;
};
const $2e1ac7157de99f01$export$4c47e28146a39728 = (context, ids)=>{
    return ids?.reduce((idSet, id)=>{
        const ns = context.getById(id)?.normalizedId;
        // filters out undefined, null or empty items
        return !!ns ? idSet.add(ns) : idSet;
    }, new Set()) ?? new Set();
};
const $2e1ac7157de99f01$export$6c4da287bd77d75c = (schema, target, sources)=>(tr)=>$2e1ac7157de99f01$export$884cb393b34cee0d(schema, target.node, target.pos, sources, target.dataConsumer)(tr);
const $2e1ac7157de99f01$export$884cb393b34cee0d = (schema, node, pos, sources, consumer)=>(tr)=>{
        const { dataConsumer: dataConsumer } = schema.marks;
        const currentSources = (consumer ?? dataConsumer.isInSet(node.marks))?.attrs.sources;
        // Quick Check: No point in updating node markup if nothing is changing.
        if (!sources?.size && !currentSources?.length) return tr;
        // This attempts to check deep equality. If the sizes are not the same or a source is different to what's being set; then
        // we want to perform the markup change, otherwise we should avoid unnecessary transactions.
        if (sources?.size === currentSources?.length && currentSources.every((src)=>sources.has(src))) return tr;
        const marks = (dataConsumer?.removeFromSet(node.marks) ?? node.marks).concat();
        if (!!sources?.size) marks.push(dataConsumer.create({
            sources: Array.from(sources)
        }));
        // If the old target sources is now 0 then the data consumer will be removed from the marks. Otherwise a new
        // consumer with updated sources will be injected.
        tr.setNodeMarkup(pos, undefined, node.attrs, marks);
        return tr;
    };
const $2e1ac7157de99f01$export$c4bf0d625842a200 = (schema, target, name)=>(tr)=>{
        const { fragment: fragment } = schema.marks;
        // Quick Check: No point in updating node markup if nothing is changing.
        if (name === target.fragmentMark?.attrs.name) return tr;
        const marks = (target.fragmentMark?.removeFromSet(target.node.marks) ?? target.node.marks).concat();
        marks.push(fragment.create({
            localId: target.fragmentMark?.attrs.localId ?? (0, $fO7hX.uuid).generate(),
            name: name
        }));
        return tr.setNodeMarkup(target.pos, undefined, target.node.attrs, marks);
    };
const $2e1ac7157de99f01$export$599e2146ce482fc4 = (context, element, nodeNameCallback, sources)=>{
    const nodeType = context.schema.nodes[element.type];
    if (!$2e1ac7157de99f01$export$3fdc75161fb8ee49(context.schema).has(nodeType)) throw new (0, $9oPnF.UnsupportedTypeError)(element.type);
    const newNodeUUID = (0, $fO7hX.uuid).generate();
    if (context.hasId(newNodeUUID)) // XXX: Assuming UUID is true this condition should never occur.
    // This is just a safety catch; to protect against lightning strikes.
    throw new (0, $9oPnF.LocalIdCollisionError)(newNodeUUID);
    let attrs;
    if (element.type !== 'table') attrs = element.attrs;
    const { markNameWithNumber: markNameWithNumber } = $2e1ac7157de99f01$export$8a9a3ce4139f59c3({
        type: nodeType,
        attrs: attrs
    }, context.schema, context.getMaxNumberUsedInFragmentMarkNames(), nodeNameCallback);
    if (element.type === 'table') attrs = {
        width: 760
    };
    const node = $2e1ac7157de99f01$export$270e7ba5936d3c48(context.schema, nodeType, attrs, $2e1ac7157de99f01$export$ebf688cb60f59a94(context.schema, newNodeUUID, markNameWithNumber, sources));
    const { inlineExtension: inlineExtension, paragraph: paragraph } = context.schema.nodes;
    // The finalNode is a post-processed node which is eventually added to the document. This may not be the actual
    // element node this was told to create as some nodes may need to be wrapped by others to be safely added  to the document.
    const finalNode = nodeType === inlineExtension ? paragraph.create(undefined, [
        node
    ]) : node;
    return {
        linkNode: $2e1ac7157de99f01$export$dbdf2d08277c626e(newNodeUUID, markNameWithNumber, node),
        node: finalNode
    };
};
const $2e1ac7157de99f01$export$2e109011d5320d15 = (context, targetLocalId, sourceLocalId, tr)=>{
    const target = context.getById(targetLocalId);
    if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
    const source = context.getById(sourceLocalId);
    if (!source) throw new (0, $9oPnF.SourceReferenceError)(sourceLocalId);
    if (target.normalizedId === source.normalizedId) throw new (0, $9oPnF.CyclicReferenceError)(targetLocalId, sourceLocalId);
    // If the current target dataConsumer already has the source linked.
    const hasDataConsumerSource = !!target.dataConsumer?.attrs.sources.some((src)=>source.ids.has(src));
    if (hasDataConsumerSource) // If the connection has already been made, avoid an unnecessary transaction
    return {
        target: $2e1ac7157de99f01$export$7503e197531554a8(target),
        source: $2e1ac7157de99f01$export$7503e197531554a8(source),
        tr: tr
    };
    else {
        if ($2e1ac7157de99f01$export$c85fa7574bd3ee0b(context, target, source)) throw new (0, $9oPnF.CyclicReferenceError)(targetLocalId, sourceLocalId);
        const newSources = $2e1ac7157de99f01$export$4c47e28146a39728(context, target.dataConsumer?.attrs.sources);
        // Add the source to the target.
        newSources.add(source.normalizedId);
        tr = $2e1ac7157de99f01$export$6c4da287bd77d75c(context.schema, target, newSources)(tr);
    }
    return {
        target: $2e1ac7157de99f01$export$7503e197531554a8(target),
        source: $2e1ac7157de99f01$export$7503e197531554a8(source),
        tr: tr
    };
};
const $2e1ac7157de99f01$export$dba1c2bae2f381b9 = (context, targetLocalId, sourceLocalId, tr)=>{
    const source = context.getById(sourceLocalId);
    if (!source) throw new (0, $9oPnF.SourceReferenceError)(sourceLocalId);
    const target = context.getById(targetLocalId);
    if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
    const targetSources = $2e1ac7157de99f01$export$4c47e28146a39728(context, target.dataConsumer?.attrs.sources);
    // Remove the source from the target (if any) and update the sources if the source was deleted.
    if (targetSources.delete(source.normalizedId)) return $2e1ac7157de99f01$export$6c4da287bd77d75c(context.schema, target, targetSources)(tr);
    return tr;
};
const $2e1ac7157de99f01$export$b0852c37ee3e7ea9 = (context, targetLocalId, sourceLocalId, tr)=>{
    const target = context.getById(targetLocalId);
    if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
    const source = context.getById(sourceLocalId);
    if (!source) throw new (0, $9oPnF.SourceReferenceError)(sourceLocalId);
    if (target.normalizedId === source.normalizedId) throw new (0, $9oPnF.CyclicReferenceError)(targetLocalId, sourceLocalId);
    // If the current target dataConsumer already has the source linked.
    const hasDataConsumerSource = !!target.dataConsumer?.attrs.sources.every((src)=>source.ids.has(src));
    if (hasDataConsumerSource) // If the connection has already been made, avoid an unnecessary transaction
    return {
        target: $2e1ac7157de99f01$export$7503e197531554a8(target),
        source: $2e1ac7157de99f01$export$7503e197531554a8(source),
        tr: tr
    };
    else {
        if ($2e1ac7157de99f01$export$c85fa7574bd3ee0b(context, target, source)) throw new (0, $9oPnF.CyclicReferenceError)(targetLocalId, sourceLocalId);
        tr = $2e1ac7157de99f01$export$6c4da287bd77d75c(context.schema, target, new Set([
            source.normalizedId
        ]))(tr);
    }
    return {
        target: $2e1ac7157de99f01$export$7503e197531554a8(target),
        source: $2e1ac7157de99f01$export$7503e197531554a8(source),
        tr: tr
    };
};
const $2e1ac7157de99f01$export$73aa87199f4a96f5 = (context, localId, tr)=>{
    const source = context.getById(localId);
    if (!source) throw new (0, $9oPnF.SourceReferenceError)(localId);
    source.targets.forEach((target)=>{
        tr = $2e1ac7157de99f01$export$dba1c2bae2f381b9(context, target, localId, tr);
    });
    return tr;
};
const $2e1ac7157de99f01$export$328b0edc9fda3a36 = (context, oldSourceLocalId, newSourceLocalId, tr)=>{
    // This needs to disconnect the old source from all targets. Then update each target with the new source
    const oldSource = context.getById(oldSourceLocalId);
    if (!oldSource) throw new (0, $9oPnF.SourceReferenceError)(oldSourceLocalId);
    const newSource = context.getById(newSourceLocalId);
    if (!newSource) throw new (0, $9oPnF.SourceReferenceError)(newSourceLocalId);
    // If the old/new source are referring to the same connection then we should avoid unnecessary transactions.
    if (oldSource === newSource) return {
        source: $2e1ac7157de99f01$export$7503e197531554a8(newSource),
        tr: tr
    };
    // Before we do any disconnecting or updating we must ensure a couple things first;
    // 1. The old source targets exist
    // 2. Moving the old source target to the new source doesn't cause a cyclic ref.
    for (const targetId of oldSource.targets){
        const target = context.getById(targetId);
        if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetId);
        if ($2e1ac7157de99f01$export$c85fa7574bd3ee0b(context, target, newSource)) throw new (0, $9oPnF.CyclicReferenceError)(targetId, newSourceLocalId);
        const targetSources = $2e1ac7157de99f01$export$4c47e28146a39728(context, target.dataConsumer?.attrs.sources);
        const deleted = targetSources.delete(oldSource.normalizedId);
        // If the target source doesn't have the new source then it will be added.
        const added = !targetSources.has(newSource.normalizedId);
        targetSources.add(newSource.normalizedId);
        if (deleted || added) tr = $2e1ac7157de99f01$export$6c4da287bd77d75c(context.schema, target, targetSources)(tr);
    }
    return {
        source: $2e1ac7157de99f01$export$7503e197531554a8(newSource),
        tr: tr
    };
};
const $2e1ac7157de99f01$export$fb891e3743d8c30f = (context, sourceLocalId, target, tr, nodeNameCallback, oldTargetLocalId)=>{
    const nodeType = context.schema.nodes[target.type];
    if (!$2e1ac7157de99f01$export$3fdc75161fb8ee49(context.schema).has(nodeType)) throw new (0, $9oPnF.UnsupportedTypeError)(target.type);
    if (!context.hasId(sourceLocalId)) throw new (0, $9oPnF.SourceReferenceError)(sourceLocalId);
    const { linkNode: linkNode, node: node } = $2e1ac7157de99f01$export$599e2146ce482fc4(context, target, nodeNameCallback, [
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        context.getById(sourceLocalId).normalizedId
    ]);
    if (!!oldTargetLocalId) // If an old target id has been supplied then this insert action is
    // replacing and old connection, so we need to disconnect the
    // old connection, then insert the new node.
    tr = $2e1ac7157de99f01$export$dba1c2bae2f381b9(context, oldTargetLocalId, sourceLocalId, tr);
    tr = $2e1ac7157de99f01$export$9c63b8d16fa708c5(sourceLocalId, node, context.state, tr);
    tr = tr.setMeta('referentialityTableInserted', node.type.name === context.schema.nodes.table.name);
    return {
        linkNode: linkNode,
        tr: tr
    };
};


class $d8399198c52b1afb$export$3e2fc71d3c4adf01 {
    /**
   * Convenience helper to get the EditorState
   */ get state() {
        return this.view.state;
    }
    /**
   * Convenience helper to get the Schema
   */ get schema() {
        return this.view.state.schema;
    }
    getById(localId) {
        return this.connections.get(localId);
    }
    hasId(localId) {
        return this.connections.has(localId);
    }
    getMaxNumberUsedInFragmentMarkNames() {
        return {
            ...this.maxNumberUsedInFragmentMarkName
        };
    }
    getMaxNumberUsedInFragmentMarkName(name) {
        return this.maxNumberUsedInFragmentMarkName[name] ?? 0;
    }
    updateMaxNumberUsedInFragmentMarkNames(name, value) {
        this.maxNumberUsedInFragmentMarkName[name] = value;
    }
    *uniqueConnections() {
        for (const id of this.uniqueNormalizedIds){
            const connection = this.connections.get(id);
            if (connection) yield connection;
        }
    }
    /**
   * This generator will only return connections which contain DataConsumer sources.
   */ *consumerOnlyConnections() {
        for (const id of this.uniqueNormalizedIds){
            const connection = this.connections.get(id);
            if (connection && !!connection.dataConsumer?.attrs.sources.length) yield connection;
        }
    }
    /**
   * This generator will only return connections which are sources
   */ *sourceOnlyConnections() {
        for (const id of this.uniqueSourceNormalizedIds){
            const connection = this.connections.get(id);
            if (connection) yield connection;
        }
    }
    /**
   * This generator will return connections which do not contain a name or fragment
   */ *namelessOnlyConnections() {
        for (const id of this.namelessNormalizedIds){
            const connection = this.connections.get(id);
            if (connection) yield connection;
        }
    }
    /**
   * @constructor
   * @param view
   * @param shallow A flag to help identify the depth of scan required. This default to true. A Shallow context assumes
   * that nodes with data consumers cannot contain descendants with fragmentMarks or dataConsumers
   */ constructor(view, normalizeLocalId, shallow = true){
        this.view = view;
        this.normalizeLocalId = normalizeLocalId;
        this.shallow = shallow;
        /**
     * This record is used to keep track of the max number in each fragment name.
     */ this.maxNumberUsedInFragmentMarkName = {};
        /**
     * This map enables quick lookup of all unnormalized connections
     */ this.connections = new Map();
        /**
     * This is a unique set containing only normalized localIds
     */ this.uniqueNormalizedIds = new Set();
        /**
     * This is a unique set containing only normalized localIds
     */ this.uniqueSourceNormalizedIds = new Set();
        /**
     * This is a unique set of normalized localIds which are nameless
     */ this.namelessNormalizedIds = new Set();
        const { doc: doc, schema: schema } = this.view.state;
        const { fragment: fragment, dataConsumer: dataConsumer } = schema.marks;
        const nodesSupportingFragmentMark = (0, $2e1ac7157de99f01$export$3fdc75161fb8ee49)(schema);
        const sourceToTargetMappings = new Map();
        doc.descendants((node, pos, parent)=>{
            if (!nodesSupportingFragmentMark.has(node.type)) return true;
            const fragmentMark = fragment.isInSet(node.marks);
            // If node cannot be referenced by any means then abort.
            if (!fragmentMark && !node.attrs?.localId) return true;
            const normalizedId = this.normalizeLocalId(node.attrs?.localId, fragmentMark?.attrs?.localId);
            if (!normalizedId || this.connections.has(normalizedId)) return true;
            let decodedName;
            if (!!fragmentMark?.attrs.name) {
                decodedName = (0, $2e1ac7157de99f01$export$368b1080eb192086)(fragmentMark.attrs.name);
                if (decodedName) {
                    const currentMax = this.maxNumberUsedInFragmentMarkName[decodedName.defaultName];
                    if (currentMax === undefined || currentMax < decodedName.defaultNameNumber) this.maxNumberUsedInFragmentMarkName[decodedName.defaultName] = decodedName.defaultNameNumber;
                }
            } else this.namelessNormalizedIds.add(normalizedId);
            const consumer = dataConsumer.isInSet(node.marks);
            const ref = {
                node: node,
                pos: pos,
                parent: parent,
                normalizedId: normalizedId,
                name: fragmentMark?.attrs?.name ?? normalizedId,
                ids: new Set(),
                targets: new Set(),
                fragmentMark: fragmentMark,
                dataConsumer: consumer,
                decodedName: decodedName
            };
            if (!!fragmentMark?.attrs?.localId) {
                ref.ids.add(fragmentMark.attrs.localId);
                this.connections.set(fragmentMark.attrs.localId, ref);
            }
            if (!!node.attrs?.localId) {
                ref.ids.add(node.attrs.localId);
                this.connections.set(node.attrs.localId, ref);
            }
            this.uniqueNormalizedIds.add(normalizedId);
            if (consumer) // A lookup map of srcId -> targetId[]. This enables quickly finding all nodes
            // which consume a specific source.
            consumer.attrs.sources.forEach((src)=>sourceToTargetMappings.set(src, sourceToTargetMappings.get(src)?.add(normalizedId) ?? new Set([
                    normalizedId
                ])));
            // Do not descend into children of a node which has a dataConsumer attached. This assumes all children of the node cannot
            // be referenced by another node. Unless of course this is not a shallow context.
            // if consumer: true & shallow: true -> return false // don't descend
            // if consumer: false & shallow: true -> return true // descend
            // if consumer: true & shallow: false -> return true // descend
            // if consumer: false & shallow: false -> return true // descend
            return !(shallow && consumer);
        });
        // This 2nd-pass is used to normalize all the source ids. We need to have full context before we're able to do this.
        for (const [source, targets] of sourceToTargetMappings){
            const connection = this.connections.get(source);
            if (connection) {
                this.uniqueSourceNormalizedIds.add(connection.normalizedId);
                connection.targets = new Set([
                    ...connection.targets,
                    ...targets
                ]);
            }
        }
    }
}







var $d925B = parcelRequire("d925B");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32b6226d0cdd6a9e$var$getPayload = (payload)=>({
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        tags: [
            'editor'
        ],
        ...payload
    });
const $32b6226d0cdd6a9e$export$12008b1cff7b5512 = ({ docSize: docSize, count: count, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).INITIALISED_FRAGMENT_MARK,
            attributes: {
                duration: duration,
                docSize: docSize,
                count: count
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$bff45a9f8c570c00 = ({ docSize: docSize, sourceNodeType: sourceNodeType, targetNodeType: targetNodeType, type: type, actionType: actionType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).CONNECTED_NODES,
            attributes: {
                duration: duration,
                docSize: docSize,
                sourceNodeType: sourceNodeType,
                targetNodeType: targetNodeType,
                type: type,
                actionType: actionType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$d0d121977041a37d = ({ docSize: docSize, oldSourceNodeType: oldSourceNodeType, newSourceNodeType: newSourceNodeType, type: type, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).UPDATED_SOURCE,
            attributes: {
                duration: duration,
                docSize: docSize,
                oldSourceNodeType: oldSourceNodeType,
                newSourceNodeType: newSourceNodeType,
                type: type
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$9f5791db63c112cc = ({ docSize: docSize, targetNodeType: targetNodeType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).DISCONNECTED_SOURCE,
            attributes: {
                duration: duration,
                docSize: docSize,
                targetNodeType: targetNodeType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$1bb576f3f4bb0389 = ({ docSize: docSize, sourceNodeType: sourceNodeType, targetNodeType: targetNodeType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).DISCONNECTED_TARGET,
            attributes: {
                duration: duration,
                docSize: docSize,
                sourceNodeType: sourceNodeType,
                targetNodeType: targetNodeType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$41746208cd3b8ef5 = ({ docSize: docSize, newTargetNodeType: newTargetNodeType, oldTargetNodeType: oldTargetNodeType, sourceNodeType: sourceNodeType, type: type, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).UPDATED_TARGET,
            attributes: {
                duration: duration,
                docSize: docSize,
                newTargetNodeType: newTargetNodeType,
                oldTargetNodeType: oldTargetNodeType,
                sourceNodeType: sourceNodeType,
                type: type
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$6f3cdc6bed2f6e2e = ({ nodeType: nodeType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).UPDATED_FRAGMENT_MARK_NAME,
            attributes: {
                duration: duration,
                nodeType: nodeType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$c56def702d19a484 = ({ count: count, docSize: docSize, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).GOT_CONNECTIONS,
            attributes: {
                docSize: docSize,
                duration: duration,
                count: count
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};


class $e9714976d4e11162$export$6a5e825be2d43d52 {
    get isAttached() {
        return !!this.editorView;
    }
    attach(editorView) {
        const { state: { schema: schema } } = editorView;
        if (!schema.marks.fragment) throw new (0, $9oPnF.CompatibilityError)('fragmentMark not supported');
        this.editorView = editorView;
    }
    detach() {
        this.editorView = undefined;
    }
    setNodeFocusCallback(callback) {
        this.nodeFocusCallback = callback;
    }
    setNodeNameCallback(callback) {
        this.nodeNameCallback = callback;
    }
    setSelectedLocalId(localId) {
        if (this.selectedLocalId === localId) return;
        this.selectedLocalId = localId;
        if (!!this.nodeFocusCallback) {
            if (!localId) {
                this.nodeFocusCallback(undefined);
                return;
            }
            if (this.editorView) {
                const { state: state } = this.editorView;
                const foundNode = (0, $2e1ac7157de99f01$export$aadcc3ba2430b)(localId, state);
                if (foundNode) this.nodeFocusCallback((0, $2e1ac7157de99f01$export$dbdf2d08277c626e)(this.normalizeLocalId(localId, foundNode.fragmentMark?.attrs.localId), foundNode.fragmentMark?.attrs.name || '', foundNode.node));
            }
        }
    }
    initialiseFragmentMarks() {
        if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('initialiseFragmentMarks');
        (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).INITIALISE_FRAGMENT_MARKS);
        const { state: state, dispatch: dispatch } = this.editorView;
        let { tr: tr } = state;
        const docSize = state.doc.nodeSize;
        const context = new (0, $d8399198c52b1afb$export$3e2fc71d3c4adf01)(this.editorView, this.normalizeLocalId, false);
        let count = 0;
        const maxNumberUsedInFragmentMarkNames = context.getMaxNumberUsedInFragmentMarkNames();
        for (const target of context.namelessOnlyConnections()){
            const { markNameWithNumber: markNameWithNumber, markName: markName, markNameNumber: markNameNumber } = (0, $2e1ac7157de99f01$export$8a9a3ce4139f59c3)(target.node, state.schema, maxNumberUsedInFragmentMarkNames, this.nodeNameCallback);
            maxNumberUsedInFragmentMarkNames[markName] = markNameNumber;
            tr = (0, $2e1ac7157de99f01$export$c4bf0d625842a200)(state.schema, target, markNameWithNumber)(tr);
            count++;
        }
        tr.setMeta('addToHistory', false);
        (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).INITIALISE_FRAGMENT_MARKS, (0, $32b6226d0cdd6a9e$export$12008b1cff7b5512)({
            docSize: docSize,
            count: count,
            tr: tr,
            editorAnalyticsAPI: this.editorAnalyticsAPI
        }));
        dispatch(tr);
    }
    getConnections() {
        (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).GET_CONNECTIONS);
        const result = {};
        if (!this.editorView) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).GET_CONNECTIONS);
            return result;
        }
        const { state: { tr: tr, doc: { nodeSize: nodeSize } } } = this.editorView;
        const context = new (0, $d8399198c52b1afb$export$3e2fc71d3c4adf01)(this.editorView, this.normalizeLocalId);
        // First initialize all possible connection linkages
        for (const { node: node, normalizedId: normalizedId, name: name } of context.uniqueConnections())result[normalizedId] = (0, $2e1ac7157de99f01$export$54a3e405bb0d0a4a)(node, normalizedId, name);
        // This 2nd-pass only looks at the consumer sources and updates all connections with the correct id refs.
        for (const { normalizedId: normalizedId, dataConsumer: dataConsumer } of context.consumerOnlyConnections()){
            // This is a ref to the node (connection link) which contains the consumer.
            const currentNodeLink = result[normalizedId];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dataConsumer.attrs.sources.forEach((src)=>{
                const normalizedSrcId = context.getById(src)?.normalizedId ?? src;
                const srcLink = result[normalizedSrcId];
                if (srcLink && normalizedSrcId !== normalizedId) {
                    srcLink.targets.push(normalizedId);
                    currentNodeLink?.sources.push(normalizedSrcId);
                }
            });
        }
        (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).GET_CONNECTIONS, (0, $32b6226d0cdd6a9e$export$c56def702d19a484)({
            tr: tr,
            editorAnalyticsAPI: this.editorAnalyticsAPI,
            docSize: nodeSize,
            count: Object.keys(result).length
        }));
        return result;
    }
    select(localId, scroll = false) {
        if (!this.editorView || !localId) throw new (0, $9oPnF.ConfigurationError)('select');
        const { state: state, dispatch: dispatch } = this.editorView;
        const foundNode = (0, $2e1ac7157de99f01$export$aadcc3ba2430b)(localId, state);
        if (foundNode) {
            const { tr: tr } = state;
            tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, foundNode.pos));
            if (scroll) tr.scrollIntoView();
            tr.setMeta('addToHistory', false);
            dispatch(tr);
        }
    }
    updateName(localId, name) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_FRAGMENT_MARK_NAME);
            if (!this.isAttached || !this.editorView) throw new (0, $9oPnF.ConfigurationError)('updateName');
            const { state: state, state: { schema: schema }, dispatch: dispatch } = this.editorView;
            const foundNode = (0, $2e1ac7157de99f01$export$aadcc3ba2430b)(localId, state);
            if (!foundNode) throw new (0, $9oPnF.NodeNotFoundError)(localId);
            const { fragment: fragment } = schema.marks;
            const { fragmentMark: fragmentMark, node: node, pos: pos } = foundNode;
            const fragLocalId = fragmentMark?.attrs.localId ?? (0, $fO7hX.uuid).generate();
            const nextFragmentMark = fragment.create({
                localId: fragLocalId,
                name: name
            });
            const nextMarks = fragmentMark ? node.marks.filter((mark)=>mark.type !== nextFragmentMark.type) : node.marks.concat();
            nextMarks.push(nextFragmentMark);
            // ensure the fragment mark on the node has the correct id & name.
            const tr = state.tr.setNodeMarkup(pos, undefined, node.attrs, nextMarks);
            dispatch(tr);
            const linkNode = (0, $2e1ac7157de99f01$export$dbdf2d08277c626e)(this.normalizeLocalId(node.attrs.localId, fragLocalId), name, node);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_FRAGMENT_MARK_NAME, (0, $32b6226d0cdd6a9e$export$6f3cdc6bed2f6e2e)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                nodeType: node.type.name
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_FRAGMENT_MARK_NAME);
            throw e;
        }
    }
    getADFFromLocalId(localId) {
        if (!this.isAttached || !this.editorView) throw new (0, $9oPnF.ConfigurationError)('getADFFromLocalId');
        const { state: state } = this.editorView;
        const foundNode = (0, $2e1ac7157de99f01$export$aadcc3ba2430b)(localId, state);
        if (!foundNode) throw new (0, $9oPnF.NodeNotFoundError)(localId);
        return new (0, $h9yJL.JSONTransformer)().encodeNode(foundNode.node);
    }
    connectSource(targetLocalId, sourceLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('connectSource');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $d8399198c52b1afb$export$3e2fc71d3c4adf01)(this.editorView, this.normalizeLocalId);
            const { source: source, target: target, tr: tr } = (0, $2e1ac7157de99f01$export$2e109011d5320d15)(context, targetLocalId, sourceLocalId, state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES, (0, $32b6226d0cdd6a9e$export$bff45a9f8c570c00)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectSource',
                type: 'connect',
                sourceNodeType: source.node.type,
                targetNodeType: target.node.type
            }));
            return source;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    connectTarget(sourceLocalId, targetLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('connectTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $d8399198c52b1afb$export$3e2fc71d3c4adf01)(this.editorView, this.normalizeLocalId);
            const { source: source, target: target, tr: tr } = (0, $2e1ac7157de99f01$export$2e109011d5320d15)(context, targetLocalId, sourceLocalId, state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES, (0, $32b6226d0cdd6a9e$export$bff45a9f8c570c00)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectTarget',
                type: 'connect',
                sourceNodeType: source.node.type,
                targetNodeType: target.node.type
            }));
            return target;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    updateTarget(sourceLocalId, oldTargetLocalId, newTargetLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('updateTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $d8399198c52b1afb$export$3e2fc71d3c4adf01)(this.editorView, this.normalizeLocalId);
            const { target: target, source: source, tr: tr } = (0, $2e1ac7157de99f01$export$2e109011d5320d15)(context, newTargetLocalId, sourceLocalId, (0, $2e1ac7157de99f01$export$dba1c2bae2f381b9)(context, oldTargetLocalId, sourceLocalId, state.tr));
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET, (0, $32b6226d0cdd6a9e$export$41746208cd3b8ef5)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                newTargetNodeType: target.node.type,
                oldTargetNodeType: context.getById(oldTargetLocalId)?.node.type.name || '',
                sourceNodeType: source.node.type,
                type: 'update'
            }));
            return target;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET);
            throw e;
        }
    }
    updateSource(targetLocalId, newSourceLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('updateSource');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $d8399198c52b1afb$export$3e2fc71d3c4adf01)(this.editorView, this.normalizeLocalId);
            const { target: target, source: source, tr: tr } = (0, $2e1ac7157de99f01$export$b0852c37ee3e7ea9)(context, targetLocalId, newSourceLocalId, state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE, (0, $32b6226d0cdd6a9e$export$d0d121977041a37d)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                oldSourceNodeType: target.node.type,
                newSourceNodeType: source.node.type,
                type: 'update'
            }));
            return source;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE);
            throw e;
        }
    }
    disconnectTarget(sourceLocalId, targetLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_TARGET);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('disconnectTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $d8399198c52b1afb$export$3e2fc71d3c4adf01)(this.editorView, this.normalizeLocalId);
            const tr = (0, $2e1ac7157de99f01$export$dba1c2bae2f381b9)(context, targetLocalId, sourceLocalId, state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_TARGET, (0, $32b6226d0cdd6a9e$export$1bb576f3f4bb0389)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                sourceNodeType: context.getById(sourceLocalId)?.node.type.name || '',
                targetNodeType: context.getById(targetLocalId)?.node.type.name || ''
            }));
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_TARGET);
            throw e;
        }
    }
    disconnectSource(targetLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_SOURCE);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('disconnectSource');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const target = (0, $2e1ac7157de99f01$export$aadcc3ba2430b)(targetLocalId, state);
            if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
            const tr = (0, $2e1ac7157de99f01$export$884cb393b34cee0d)(state.schema, target.node, target.pos)(state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_SOURCE, (0, $32b6226d0cdd6a9e$export$9f5791db63c112cc)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                targetNodeType: target.node.type.name
            }));
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_SOURCE);
            throw e;
        }
    }
    insertAndConnectTarget(sourceLocalId, target) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('insertAndConnectTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const context = new (0, $d8399198c52b1afb$export$3e2fc71d3c4adf01)(this.editorView, this.normalizeLocalId);
            const { linkNode: linkNode, tr: tr } = (0, $2e1ac7157de99f01$export$fb891e3743d8c30f)(context, sourceLocalId, target, state.tr, this.nodeNameCallback);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES, (0, $32b6226d0cdd6a9e$export$bff45a9f8c570c00)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectTarget',
                type: 'insertAndConnect',
                sourceNodeType: context.getById(sourceLocalId)?.node.type.name || '',
                targetNodeType: target.type
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    insertAndConnectSource(targetLocalId, source) {
        try {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('insertAndConnectSource');
            const { state: state, state: { schema: schema }, dispatch: dispatch } = this.editorView;
            const nodeType = schema.nodes[source.type];
            if (!(0, $2e1ac7157de99f01$export$3fdc75161fb8ee49)(schema).has(nodeType)) throw new (0, $9oPnF.UnsupportedTypeError)(source.type);
            const context = new (0, $d8399198c52b1afb$export$3e2fc71d3c4adf01)(this.editorView, this.normalizeLocalId);
            const target = context.getById(targetLocalId);
            if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
            const { linkNode: linkNode, node: node } = (0, $2e1ac7157de99f01$export$599e2146ce482fc4)(context, source, this.nodeNameCallback);
            let tr = state.tr;
            const targetSources = (0, $2e1ac7157de99f01$export$4c47e28146a39728)(context, target.dataConsumer?.attrs.sources).add(linkNode.localId);
            tr = (0, $2e1ac7157de99f01$export$6c4da287bd77d75c)(schema, target, targetSources)(tr);
            tr = (0, $2e1ac7157de99f01$export$9c63b8d16fa708c5)(targetLocalId, node, state, tr);
            tr = tr.setMeta('referentialityTableInserted', node.type.name === schema.nodes.table.name);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES, (0, $32b6226d0cdd6a9e$export$bff45a9f8c570c00)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectSource',
                type: 'insertAndConnect',
                sourceNodeType: node.type.name,
                targetNodeType: context.getById(targetLocalId)?.node.type.name || ''
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    replaceAndUpdateTarget(sourceLocalId, oldTargetLocalId, newTarget) {
        try {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('replaceAndUpdateTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const context = new (0, $d8399198c52b1afb$export$3e2fc71d3c4adf01)(this.editorView, this.normalizeLocalId);
            const { linkNode: linkNode, tr: tr } = (0, $2e1ac7157de99f01$export$fb891e3743d8c30f)(context, sourceLocalId, newTarget, state.tr, this.nodeNameCallback, oldTargetLocalId);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET, (0, $32b6226d0cdd6a9e$export$41746208cd3b8ef5)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                type: 'replaceAndUpdate',
                newTargetNodeType: newTarget.type,
                oldTargetNodeType: context.getById(oldTargetLocalId)?.node.type.name || '',
                sourceNodeType: context.getById(sourceLocalId)?.node.type.name || ''
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET);
            throw e;
        }
    }
    replaceAndUpdateSource(targetLocalId, newSource) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('replaceAndUpdateSource');
            const { state: { schema: schema }, state: state, dispatch: dispatch } = this.editorView;
            const nodeType = schema.nodes[newSource.type];
            if (!(0, $2e1ac7157de99f01$export$3fdc75161fb8ee49)(schema).has(nodeType)) throw new (0, $9oPnF.UnsupportedTypeError)(newSource.type);
            const context = new (0, $d8399198c52b1afb$export$3e2fc71d3c4adf01)(this.editorView, this.normalizeLocalId);
            const target = context.getById(targetLocalId);
            if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
            const { linkNode: linkNode, node: node } = (0, $2e1ac7157de99f01$export$599e2146ce482fc4)(context, newSource, this.nodeNameCallback);
            let tr = (0, $2e1ac7157de99f01$export$6c4da287bd77d75c)(context.schema, target, new Set([
                linkNode.localId
            ]))(state.tr);
            tr = (0, $2e1ac7157de99f01$export$9c63b8d16fa708c5)(targetLocalId, node, state, tr);
            tr = tr.setMeta('referentialityTableInserted', node.type.name === schema.nodes.table.name);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE, (0, $32b6226d0cdd6a9e$export$d0d121977041a37d)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                oldSourceNodeType: target.node.type.name,
                newSourceNodeType: newSource.type,
                type: 'replaceAndUpdate'
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE);
            throw e;
        }
    }
    /**
   * @constructor
   */ constructor({ nodeNameCallback: nodeNameCallback, nodeFocusCallback: // you can also set this callback using setNodeNameCallback method
    nodeFocusCallback, editorAnalyticsAPI: // you can also set this callback using setNodeFocusCallback method
    editorAnalyticsAPI, editorView: editorView, featureFlags: featureFlags } = {}){
        this.nodeNameCallback = void 0;
        this.nodeFocusCallback = void 0;
        this.normalizeLocalId = void 0;
        this.editorAnalyticsAPI = void 0;
        this.editorView = void 0;
        this.selectedLocalId = void 0;
        this.nodeNameCallback = nodeNameCallback;
        this.nodeFocusCallback = nodeFocusCallback;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
        this.editorView = editorView;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.normalizeLocalId = (attrsLocalId, fragmentLocalId)=>fragmentLocalId ?? attrsLocalId;
    }
}









var $2XqLN = parcelRequire("2XqLN");


// This is a Statsig experiment
const $5e97256736fa056e$export$977ce18f16415288 = 'confluence_frontend_macro_interaction_design';


const $6e4cd1d435523f2b$var$EmitterEvents = {
    TABLE_DELETED: 'TABLE_DELETED'
};
const $6e4cd1d435523f2b$export$35dc45686fc2dbd7 = (node)=>{
    try {
        node.check();
        return true;
    } catch (err) {
        return false;
    }
};
const $6e4cd1d435523f2b$var$allowedSource = (node, schema)=>{
    const nodeName = typeof node.type === 'string' ? node.type : node.type.name;
    return [
        schema.nodes.table?.name
    ].includes(nodeName) && node.attrs?.localId;
};
const $6e4cd1d435523f2b$var$transformer = new (0, $h9yJL.JSONTransformer)();
const $6e4cd1d435523f2b$var$memoizedEncodeNode = (0, $2XqLN.default)((node)=>$6e4cd1d435523f2b$var$transformer.encodeNode(node));
function $6e4cd1d435523f2b$var$createPlugin(providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, externalObservers, options = {}, pluginInjectionApi, api, featureFlags, __livePage, __rendererExtensionOptions) {
    const macroInteractionDesignFeatureFlags = {
        showMacroInteractionDesignUpdates: !!featureFlags?.[0, $5e97256736fa056e$export$977ce18f16415288]
    };
    const showLivePagesBodiedMacrosRendererView = __rendererExtensionOptions?.isAllowedToUseRendererView;
    const extensionNodeViewOptions = {
        appearance: options.appearance,
        getExtensionHeight: options.getExtensionHeight
    };
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $4tb0i.pluginKey),
        state: {
            init () {
                const dataSourceProvider = new (0, $lEgye.DataSourceProvider)();
                const nodeMutationObserver = new (0, $26165acd862f475d$export$ab608a64509503ae)(dataSourceProvider);
                externalObservers.forEach((externalObserver)=>externalObserver.init({
                        emit: (localId, data)=>dataSourceProvider.createOrUpdate(localId, data)
                    }));
                return {
                    dataSourceProvider: dataSourceProvider,
                    nodeMutationObserver: nodeMutationObserver,
                    changedSources: new Map(),
                    selectedNodeLocalId: undefined
                };
            },
            apply (tr, pluginState, state, ns) {
                let selectedNodeLocalId = pluginState.selectedNodeLocalId;
                if (!!api && !state.selection.eq(ns.selection)) {
                    const supportedNodeTypes = (0, $2e1ac7157de99f01$export$8174b2693cae81eb)(state.schema);
                    const { fragment: fragment } = state.schema.marks;
                    const selectedNode = (0, $8m4tT.findSelectedNodeOfType)(supportedNodeTypes)(tr.selection) || (0, $8m4tT.findParentNodeOfType)(supportedNodeTypes)(tr.selection);
                    selectedNodeLocalId = selectedNode?.node && (fragment?.isInSet(selectedNode?.node.marks)?.attrs.localId || selectedNode?.node.attrs.localId);
                }
                const selectedLocalIdChanged = selectedNodeLocalId !== pluginState.selectedNodeLocalId;
                if (!tr.docChanged) return selectedLocalIdChanged ? {
                    ...pluginState,
                    selectedNodeLocalId: selectedNodeLocalId
                } : pluginState;
                const changedSources = new Map();
                for (const [pos, node] of pluginState.changedSources.entries()){
                    const newPos = tr.mapping.map(pos);
                    changedSources.set(newPos, node);
                }
                // Handle added/updated table node
                const changedNodes = (0, $2pjJ5.getChangedNodes)(tr).filter(({ node: node })=>{
                    // Since we are calling node validation with every interaction in useDispatchTransaction, we can safely drop the check node here to improve performance.
                    // More details: https://hello.atlassian.net/wiki/spaces/~70121ba36f99acdb4453d8f80fd8186963f3e/pages/5081212079/Optimising+typing+latency#Bonus
                    return tr.getMeta('uiEvent') !== 'cut' && $6e4cd1d435523f2b$var$allowedSource(node, state.schema);
                });
                changedNodes.forEach(({ node: sourceNode, pos: pos })=>{
                    changedSources.set(pos, sourceNode);
                });
                if (changedNodes.length) return {
                    ...pluginState,
                    changedSources: changedSources,
                    selectedNodeLocalId: selectedNodeLocalId
                };
                if (selectedLocalIdChanged) return {
                    ...pluginState,
                    selectedNodeLocalId: selectedNodeLocalId
                };
                return pluginState;
            }
        },
        view: (editorView)=>{
            api?.attach(editorView);
            const tableNodeSchema = editorView.state.schema.nodes.table;
            const pluginState = (0, $4tb0i.getPluginState)(editorView.state);
            if (!pluginState) return {};
            let handleDeleteDataSource;
            const dataSourceProvider = pluginState.dataSourceProvider;
            const nodeMutationObserver = pluginState.nodeMutationObserver;
            if (dataSourceProvider) {
                handleDeleteDataSource = (node)=>{
                    if (node && node.attrs) {
                        let tableExistsInDoc = false;
                        // ensure the destroyed node is actually not recreated
                        (0, $8m4tT.findChildrenByType)(editorView.state.doc, tableNodeSchema).forEach(({ node: existingNode })=>{
                            if (existingNode.attrs.localId === node.attrs.localId) tableExistsInDoc = true;
                        });
                        if (!tableExistsInDoc) dataSourceProvider.delete(node.attrs.localId);
                    }
                };
                eventDispatcher.on($6e4cd1d435523f2b$var$EmitterEvents.TABLE_DELETED, handleDeleteDataSource);
            }
            if (nodeMutationObserver) (0, $8m4tT.findChildrenByType)(editorView.state.doc, tableNodeSchema).forEach(({ node: node })=>{
                const fragmentLocalId = node?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
                if (fragmentLocalId) nodeMutationObserver.emit(fragmentLocalId, {
                    get [(0, $gcCrc.ADFReferenceTypes).TABLE] () {
                        return $6e4cd1d435523f2b$var$memoizedEncodeNode(node);
                    }
                });
                nodeMutationObserver.emit(node.attrs.localId, {
                    get [(0, $gcCrc.ADFReferenceTypes).TABLE] () {
                        return $6e4cd1d435523f2b$var$memoizedEncodeNode(node);
                    }
                });
            });
            return {
                update (view, prevState) {
                    const pluginState = (0, $4tb0i.getPluginState)(view.state);
                    if (!pluginState) return;
                    const prevPluginState = (0, $4tb0i.getPluginState)(prevState);
                    const { changedSources: changedSources, nodeMutationObserver: nodeMutationObserver, selectedNodeLocalId: selectedNodeLocalId } = pluginState;
                    if (selectedNodeLocalId !== prevPluginState?.selectedNodeLocalId) api?.setSelectedLocalId(selectedNodeLocalId);
                    changedSources.forEach((node, pos)=>{
                        const fragmentLocalId = node?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
                        if (fragmentLocalId) nodeMutationObserver.emit(fragmentLocalId, {
                            get [(0, $gcCrc.ADFReferenceTypes).TABLE] () {
                                return $6e4cd1d435523f2b$var$memoizedEncodeNode(node);
                            }
                        });
                        if (node.attrs?.localId) nodeMutationObserver.emit(node.attrs.localId, {
                            get [(0, $gcCrc.ADFReferenceTypes).TABLE] () {
                                return $6e4cd1d435523f2b$var$memoizedEncodeNode(node);
                            }
                        });
                    });
                    changedSources.clear();
                },
                destroy () {
                    api?.detach();
                    if (dataSourceProvider) {
                        eventDispatcher.off($6e4cd1d435523f2b$var$EmitterEvents.TABLE_DELETED, handleDeleteDataSource);
                        if (dataSourceProvider.clear) dataSourceProvider.clear();
                    }
                }
            };
        },
        props: {
            nodeViews: {
                // WARNING: these need to be kept in sync with the nodeViews
                // setup in the extension plugin.
                extension: (0, $9a0ebb093ddd3646$export$2e2bcd8739ae039)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags),
                // WARNING: these need to be kept in sync with the nodeViews
                // setup in the extension plugin.
                bodiedExtension: (0, $9a0ebb093ddd3646$export$2e2bcd8739ae039)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, __rendererExtensionOptions?.showUpdated1PBodiedExtensionUI, __rendererExtensionOptions?.rendererExtensionHandlers),
                // WARNING: these need to be kept in sync with the nodeViews
                // setup in the extension plugin.
                inlineExtension: (0, $9a0ebb093ddd3646$export$2e2bcd8739ae039)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags)
            }
        }
    });
}
const $6e4cd1d435523f2b$export$9d03c288c4007750 = ({ config: options, api: pluginInjectionApi })=>({
        name: 'referentiality',
        pmPlugins () {
            return [
                {
                    name: 'referentiality',
                    plugin: ({ providerFactory: providerFactory, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher })=>{
                        const extensionHandlers = options?.extensionHandlers ?? {};
                        const externalObservers = options?.externalObservers ?? [];
                        return $6e4cd1d435523f2b$var$createPlugin(providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, externalObservers, {
                            appearance: options?.appearance,
                            getExtensionHeight: options?.getExtensionHeight
                        }, pluginInjectionApi, options?.api, options?.featureFlags, options?.__livePage, options?.__rendererExtensionOptions);
                    }
                }
            ];
        }
    });
const $6e4cd1d435523f2b$export$7e7e0965a9844ba0 = (options)=>{
    const api = options?.api ?? new (0, $e9714976d4e11162$export$6a5e825be2d43d52)(options);
    return {
        api: api,
        plugin: $6e4cd1d435523f2b$export$9d03c288c4007750({
            config: {
                ...options,
                api: api
            }
        })
    };
};
module.exports["referentialityPlugin"] = $6e4cd1d435523f2b$export$9d03c288c4007750;
module.exports["createReferentiality"] = $6e4cd1d435523f2b$export$7e7e0965a9844ba0;

});

parcelRegister("4xvYZ", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $4tb0i = parcelRequire("4tb0i");

const $20c78fd742182292$export$5e2881449d7cf240 = (editorActions)=>{
    const state = editorActions?._privateGetEditorView()?.state;
    if (!state) return null;
    const selection = state.selection;
    if (selection instanceof (0, $ks2lK.NodeSelection)) {
        const dataSourceId = selection.node.marks?.find((mark)=>mark.type === state.schema?.marks?.dataConsumer)?.attrs?.sources[0];
        if (!dataSourceId) return null;
        const dataSourceProvider = (0, $4tb0i.getPluginState)(state)?.dataSourceProvider;
        return dataSourceProvider?.get(dataSourceId);
    }
};
module.exports["dataSourceResolver"] = $20c78fd742182292$export$5e2881449d7cf240;

});

parcelRegister("lEgye", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
class $9eb3f7291ea30683$export$83ebb6424014532f {
    createOrUpdate(id, reference) {
        this.dataSources.set(id, reference);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const requestCallback = window.requestIdleCallback || window.requestAnimationFrame;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const cancelCallback = window.cancelIdleCallback || window.cancelAnimationFrame;
        // TODO: ED-26962 - refactor if needed - https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/8012/ed-11927-data-source-provider#comment-206010499
        const callbackId = requestCallback(()=>{
            cancelCallback(callbackId);
            this.notifySubscribers(id, reference);
        });
    }
    notifySubscribers(id, reference) {
        if (this.subscriptions.has(id)) this.subscriptions.get(id)?.forEach((callback)=>{
            callback(reference);
        });
    }
    subscribe(id, callback) {
        if (!this.subscriptions.has(id)) this.subscriptions.set(id, new Set());
        this.subscriptions.get(id)?.add(callback);
    }
    unsubscribe(id, callback) {
        if (!this.subscriptions.has(id)) return;
        this.subscriptions.get(id)?.delete(callback);
    }
    delete(id) {
        this.dataSources.delete(id);
        this.notifySubscribers(id, null);
    }
    get(id) {
        return this.dataSources.get(id) || null;
    }
    clear() {
        this.dataSources.clear();
        this.subscriptions.clear();
    }
    constructor(){
        this.subscriptions = new Map();
        this.dataSources = new Map();
    }
}
module.exports["DataSourceProvider"] = $9eb3f7291ea30683$export$83ebb6424014532f;

});

parcelRegister("eVKuj", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $gcCrc = parcelRequire("gcCrc");

// Getting all nodes mapping (LocalId => ADNode)
const $807577750dac8d47$var$getAllNodes = (nodes = [])=>{
    let allNodes = new Map();
    nodes.forEach((node)=>{
        const existingFragmentMark = node.marks?.find((m)=>m.type === 'fragment');
        const fragmentLocalId = existingFragmentMark?.attrs?.localId;
        if (fragmentLocalId) allNodes.set(fragmentLocalId, node);
        if (node.attrs?.localId) allNodes.set(node.attrs.localId, node);
        if (node.content) allNodes = new Map([
            ...allNodes,
            ...$807577750dac8d47$var$getAllNodes(node.content)
        ]);
    });
    return allNodes;
};
const $807577750dac8d47$var$memoGetAllNodes = (0, $2XqLN.default)((adf)=>$807577750dac8d47$var$getAllNodes(adf.content));
const $807577750dac8d47$export$cd3f7ccaa044b456 = ({ adf: adf, extensionParams: extensionParams, dataSourceProvider: dataSourceProvider })=>{
    const allADFNodes = $807577750dac8d47$var$memoGetAllNodes(adf);
    const activeNodeFromADF = allADFNodes.get(extensionParams.localId);
    // At the moment we support only one data consumer
    const dataSourceId = activeNodeFromADF?.marks?.find((mark)=>mark.type === 'dataConsumer')?.attrs?.sources?.[0];
    const [reference, setReference] = (0, $42omo.useState)(()=>{
        const dataSourceNode = allADFNodes.get(dataSourceId);
        // At the momment only table nodes as a source are supported
        if (dataSourceNode?.type === 'table') return {
            [(0, $gcCrc.ADFReferenceTypes).TABLE]: dataSourceNode
        };
    });
    (0, $42omo.useEffect)(()=>{
        if (!dataSourceId) return;
        dataSourceProvider?.subscribe(dataSourceId, setReference);
        return ()=>dataSourceProvider?.unsubscribe(dataSourceId, setReference);
    }, [
        dataSourceProvider,
        dataSourceId
    ]);
    return {
        references: reference ? [
            reference
        ] : []
    };
};
module.exports["useReference"] = $807577750dac8d47$export$cd3f7ccaa044b456;

});

parcelRegister("gcCrc", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
var $b1f12d58a935bfc6$export$eeab3cae4ffcf74a = /*#__PURE__*/ function(ADFReferenceTypes) {
    ADFReferenceTypes["TABLE"] = "table-adf";
    return ADFReferenceTypes;
}({});
var $b1f12d58a935bfc6$export$5cb1f459478c70e = /*#__PURE__*/ function(MEASURE_NAME) {
    MEASURE_NAME["INITIALISE_FRAGMENT_MARKS"] = "initialiseFragmentMarks";
    MEASURE_NAME["CONNECT_NODES"] = "connectNodes";
    MEASURE_NAME["UPDATE_SOURCE"] = "updateSource";
    MEASURE_NAME["DISCONNECT_SOURCE"] = "disconnectSource";
    MEASURE_NAME["UPDATE_TARGET"] = "updateTarget";
    MEASURE_NAME["DISCONNECT_TARGET"] = "disconnectTarget";
    MEASURE_NAME["UPDATE_FRAGMENT_MARK_NAME"] = "updateFragmentMarkName";
    MEASURE_NAME["GET_CONNECTIONS"] = "getConnections";
    return MEASURE_NAME;
}({});
module.exports["ADFReferenceTypes"] = $b1f12d58a935bfc6$export$eeab3cae4ffcf74a;
module.exports["MEASURE_NAME"] = $b1f12d58a935bfc6$export$5cb1f459478c70e;

});

parcelRegister("9oPnF", function(module, exports) {
class $4157e5902416a90b$export$fa0bafaea078bc3e extends Error {
    constructor(reason){
        super(`Unable to attach, Incorrect configuration: ${reason}`), this.reason = reason;
    }
}
class $4157e5902416a90b$export$c9ab3ad70477eb extends Error {
    constructor(handlerName){
        super(`Unable to execute ${handlerName}, API hasn't been initialized`), this.handlerName = handlerName;
    }
}
class $4157e5902416a90b$export$6b13996afffc6894 extends Error {
    constructor(){
        super('An Error occured during Initialization');
    }
}
class $4157e5902416a90b$export$e162153238934121 extends Error {
    constructor(){
        super('API not implemented');
    }
}
class $4157e5902416a90b$export$fef5df6faf884a63 extends Error {
    constructor(type){
        super(`Unsupported type (${type})`);
    }
}
class $4157e5902416a90b$export$8ef43b75008b17aa extends ReferenceError {
    constructor(localId){
        super(`Node (${localId}) could not be found`), this.localId = localId;
    }
}
class $4157e5902416a90b$export$88aaf39bc2cab9a8 extends $4157e5902416a90b$export$8ef43b75008b17aa {
    constructor(localId){
        super(localId), this.localId = localId;
    }
}
class $4157e5902416a90b$export$311a85310d085910 extends $4157e5902416a90b$export$8ef43b75008b17aa {
    constructor(localId){
        super(localId), this.localId = localId;
    }
}
class $4157e5902416a90b$export$1a3d80e823d9a375 extends ReferenceError {
    constructor(targetLocalId, sourceLocalId){
        super(`Connecting Target (${targetLocalId}) to Source (${sourceLocalId}) will result in a Circular Reference`), this.targetLocalId = targetLocalId, this.sourceLocalId = sourceLocalId;
    }
}
class $4157e5902416a90b$export$d754643475748116 extends ReferenceError {
    constructor(localId){
        super(`LocalId (${localId}) Collision has occured`), this.localId = localId;
    }
}
module.exports["CompatibilityError"] = $4157e5902416a90b$export$fa0bafaea078bc3e;
module.exports["ConfigurationError"] = $4157e5902416a90b$export$c9ab3ad70477eb;
module.exports["UnsupportedTypeError"] = $4157e5902416a90b$export$fef5df6faf884a63;
module.exports["NodeNotFoundError"] = $4157e5902416a90b$export$8ef43b75008b17aa;
module.exports["TargetReferenceError"] = $4157e5902416a90b$export$88aaf39bc2cab9a8;
module.exports["SourceReferenceError"] = $4157e5902416a90b$export$311a85310d085910;
module.exports["CyclicReferenceError"] = $4157e5902416a90b$export$1a3d80e823d9a375;
module.exports["LocalIdCollisionError"] = $4157e5902416a90b$export$d754643475748116;

});

parcelRegister("989nU", function(module, exports) {
/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $kksmx = parcelRequire("kksmx");


var $8pcS0 = parcelRequire("8pcS0");


var $6mEZ3 = parcelRequire("6mEZ3");


var $4JC0x = parcelRequire("4JC0x");


var $l6Xaz = parcelRequire("l6Xaz");


var $bQm3c = parcelRequire("bQm3c");


var $9tVje = parcelRequire("9tVje");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $6AplS = parcelRequire("6AplS");


var $iaRmR = parcelRequire("iaRmR");


var $KcDWk = parcelRequire("KcDWk");


var $bYtfC = parcelRequire("bYtfC");


var $3o0Dr = parcelRequire("3o0Dr");


var $lqWPF = parcelRequire("lqWPF");


var $ji0Re = parcelRequire("ji0Re");


var $ebUME = parcelRequire("ebUME");

const $fc5bf07eec92d197$export$4f1d7d3b9a74b4f8 = ({ macroRenderedOutput: macroRenderedOutput, macroDefaultProps: macroDefaultProps, containerRef: containerRef, macroOutput: rawMacroOutput, reuseSSRedElement: reuseSSRedElement, renderedByProvider: renderedByProvider = false })=>{
    // NOTE: `featureFlags` object here is prop-drilled down through layers
    // of legacy code so the usage of deprecated attribute is retained here.
    const { featureFlags: featureFlags, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const macroOutput = rawMacroOutput;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { node: node, contentId: contentId, mode: mode, extensionKey: extensionKey } = macroDefaultProps;
    const { viewportHeight: viewportHeight } = (0, $bYtfC.useConnectExtensionViewportSize)(node);
    const keys = Object.keys(node);
    keys.forEach((key)=>{
        if (node[key] === undefined || node[key] === null) delete node[key];
    });
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const isMissingMacroParameters = node.parameters?.macroParams?.isMissingRequiredParameters?.value;
    (0, $42omo.useEffect)(()=>{
        if (macroOutput) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'macro.with.macroOutput',
                source: 'FabricLegacyMacrosServerRenderer',
                attributes: {
                    extensionKey: extensionKey,
                    contentId: contentId
                }
            }
        }).fire();
    }, [
        macroOutput,
        createAnalyticsEvent,
        extensionKey,
        contentId
    ]);
    const macroData = (0, $ji0Re.useMacroContentData)(contentId, node);
    const ssredElement = (0, $KcDWk.useSSRedLegacyMacroElement)(macroId);
    const containsMacro = macroRenderedOutput ? macroRenderedOutput.filter((macro)=>macro?.key === macroId) : [];
    let macroHtml = macroData?.macroBodyRenderer?.value || containsMacro[0]?.value?.value || macroOutput;
    if (extensionKey && macroRenderedOutput) // If a Tiny page with Style Macro gets converted to Fabric, need to Scope the CSS
    // Not limiting extensionKey to "style" only because the Style Macro can be nested in other macros
    macroHtml = (0, $6AplS.scopeCSS)(macroHtml, (0, $6AplS.mainContentSelector)).contentWithScopedCSS;
    const dataMacroBody = (0, $lqWPF.useDataMacroBody)(node, contentId);
    /**
   * "tasks-report-macro" has no actually required macro parameters.
   * Required parameter was introduced for UI only so the macro doesn't try to render all tasks in the instance when it's inserted in editor,
   *
   * Due to a bug https://product-fabric.atlassian.net/browse/COMMENTS-177
   * it has polluted database with wrong isMissingMacroParameters and it prevents SSRing of this particular (and popular) macro.
   * This check should be removed when we fix the property editor and clean up the DB.
   */ const isActuallyMissingMacroParameters = isMissingMacroParameters && extensionKey !== 'tasks-report-macro';
    //To match the placeholder from SPA
    if (isMissingMacroParameters && extensionKey === 'tasks-report-macro' && !node.parameters?.macroParams?.pages && !node.parameters?.macroParams?.spaces) {
        const macro_0 = {
            title: 'Task report',
            macroName: extensionKey,
            icon: {
                height: 80,
                location: '/download/resources/com.atlassian.confluence.plugins.confluence-inline-tasks/tasks-report-image-resources/task-report.png',
                relative: true,
                width: 80
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9tVje.ExtensionPlaceholder), {
            isEditor: false,
            macro: macro_0,
            description: (0, $9tVje.editToSetupMessage)
        });
    }
    /**
   *
   * skip check if macroOutput exists, as it contains all the html
   * required to render the macro
   */ if (!macroOutput && isActuallyMissingMacroParameters) return null;
    const preloadingDataPresent = macroData && !dataMacroBody.missing || macroData?.macroBodyStorageFormat;
    // If there's no data and no macro data from preloading to render - resort to standard macro preloading
    if (!macroOutput && containsMacro.length === 0 && !preloadingDataPresent) {
        (0, $4JC0x.markMissingMacroData)(macroId, extensionKey);
        // This logic is applicable to the cases when there's no server output for given macro
        // and therefore macro data loading is deferred till client code takes over. The idea is
        // when macro data is unavailable we attempt preloading it through the query preloader.
        //
        // NOTE: there's a lot of logic around what query to use (see LegacyMacroRendererQuery)
        // and the fact that we may want to THROTTLE macro loading to not overwhelm the backend.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3o0Dr.FabricLegacyMacrosServerLoader), macroDefaultProps);
    }
    // Continue showing the placeholder for the first render if the macro marked during SSR to prevent hydration mismatches
    if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    renderServerPlaceholder && window.__MISSING_DATA_MACROS__?.includes(macroId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3o0Dr.FabricLegacyMacrosServerLoader), macroDefaultProps);
    if (!macroHtml) return null;
    // Continue showing the null for the first render if the macro was not SSRed to prevent hydration mismatches
    if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    renderServerPlaceholder && !window.__MISSING_DATA_MACROS__?.includes(macroId) && !window.__LEGACY_MACRO_SSRED__?.[macroId]) return null;
    const css = macroData?.macroBodyRenderer?.webResourceDependencies?.tags?.css || macroData?.macroBodyRenderer?.webResource?.tags?.css || containsMacro[0]?.value?.webresource?.tags?.css;
    const js = macroData?.macroBodyRenderer?.webResourceDependencies?.tags?.js || macroData?.macroBodyRenderer?.webResource?.tags?.js || containsMacro[0]?.value?.webresource?.tags?.js;
    const adf = (0, $6mEZ3.extensionToADF)(macroDefaultProps.node);
    const isInline = adf.type === (0, $8pcS0.INLINE_EXTENSION_TYPE);
    const macroDataProps = {
        'data-fabric-macro': macroId,
        'data-macro-body': macroData?.macroBodyStorageFormat?.value || dataMacroBody.value,
        'data-macro-parameters': (0, $6mEZ3.getParametersString)(node),
        'data-skate-created': undefined
    };
    const nodeProps = {
        // ref will be passed in only for SPA in order to load default WRM modules
        ref: containerRef || null
    };
    let macroRepresentation = macroData?.macroBodyRenderer?.representation || containsMacro[0]?.value?.representation || 'view';
    if (macroData?.macroBodyRenderer?.macroRenderedRepresentation && extensionKey === 'include' && (0, $6mKj3.expVal)('confluence_frontend_ssr_include_macro_exp', 'isEnabled', false)) macroRepresentation = macroData?.macroBodyRenderer?.macroRenderedRepresentation;
    const mediaToken = macroData?.macroBodyRenderer?.mediaToken?.token;
    // In case of ADF format there might be nested macro(s)
    // so we have to pass extensionHandlers to dispatch them
    const extensionHandlers = macroRepresentation === 'atlas_doc_format' ? (0, $ebUME.getSsrExtensionHandlers)({
        adf: macroHtml,
        contentId: contentId,
        userId: userId,
        cloudId: cloudId,
        mediaToken: mediaToken
    }) : undefined;
    const elementProps = {
        adf: adf,
        isInline: isInline,
        contentId: contentId,
        mode: mode,
        extensionKey: extensionKey,
        macroRepresentation: macroRepresentation,
        macroDataProps: macroDataProps,
        macroRenderedOutput: macroHtml,
        featureFlags: featureFlags,
        nodeProps: nodeProps,
        mediaToken: mediaToken,
        extensionHandlers: extensionHandlers,
        ssredElement: ssredElement,
        delayIframe: true,
        height: viewportHeight
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, css && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        key: "css-container",
        "data-testid": "macro_css",
        dangerouslySetInnerHTML: {
            __html: css
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iaRmR.LegacyMacroStyledElement), {
        renderedByProvider: renderedByProvider,
        ...elementProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kksmx.ExtensionSSRMark), {
        macroId: macroId,
        renderType: (0, $kksmx.getRenderType)(macroOutput, macroData)
    }), js && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "macro_js",
        dangerouslySetInnerHTML: {
            __html: `${(0, $l6Xaz.deferScript)(js)}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    }));
};
module.exports["FabricLegacyMacrosServerRenderer"] = $fc5bf07eec92d197$export$4f1d7d3b9a74b4f8;

});

parcelRegister("6gj4X", function(module, exports) {
const $45b144f792a5212a$export$36b5af56b86b89d3 = (isLegacyRenderer, rendererProps)=>{
    if (!isLegacyRenderer) return rendererProps;
    return {
        adf: rendererProps.document,
        objectId: rendererProps.contentId
    };
};
const $45b144f792a5212a$export$47eae2202f029f6b = (node)=>node?.parameters?.macroMetadata?.macroId?.value;
module.exports["convertRendererProps"] = $45b144f792a5212a$export$36b5af56b86b89d3;
module.exports["getMacroId"] = $45b144f792a5212a$export$47eae2202f029f6b;

});

parcelRegister("4tb0i", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $37c64d6535cfb5cb$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('referentialityPlugin');
const $37c64d6535cfb5cb$export$f05434c51e3762e = (state)=>state && $37c64d6535cfb5cb$export$18d4026d1ea86bb1.getState(state);
module.exports["pluginKey"] = $37c64d6535cfb5cb$export$18d4026d1ea86bb1;
module.exports["getPluginState"] = $37c64d6535cfb5cb$export$f05434c51e3762e;

});

parcelRegister("iaRmR", function(module, exports) {
/* LegacyMacroStyledElement.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* SSR is also using the same elements to prevent duplication and risk for getting out of sync. Moved to fabric extension to
 prevent circular dependency with fabric-extension-handler and content-renderer */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $iRRvH = parcelRequire("iRRvH");


var $hEeUR = parcelRequire("hEeUR");


var $adbKg = parcelRequire("adbKg");


var $9wGTI = parcelRequire("9wGTI");


var $1aGr8 = parcelRequire("1aGr8");


var $5kjCz = parcelRequire("5kjCz");


var $iHLZT = parcelRequire("iHLZT");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $gEtAQ = parcelRequire("gEtAQ");


var $KcDWk = parcelRequire("KcDWk");

'use no memo';
const $442661c5ce449806$var$findMacroElementWithoutConnectIframe = (macroId)=>{
    if ((0, $6mKj3.expValEquals)('confluence-not-valid-selector', 'isEnabled', true)) {
        const elements = Array.from(document.querySelectorAll(`[data-fabric-macro="${macroId}"][data-skate-created]`));
        for (const el of elements){
            // Exclude elements that contain Connect iframe script or container
            if (!el.querySelector('.ap-iframe-body-script') && !el.querySelector('.ap-iframe-container')) return el;
        }
        return null;
    } else return document.querySelector(`[data-fabric-macro="${macroId}"][data-skate-created]:not(:has(.ap-iframe-body-script)):not(:has(.ap-iframe-container))`);
};
const $442661c5ce449806$var$hasMacroBeenHydrated = {};
function $442661c5ce449806$var$LegacyMacroDOMManipulatedByJQuery({ macroId: macroId, content: content, containerRef: containerRef, isConnectIframeEarlyInitialized: isConnectIframeEarlyInitialized, renderedByProvider: renderedByProvider }) {
    const [hydrated, setHydrated] = (0, $42omo.useState)($442661c5ce449806$var$hasMacroBeenHydrated[macroId]);
    if (!hydrated) // This needs to happen before rendering.
    // Collect the real DOM before replacing it with placeholder (LoadablePlaceholderClient)
    (0, $KcDWk.collectSSRedLegacyMacro)(macroId);
    const ref = (0, $42omo.useRef)(null);
    const domElement = (0, $KcDWk.useSSRedLegacyMacroElement)(macroId);
    (0, $42omo.useLayoutEffect)(()=>{
        if (hydrated) {
            const markerElement = ref.current;
            if (markerElement && domElement) {
                markerElement.insertAdjacentElement('afterend', domElement); // When early webpanel initialization is enabled, the SSR-rendered Connect iframe
                // was rendered with renderedByProvider=false, which applied inline styles to hide it.
                // After hydration, we need to directly update those inline styles on the DOM element.
                if (isConnectIframeEarlyInitialized && renderedByProvider === false) {
                    if (domElement instanceof HTMLElement) {
                        // Directly update the inline styles to match renderedByProvider=true
                        domElement.style.visibility = 'visible';
                        domElement.style.display = 'revert';
                    }
                } // Set this callback is important because it signals setIsMacroResourcesLoaded in LegacyMacroRendererComponent
                // Which updates LegacyMacroRendererComponentResourcesSSR UFOLoadHold
                if (containerRef && typeof containerRef === 'function') containerRef(domElement);
                return ()=>{
                    // We inserted domElement above which is outside the React lifecycle
                    // When the actual macro is rendered, this component will unmount.
                    // At that point, we need to remove the inserted element to avoid duplication
                    try {
                        domElement.parentNode?.removeChild(domElement);
                    } catch  {}
                };
            }
        } else {
            // External state instead of ref because the ancestor of this component
            // will change from FabricLegacyMacrosServerRenderer to PageContentRendererFabric
            // The external state is used to keep state between re-mounts.
            $442661c5ce449806$var$hasMacroBeenHydrated[macroId] = true; // Local state is used to trigger re-render
            setHydrated(true);
        }
    }, [
        hydrated,
        macroId,
        domElement,
        containerRef,
        isConnectIframeEarlyInitialized,
        renderedByProvider
    ]);
    // If we didn't save the real DOM for whatever reason just render again.
    // We will get flicker but at least we will not break the page.
    if (!domElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, content);
     /**
     * There are certain SSRed macros that have jquery DOM manipulation.
     * For those macros hydration is not going to work as React don't know about the DOM changes.
     * If we put macroHtml on the page it will flip back to the initial state. eg page tree macro.
     *
     * - We display the SSR rendered result. This is when hydrated = false. This is to ensure React don't freak out in hydration.
     * - However because LoadablePlaceholderClient converts DOM elements to React component on the fly. Click handlers are going to get lost.
     * - We will later replace it with collected real DOM element. This is when hydrated = true.
     * - Because the ancestor will change from FabricLegacyMacrosServerRenderer to PageContentRendererFabric all local state will be lost. hasMacroBeenHydrated will ensure we still use the real DOM with PageContentRendererFabric.
     */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hydrated ? // don't render this on the first paint to avoid breaking hydration
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        ref: ref,
        "data-legacy-macro-placeholder-ref": true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1aGr8.LoadablePlaceholderClient), {
        placeholderId: `legacy-macro-${macroId}`,
        clientPlaceholder: ()=>content,
        uniquePlaceholderId: true
    }));
}
const $442661c5ce449806$var$getExtensionElementStyle = (isConnectIframeEarlyInitialized, renderedByProvider, macroRenderedOutput, isInline, style, nodeHeight)=>{
    if (!isConnectIframeEarlyInitialized) return style;
    const iframeHeightMatch = macroRenderedOutput?.match(/"h":\s*"(\d+(?:%|px)?)"/);
    const shouldUseNodeHeight = (0, $9wGTI.fg)('confluence_connect_renderer_height_preset') && nodeHeight;
    return {
        ...style,
        /**
     * The height of an extension (or Connect iframe) can come from the app's descriptor returned in macroRenderedOutput
     * or could be in macroParams on the node itself. To reduce CLS, we ideally pick the extension height from the
     * node itself and fallback to the descriptor height, if any of the aforementioned values are declared. Long term, we
     * want to rely on the node itself to declare the height it should be for SSR. A similar flow is reflected in
     * @atlaskit/editor/renderer/src/react/nodes/extension.tsx
     */ ...shouldUseNodeHeight && {
            minHeight: nodeHeight
        },
        height: iframeHeightMatch?.[1] || '',
        // There are two render paths for Connect iframes as detailed in ExtensionRenderer, which both use
        // this component. First is with getSSRExtensionHandlers which renders in SSR + SPA before providers have
        // loaded, and then using getNodeRenderer after providers have loaded. If connect resources have been preloaded,
        // this means iframe will render in non-provider flow as well. We want to hide connect iframe during this time in
        // order to prevent users from seeing a flicker when iframe gets recreated during provider flow.
        visibility: !renderedByProvider ? 'hidden' : 'visible',
        // If height is NOT provided in macroRenderedOutput, we don't want to display the iframe at all during
        // non-provider flow so dynamic height/width of hidden iframe doesn't cause CLS in DOM. We also hide with any inline
        // macro due to existing bug on Connect side width being set as an html attribute with dev supplied width, and 100%
        // width in style attribute.
        display: !renderedByProvider && (!iframeHeightMatch?.[1] || isInline) ? 'none' : 'revert'
    };
};
const $442661c5ce449806$export$2b189d249f2bce2b = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, className: className, isInline: isInline, nodeProps: nodeProps, macroDataProps: macroDataProps, macroRepresentation: macroRepresentation, macroRenderedOutput: macroRenderedOutput, style: style, children: children, featureFlags: featureFlags, extensionHandlers: extensionHandlers, mediaToken: mediaToken, ssredElement: ssredElement, delayIframe: delayIframe, extensionKey: extensionKey, renderedByProvider: renderedByProvider, isConnectIframeEarlyInitialized: isConnectIframeEarlyInitialized = false, height: height })=>{
    const ElementTag = isInline ? 'span' : 'div';
    const macroId = macroDataProps?.['data-fabric-macro'];
    const containerRef = nodeProps?.ref;
    const placeholderRef = (0, $42omo.useRef)(null);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const elementStyle = (0, $42omo.useMemo)(()=>$442661c5ce449806$var$getExtensionElementStyle(isConnectIframeEarlyInitialized, renderedByProvider, macroRenderedOutput, isInline, style, height), [
        isConnectIframeEarlyInitialized,
        renderedByProvider,
        macroRenderedOutput,
        isInline,
        style,
        height
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const markerElement = placeholderRef.current;
        if (markerElement && ssredElement) {
            markerElement.insertAdjacentElement('afterend', ssredElement);
            if (containerRef && typeof containerRef === 'function') containerRef(ssredElement);
            return ()=>{
                // We inserted ssredElement above which is outside the React lifecycle
                // When the actual macro is rendered, this component will unmount.
                // At that point, we need to remove the inserted element to avoid duplication
                try {
                    ssredElement.parentNode?.removeChild(ssredElement);
                } catch  {}
            };
        }
    }, [
        containerRef,
        ssredElement
    ]);
    (0, $adbKg.useDelayedIframe)(delayIframe, ssredElement);
    if (children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ElementTag // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        ...nodeProps,
        ...macroDataProps
    }, children);
    if (macroRepresentation === 'atlas_doc_format') return macroRenderedOutput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ElementTag // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        ...nodeProps,
        ...macroDataProps,
        "data-testid": "legacy-macro-adf",
        "data-vc": `legacy-macro-element_${extensionKey || 'no-extension-key-provided'}`,
        "data-vc-ignore-if-no-layout-shift": true,
        ...renderServerPlaceholder ? {
            'data-ssr-placeholder': macroId
        } : {
            'data-ssr-placeholder-replace': macroId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
        document: JSON.parse(macroRenderedOutput),
        contentId: contentId,
        featureFlags: featureFlags ?? {},
        extensionHandlers: extensionHandlers,
        mediaToken: mediaToken,
        appearance: "full-width"
    })) : null;
    else {
        // we don't need to do placeholder logic when hydration is enabled
        const shouldDisablePlaceholder = window?.__HYDRATABLE__;
        if (!shouldDisablePlaceholder && ssredElement && !(0, $9wGTI.fg)('enable_loadable_placeholder_for_legacy_macros')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            ref: placeholderRef,
            "data-legacy-ssred-element-ref": true
        });
        const macroHtml = delayIframe ? (0, $adbKg.delayIframeLoading)(macroRenderedOutput) : macroRenderedOutput;
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ElementTag // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: className,
            style: elementStyle,
            dangerouslySetInnerHTML: {
                __html: `${macroHtml}`
            },
            ...nodeProps,
            ...macroDataProps,
            ...delayIframe ? {
                'data-delay-iframe': '1'
            } : {},
            "data-testid": "legacy-macro-element",
            "data-vc": `legacy-macro-element_${extensionKey || 'no-extension-key-provided'}`,
            "data-vc-ignore-if-no-layout-shift": true,
            ...renderServerPlaceholder ? {
                'data-ssr-placeholder': macroId
            } : {
                'data-ssr-placeholder-replace': macroId
            }
        });
        if (window.__SSR_RENDERED__ && // If the macro is server rendered
        macroHtml?.includes(`data-macro-id="${macroId}"`) && // When hydrating, DOM contains element that was manipulated by jQuery
        // Exclude connect init script or connect iframe
        // There is no point of copy iframe because there is no way to move it without reloading the iframe content.
        ($442661c5ce449806$var$findMacroElementWithoutConnectIframe(macroId) || // When we hydrated the macro, replacing the placeholder with the saved real DOM element
        document.querySelector('[data-legacy-macro-placeholder-ref]'))) {
            if ((0, $9wGTI.fg)('confluence_frontend_revert_macro_hydration_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($442661c5ce449806$var$LegacyMacroDOMManipulatedByJQuery, {
                macroId: macroId,
                content: content,
                containerRef: containerRef,
                isConnectIframeEarlyInitialized: isConnectIframeEarlyInitialized,
                renderedByProvider: renderedByProvider
            });
            return renderServerPlaceholder && window.__SSR_REACT_STREAMING__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1aGr8.LoadablePlaceholderServer), {
                placeholderId: `legacy-macro-${macroId}`
            }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($442661c5ce449806$var$LegacyMacroDOMManipulatedByJQuery, {
                macroId: macroId,
                content: content,
                containerRef: containerRef,
                isConnectIframeEarlyInitialized: isConnectIframeEarlyInitialized,
                renderedByProvider: renderedByProvider
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1aGr8.LoadablePlaceholderServer), {
            placeholderId: `legacy-macro-${macroId}`
        }, content);
    }
});
const $442661c5ce449806$var$createClassnameForExtension = (adf)=>{
    const macroParams = adf?.attrs?.parameters?.macroParams || {};
    const extensionKey = adf?.attrs?.extensionKey || '';
    let key = `macro${extensionKey}`;
    if (extensionKey === 'jira' && !macroParams.key && !macroParams.count) key += 'Table';
    return key;
};
const $442661c5ce449806$var$LegacyMacroStyledElementBaseStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementJiraTableStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementIncludeStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementEditorModeStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementRendererModeStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementInlineStyles = null;
const $442661c5ce449806$export$e9dd081c6786d35c = ({ adf: adf, mode: mode, isInline: isInline, ...props })=>{
    const hasMacroJiraTable = $442661c5ce449806$var$createClassnameForExtension(adf) === 'macrojiraTable';
    const hasMacroInclude = $442661c5ce449806$var$createClassnameForExtension(adf) === 'macroinclude';
    const isConnectIframeEarlyInitialized = props.macroRenderedOutput?.includes('ap-iframe-body-script') && (0, $gEtAQ.isSpaceOverview)() && ((0, $9wGTI.fg)('content_early_connect_iframe_initialization') || (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)); // Include connect web resources html in case there is a Connect iframe on the page.
    if (isConnectIframeEarlyInitialized) {
        (0, $iHLZT.superbatchJSRecorder).includeConnectWebResources();
        (0, $iHLZT.superbatchCSSRecorder).includeConnectWebResources();
    } // Check if this contains Connect iframe content that should be wrapped in UFOThirdPartySegment
    const hasConnectIframe = props.macroRenderedOutput?.includes('ap-iframe-body-script') || props.macroRenderedOutput?.includes('ap-iframe-container');
    const macroElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($442661c5ce449806$export$2b189d249f2bce2b, {
        adf: adf,
        mode: mode,
        isInline: isInline,
        isConnectIframeEarlyInitialized: isConnectIframeEarlyInitialized,
        ...props,
        className: (0, $gMc0m.default)([
            "_o5724jg8 _11rm1hrf _5xln4jg8 _1v0sze3t _tmbuze3t _og5autpp _oxx4utpp",
            hasMacroJiraTable && "_1e0c1ule _p12f1osq _1reo1wug _1cqiaq80 _1lkk4jg8",
            hasMacroInclude && "_1t1412x7 _12c1ze3t _4lh2ze3t _1cqiaq80 _hxtqze3t _vzdwze3t",
            mode === (0, $5kjCz.EDITOR) && "_kqswh2mm _uiztglyw",
            isInline && "_11rmglyw",
            mode === (0, $5kjCz.RENDERER) && isInline && "_1yt4v77o _1e0c1o8l"
        ])
    }); // Wrap Connect iframe content in UFOThirdPartySegment to exclude from TTVC calculations
    return hasConnectIframe && (0, $6mKj3.expVal)('confluence_frontend_iframe_exclusion', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
        name: `legacy-macro-${props.extensionKey || 'connect-iframe'}`
    }, macroElement) : macroElement;
};
module.exports["LegacyMacroStyledElement"] = $442661c5ce449806$export$e9dd081c6786d35c;

});

parcelRegister("bYtfC", function(module, exports) {
/**
 * Currently, very few legacy (connect) macros provide their expected rendered height/width
 * values in their macro parameters. Of those that do, there's a slight but consistent
 * margin of error for the height value. Others that don't render dynamic content we can
 * set a default height for (such as Miro embed).
 *
 * Any changes here should be reflected in @confluence/fabric-extension-legacy-macro-renderer
 */ const $f6824b7afd9ef7c7$var$DRAW_IO_HEIGHT_OFFSET = 52;
const $f6824b7afd9ef7c7$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT = 79;
const $f6824b7afd9ef7c7$var$PLANTUML_OFFSET_HEIGHT = 40;
// Default sizes
const $f6824b7afd9ef7c7$var$MIRO_EMBED_DEFAULT_HEIGHT = 450;
const $f6824b7afd9ef7c7$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT = 47;
const $f6824b7afd9ef7c7$var$MATH_BLOCK_DEFAULT_HEIGHT = 58;
const $f6824b7afd9ef7c7$var$PAGE_SIGNATURES_DEFAULT_HEIGHT = 23;
const $f6824b7afd9ef7c7$var$QUESTIONS_LIST_DEFAULT_HEIGHT = 800;
const $f6824b7afd9ef7c7$var$JIRA_ROADMAP_DEFAULT_HEIGHT = 600;
const $f6824b7afd9ef7c7$var$LUCID_CHART_DEFAULT_HEIGHT = 500;
const $f6824b7afd9ef7c7$var$GLIFFY_DEFAULT_HEIGHT = 150;
const $f6824b7afd9ef7c7$var$AURA_DIVIDER_DEFAULT_HEIGHT = 21;
const $f6824b7afd9ef7c7$var$AURA_CARDS_DEFAULT_HEIGHT = 226;
const $f6824b7afd9ef7c7$var$getHeightFromParams = (node)=>{
    if (!node) return;
    const extensionKey = node.extensionKey;
    const params = node.parameters?.macroParams;
    /**
   * DrawIo will resize diagrams based on the viewport they are rendered in
   * if the diagram's width is greater than 530px. This means that the natural dimensions
   * provided in macro parameters could be the incorrect height to reserve so we will
   * conservatively exclude them.
   */ if (extensionKey === 'drawio' || extensionKey === 'inc-drawio' || extensionKey === 'drawio-sketch') {
        const diagramWidth = Number(params?.width?.value);
        const zoomFactor = Number(params?.zoom?.value);
        if (diagramWidth && diagramWidth > 530 || zoomFactor !== 1) // Exclude wide diagrams due to allow resizing by vendor
        return;
    }
    if (extensionKey === 'plantumlcloud') return params?.originalHeight?.value;
    return params?.height?.value;
};
const $f6824b7afd9ef7c7$export$1a33580c6521db41 = (node)=>{
    const macroHeight = $f6824b7afd9ef7c7$var$getHeightFromParams(node);
    const extensionKey = node?.extensionKey;
    let height = Number(macroHeight);
    if (!Number.isNaN(height)) // for extensions that provide a number, add their offset
    switch(extensionKey){
        case 'drawio':
        case 'inc-drawio':
        case 'drawio-sketch':
            height += $f6824b7afd9ef7c7$var$DRAW_IO_HEIGHT_OFFSET;
            break;
        case 'lref-gdrive-embedded-file':
            height += $f6824b7afd9ef7c7$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT;
            break;
        case 'plantumlcloud':
            height += $f6824b7afd9ef7c7$var$PLANTUML_OFFSET_HEIGHT;
            break;
        default:
            break;
    }
    else // for extensions that don't resize based on their content, we can set a default height
    switch(extensionKey){
        case 'gliffy':
            height = $f6824b7afd9ef7c7$var$GLIFFY_DEFAULT_HEIGHT;
            break;
        case 'aura-divider':
            height = $f6824b7afd9ef7c7$var$AURA_DIVIDER_DEFAULT_HEIGHT;
            break;
        case 'aura-cards':
            height = $f6824b7afd9ef7c7$var$AURA_CARDS_DEFAULT_HEIGHT;
            break;
        case 'miro-macro-resizing':
            height = $f6824b7afd9ef7c7$var$MIRO_EMBED_DEFAULT_HEIGHT;
            break;
        case 'easy-math-block':
            height = $f6824b7afd9ef7c7$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT;
            break;
        case 'mathblock':
            height = $f6824b7afd9ef7c7$var$MATH_BLOCK_DEFAULT_HEIGHT;
            break;
        case 'page-signatures':
            height = $f6824b7afd9ef7c7$var$PAGE_SIGNATURES_DEFAULT_HEIGHT;
            break;
        case 'questionslist-macro':
            height = $f6824b7afd9ef7c7$var$QUESTIONS_LIST_DEFAULT_HEIGHT;
            break;
        case 'jiraroadmap':
            height = $f6824b7afd9ef7c7$var$JIRA_ROADMAP_DEFAULT_HEIGHT;
            break;
        case 'lucidchart':
            height = $f6824b7afd9ef7c7$var$LUCID_CHART_DEFAULT_HEIGHT;
            break;
        default:
            height = undefined;
            break;
    }
    return {
        viewportHeight: height
    };
};
module.exports["useConnectExtensionViewportSize"] = $f6824b7afd9ef7c7$export$1a33580c6521db41;

});

parcelRegister("3o0Dr", function(module, exports) {

var $42omo = parcelRequire("42omo");



var $eczvQ = parcelRequire("eczvQ");

const $1c95b3b9276df843$var$THROTTLE_MACROS_QUERY_THRESHOLD = 8;
const $1c95b3b9276df843$export$b5cf65c5c3b73c3f = ({ node: node, mode: mode, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
        node: node
    });
};
module.exports["FabricLegacyMacrosServerLoader"] = $1c95b3b9276df843$export$b5cf65c5c3b73c3f;

});

parcelRegister("lqWPF", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $8pcS0 = parcelRequire("8pcS0");


var $92uc5 = parcelRequire("92uc5");

function $8ed303578fdef1ee$export$d2c0db192704879b(node, contentId) {
    'use no memo';
    const bodyContentParam = node.parameters?.macroParams?.__bodyContent;
    const isPlainText = node.type === (0, $8pcS0.REGULAR_EXTENSION_TYPE) && Boolean(bodyContentParam);
    const isRichTextMacro = node.type === (0, $8pcS0.BODIED_EXTENSION_TYPE);
    const contentConverterQueryResult = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useDataMacroBodyContentConverterQuery($content:String!$contentId:ID!$from:String!$to:String!$spaceKeyContext:String=""){contentConverter(from:$from to:$to content:$content contentIdContext:$contentId spaceKeyContext:$spaceKeyContext){value}}`, {
        variables: (0, $92uc5.getContentConverterVariables)({
            content: node.content,
            contentId: contentId
        }),
        fetchPolicy: 'cache-only',
        skip: !isRichTextMacro
    });
    if (isRichTextMacro) return contentConverterQueryResult.data ? {
        value: contentConverterQueryResult.data.contentConverter?.value
    } : {
        missing: true
    };
    if (isPlainText) return {
        value: bodyContentParam?.value || ''
    };
    return {
        value: ''
    };
}
module.exports["useDataMacroBody"] = $8ed303578fdef1ee$export$d2c0db192704879b;

});

parcelRegister("ji0Re", function(module, exports) {

var $ld6xp = parcelRequire("ld6xp");


var $iKSlH = parcelRequire("iKSlH");


var $8mIlz = parcelRequire("8mIlz");


var $eqB7W = parcelRequire("eqB7W");


var $b1ypt = parcelRequire("b1ypt");


var $jMyy4 = parcelRequire("jMyy4");

'use no memo';
const $f467909144d22250$export$9f73be5695bf7530 = (contentId, node)=>{
    const { isMacroContentAndBody: isMacroContentAndBody, ...rest } = (0, $8mIlz.getMacroQueryVariables)({
        node: node,
        contentId: contentId
    });
    const MacroQuery = isMacroContentAndBody ? (0, $eqB7W.default) : (0, $b1ypt.default);
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types -- preserving original behavior
    const { data: data } = (0, $jMyy4.useQueryInterop)(MacroQuery, {
        fetchPolicy: 'cache-only',
        variables: rest
    });
    return data;
};
const $f467909144d22250$export$60af9684eedb3caa = (contentId, node)=>{
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const { renderedMacro: renderedMacro } = (0, $iKSlH.useMultiMacroQuery)({
        contentId: contentId,
        macroId: macroId
    });
    return {
        macroBodyRenderer: renderedMacro,
        representation: renderedMacro?.macroRenderedRepresentation,
        mediaToken: renderedMacro?.mediaToken,
        webResourceDependencies: renderedMacro?.webResource,
        macroBodyStorageFormat: {
            value: renderedMacro?.macroBodyStorage
        }
    };
};
const $f467909144d22250$export$6bb3728261293af5 = (contentId, node)=>{
    return (0, $ld6xp.canUseMultiMacroQuery)(node.extensionKey) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $f467909144d22250$export$60af9684eedb3caa(contentId, node) : // eslint-disable-next-line react-hooks/rules-of-hooks
    $f467909144d22250$export$9f73be5695bf7530(contentId, node);
};
module.exports["useMacroContentData"] = $f467909144d22250$export$6bb3728261293af5;

});

parcelRegister("adbKg", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4995ce58a287dd32$var$iframeSrcRegex = /(<iframe.*)\ssrc=((?:".*?")|(?:'.*?'))(.*>)/gim;
const $4995ce58a287dd32$var$iframeTagRegex = /<iframe/gi;
const $4995ce58a287dd32$export$79f3459501b856f9 = (extensionHTML)=>{
    if (!extensionHTML) return extensionHTML;
    // Account for multiple iframes in the input, to make non-advised Regex-based HTML
    // handling more robust in this particular case.
    return extensionHTML.split($4995ce58a287dd32$var$iframeTagRegex).map((fragment, index)=>{
        return index === 0 ? fragment : `<iframe${fragment}`.replace($4995ce58a287dd32$var$iframeSrcRegex, `$1 data-delayed-src=$2$3`);
    }).join('');
};
const $4995ce58a287dd32$export$1a181571c396c997 = (delayIframe, extensionElement)=>{
    (0, $42omo.useLayoutEffect)(()=>{
        if (extensionElement) {
            if (delayIframe) extensionElement.setAttribute('data-delay-iframe', 'true');
            else extensionElement.removeAttribute('data-delay-iframe');
        }
    }, [
        extensionElement,
        delayIframe
    ]);
    (0, $42omo.useEffect)(()=>{
        const srcAttr = 'src';
        const delayedSrcAttr = 'data-delayed-src';
        if (extensionElement) {
            const iframe = extensionElement.querySelector('iframe');
            if (iframe && !delayIframe) {
                const delayedSrc = iframe.getAttribute(delayedSrcAttr);
                if (delayedSrc) {
                    iframe.setAttribute(srcAttr, delayedSrc);
                    iframe.removeAttribute(delayedSrcAttr);
                }
            }
        }
    }, [
        extensionElement,
        delayIframe
    ]);
};
module.exports["delayIframeLoading"] = $4995ce58a287dd32$export$79f3459501b856f9;
module.exports["useDelayedIframe"] = $4995ce58a287dd32$export$1a181571c396c997;

});

parcelRegister("eczvQ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $9hlns = parcelRequire("9hlns");


var $9wGTI = parcelRequire("9wGTI");


var $bYtfC = parcelRequire("bYtfC");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f3207d6ccf725790$var$InlineSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1qi0 _1yt41b66 _1e0c1o8l _bfhkizff _1ul912am _4t3ildb6",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f3207d6ccf725790$var$ExtensionSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_10ib6lf": (0, $7sObp.default)(__cmplp.height, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_2rko1qi0 _1yt41b66 _1e0c1ule _bfhkizff _1bsb1osq _1ul91wqb _vchhusvi",
                __cmplp.height ? "_4t3it1jn" : "_4t3ildb6",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f3207d6ccf725790$export$ba91725a812e7aea = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { showSpinner: showSpinner, node: node } = t0;
    const { viewportHeight: viewportHeight } = (0, $bYtfC.useConnectExtensionViewportSize)(node);
    let t1;
    if ($[0] !== node || $[1] !== showSpinner || $[2] !== viewportHeight) {
        t1 = node && node.type === "inlineExtension" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f3207d6ccf725790$var$InlineSkeleton, {
            "data-testid": "ext-skeleton"
        }, showSpinner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f3207d6ccf725790$var$ExtensionSkeleton, {
            "data-testid": "ext-skeleton",
            height: (0, $9wGTI.fg)("confluence_connect_macro_preset_height") ? viewportHeight : undefined
        }, showSpinner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[0] = node;
        $[1] = showSpinner;
        $[2] = viewportHeight;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["LegacyMacroRendererShadow"] = $f3207d6ccf725790$export$ba91725a812e7aea;

});


$parcel$global.rlb("krR1D")
//# sourceMappingURL=FullPageEditorComponent.40098376.js.map
